{
    "$10 minimum": "מינימום 10$",
    "$25 minimum": "מינימום 25$",
    "$100000 maximum": "מקסימום 100,000$",
    "'0 Second(s)' means unlimited time": "'0 שנייה(ות)' פירושו זמן בלתי מוגבל",
    "'0 sec' means unlimited time": "'0 שניות' פירושו זמן בלתי מוגבל",
    "(SLA Calls + Abandoned in SLA) / Total Calls": "(שיחות SLA + ננטשו ב-SLA) / סך כל השיחות",
    "+ Create": "+ צור",
    "1 Minute": "1 דקה",
    "1 month": "1 חודש",
    "1 or more participants": "משתתף אחד או יותר",
    "1/1: Charge per second": "1/1: חיוב לפי שנייה",
    "12 Hours": "12 שעות",
    "2 Factor Authentication": "אימות דו-שלבי",
    "2 Factor Authentication has been successfully enabled": "אימות דו-שלבי הופעל בהצלחה",
    "2 Factor Authentication: ": "אימות דו-שלבי:",
    "2 or more participants": "שני משתתפים או יותר",
    "24 / 7 + SLA Commitment": "24/7 + התחייבות SLA",
    "24 Hours": "24 שעות",
    "24 hours": "24 שעות",
    "24/7 support": "תמיכה 24/7",
    "2FA has been successfully set up": "2FA הוגדר בהצלחה",
    "60/1: Minimum 60 seconds, 1 second increment": "60/1: מינימום 60 שניות, תוספת של שנייה",
    "60/60: Minimum 60 seconds, 60 second increment": "60/60: מינימום 60 שניות, פעימה של 60 שניות",
    "A detailed description is required to help us assist you.": "דרוש תיאור מפורט כדי לעזור לנו לסייע לך.",
    "A file was skipped because it": "קובץ אחד דולג מכיוון ש",
    "A list of announcements": "רשימת הודעות",
    "A list of conference rooms": "רשימת חדרי ועידה",
    "A list of contacts associated with your account": "רשימת אנשי קשר המשויכים לחשבונך",
    "A list of default Caller IDs used to make calls": "רשימת מזהי מתקשר ברירת מחדל המשמשים לביצוע שיחות.",
    "A list of team members for this account": "רשימת חברי צוות עבור חשבון זה",
    "A list of users for this account and their assigned roles": "רשימת משתמשים לחשבון זה והתפקידים שהוקצו להם.",
    "A module that allows for the uploading of a list of leads, enabling the system to dial them and connect with an agent": "מודול המאפשר להעלות רשימת לידים, ומאפשר למערכת לחייג אליהם ולחבר לסוכן.",
    "A new user will add $25 to your next invoice. Once activated, a prorated charge will apply for the rest of this [month/year].": "משתמש חדש יוסיף 25$ לחשבונית הבאה שלך. לאחר ההפעלה, יחול חיוב יחסי עבור שארית ה[חודש/שנה].",
    "A reset password email has been successfully sent to": "אימייל לאיפוס סיסמה נשלח בהצלחה אל {email}.",
    "A suggestive tag that can be used to find te IVR in the app": "תגית מציינת שניתן להשתמש בה כדי למצוא את ה-IVR באפליקציה",
    "A suggestive tag that can be used to find the IVR in the app": "תג מרמז שניתן להשתמש בו למציאת IVR באפליקציה",
    "A telephone designed to work with SIP technology for making and receiving calls": "טלפון שעובד בטכנולוגיית SIP לביצוע וקבלת שיחות.",
    "A title is required to describe your issue.": "דרוש כותרת כדי לתאר את הבעיה שלך.",
    "A transcription is being generated for this call.": "תמלול נוצר עבור שיחה זו.",
    "A webphone allows making and receiving phone calls directly from the web browser using a dial panel": "חייגן דפדפן שמאפשר ביצוע וקבלת שיחות ישירות מדפדפן האינטרנט באמצעות לוח חיוג.",
    "A2P 10DLC registration approved for Campaign ID: {id}": "רישום A2P 10DLC אושר עבור קמפיין: {id}",
    "A2P 10DLC registration needed to send SMS messages": "נדרש רישום A2P 10DLC לשליחת הודעות SMS",
    "ACD": "ACD",
    "ACD, Auto Attendant, Skill-based routing": "ACD, נתב אוטומטי, ניתוב מבוסס כישורים",
    "ACD, Auto Attendant, Skills-Based routing": "ACD, נתב אוטומטי, ניתוב מבוסס כישורים",
    "AI Analytics": "ניתוחי בינה מלאכותית",
    "AI analytics": "אבחון AI",
    "AI analytics include automatic call transcripts and keyword research": "אבחון AI כוללות תמלול שיחות אוטומטי ומחקר מילות מפתח.",
    "AM": "לפנה\"צ",
    "API": "API",
    "API Key": "מפתח API",
    "API key generated successfully": "מפתח API נוצר בהצלחה",
    "AWS": "AWS",
    "Abandoned": "ננטש",
    "Abandoned Calls": "שיחות נטושות",
    "Abandoned Calls Configuration": "הגדרות שיחות נטושות",
    "Abandoned Calls Ignored": "שיחות ננטשות לא ישפיעו",
    "Abandoned Calls Ignored: SLA Calls / (Total Calls - Abandoned in SLA)": "מתעלמים משיחות שננטשו: שיחות SLA / (סה\"כ שיחות - ננטשו ב-SLA)",
    "Abandoned Calls Negative Impact": "שיחות ננטשות ישפיעו שלילית",
    "Abandoned Calls Negative Impact:": "השפעה שלילית של שיחות שננטשו:",
    "Abandoned Calls Negative Impact: SLA Calls / Total Calls": "השפעה שלילית של שיחות שננטשו: שיחות SLA / סה\"כ שיחות",
    "Abandoned Calls Positive Impact": "שיחות ננטשות ישפיעו חיובית",
    "Abandoned Calls Positive Impact:": "השפעה חיובית של שיחות שננטשו:",
    "Abandoned Calls Positive Impact: (SLA Calls + Abandoned in SLA) / Total Calls": "השפעה חיובית של שיחות שננטשו: (שיחות SLA + ננטשו ב-SLA) / סה\"כ שיחות",
    "Abort Cancellation": "בטל ביטול",
    "Accept TOC and PP": "על ידי המשך, אתה מקבל את <terms>תנאי השימוש</terms> ו-<privacy>מדיניות הפרטיות</privacy> שלנו.",
    "Access code": "קוד גישה מרחוק",
    "Account": "חשבון",
    "Account Address": "כתובת חשבון",
    "Account Default": "ברירת מחדל לחשבון",
    "Account Security": "אבטחת חשבון",
    "Account Setup": "הגדרת חשבון",
    "Account balance": "מאזן חשבון",
    "Account default": "ברירת מחדל לחשבון",
    "Account has been successfully logged out": "החשבון התנתק בהצלחה",
    "Account security": "אבטחת חשבון",
    "Account security description": "וודא שאתה היחיד שמתחבר לחשבון.\n סרוק את קוד ה-QR למטה באמצעות אפליקציית Google Authenticator.",
    "Account settings updated": "הגדרות החשבון עודכנו",
    "Account settings updated successfully": "הגדרות החשבון עודכנו בהצלחה.",
    "Account setup": "הגדרת חשבון",
    "Account setup description": "אנחנו צריכים עוד כמה פרטים כדי להגדיר את חשבונך.",
    "Account successfully created": "החשבון נוצר בהצלחה",
    "Account under review. Some features are currently disabled until the account verification is complete.": "חשבון בבדיקה. חלק מהתכונות מושבתות כרגע עד להשלמת אימות החשבון.",
    "Account under review. Some features are disabled. Please complete the identity verification process to activate full access.": "חשבון בבדיקה. חלק מהתכונות מושבתות. אנא השלם את תהליך אימות הזהות כדי להפעיל גישה מלאה.",
    "Accounts": "חשבונות",
    "Action": "פעולה",
    "Actions": "פעולות",
    "Activate SIP phone": "הפעל טלפון SIP",
    "Activate Web Dialer": "הפעל חיוג אינטרנט",
    "Activation": "הפעלה",
    "Activation requirements": "דרישות הפעלה",
    "Active": "פעיל",
    "Active chats": "צ'אטים פעילים",
    "Active session detected": "זוהתה פעילות חיבור",
    "Add": "הוסף",
    "Add Account": "הוסף חשבון",
    "Add Agent Status": "הוסף סטטוס סוכן",
    "Add Agent status": "הוסף מצב סוכן",
    "Add Auto Attendant": "הוסף נתב אוטומטי",
    "Add Call": "הוסף שיחה",
    "Add Call Log": "הוסף רישום שיחה",
    "Add Call Queue": "הוסף תור שיחות",
    "Add Contact": "הוסף איש קשר",
    "Add DID Number": "הוסף מספר חי\"פ",
    "Add DID number": "הוסף מספר חי\"פ",
    "Add Delay": "הוסף השהיה",
    "Add Extension": "Add Extension",
    "Add IVR": "הוסף IVR",
    "Add Microsoft Teams": "Add Microsoft Teams",
    "Add Note": "הוסף הערה",
    "Add Number": "הוסף מספר טלפון",
    "Add Permission Group": "הוסף קבוצת הרשאות",
    "Add Phone Number": "הוסף מספרי טלפון",
    "Add Queue": "הוסף תור",
    "Add Role": "הוסף תפקיד",
    "Add User": "הוסף משתמש",
    "Add User Group": "הוסף קבוצת משתמשים",
    "Add Users": "הוסף משתמשים",
    "Add Voicemail": "הוסף תא קולי",
    "Add Wallboard": "הוסף לוח תצוגה",
    "Add Widget": "הוסף וידג'ט",
    "Add announcement": "הוסף הודעה",
    "Add call": "הוסף שיחה",
    "Add card": "הוסף כרטיס",
    "Add conference room": "הוסף חדר ועידה",
    "Add contact": "הוסף איש קשר",
    "Add delay": "הוסף השהיה",
    "Add device": "הוסף מכשיר",
    "Add dial rule": "הוסף חוק חיוג",
    "Add endpoint": "הוסף נקודת קצה",
    "Add extension": "הוסף שלוחה",
    "Add forward": "הוסף העברה",
    "Add funds as you go, based on usage": "הוסף כספים לפי הצורך, בהתבסס על השימוש",
    "Add funds automatically when the balance falls below the threshold": "הוסף כספים אוטומטית כאשר היתרה יורדת מתחת לסף",
    "Add funds by topping up or subscribing": "הוסף יתרה באמצעות טעינה או מנוי",
    "Add inboxes": "הוסף תיבות דואר",
    "Add intercept group": "הוסף קבוצת יירוט",
    "Add media": "הוסף מדיה",
    "Add media file": "הוסף קובץ מדיה",
    "Add more seats to your subscription to bring more team members on board. Each seat allows one additional team member to access all features": "הוסף עוד מושבים למנוי שלך כדי לצרף עוד חברי צוות. כל מושב מאפשר לחבר צוות נוסף אחד לגשת לכל התכונות.",
    "Add new": "הוסף חדש",
    "Add new account": "הוסף חשבון חדש",
    "Add new announcement": "הוסף הודעה חדשה",
    "Add new card": "הוסף כרטיס חדש",
    "Add new conference room": "הוסף חדר ועידה חדש",
    "Add new media file": "הוסף קובץ מדיה חדש",
    "Add new voicemail": "הוסף תא קולי חדש",
    "Add numbers using the form on the left": "הוסף מספרים על ידי הטופס משמאל",
    "Add payment method": "הוסף שיטת תשלום",
    "Add ring group": "הוסף קבוצת צלצול",
    "Add subdomain *": "הוסף תת-דומיין *",
    "Add team": "הוסף צוות",
    "Add time condition": "הוסף שעות פעילות",
    "Add time group": "הוסף קבוצת זמן",
    "Add voicemail": "הוסף תא קולי",
    "Add-on": "תוסף",
    "Additional call limit": "מגבלת שיחות נוספת",
    "Additional calls in time period": "שיחות נוספות בפרק זמן",
    "Additional calls to the same destination": "שיחות נוספות לאותו יעד",
    "Additional information is required to activate the numbers": "נדרש מידע נוסף כדי להפעיל את המספרים",
    "Additional information is required to activate the numbers. Please send the required documentation to our support at ": "נדרש מידע נוסף כדי להפעיל את המספרים. אנא שלח את המסמכים הנדרשים לתמיכה שלנו ב-",
    "Address": "כתובת",
    "Admin": "מנהל מערכת",
    "Admin Email": "דוא\"ל מנהל",
    "Admin Pin": "קוד מנהל",
    "Administrator": "מנהל",
    "Advanced": "מתקדם",
    "After Media": "אחרי מדיה",
    "After level wait time, move to next level": "לאחר זמן ההמתנה של השלב, עבור לשלב הבאה",
    "Agent": "סוכן",
    "Agent Calls": "שיחות נציג",
    "Agent Name": "שם הסוכן",
    "Agent Number": "מספר הסוכן",
    "Agent Pre-Answer": "שמע לסוכן טרום-מענה",
    "Agent Status": "סטטוס סוכן",
    "Agent With Fewest Calls": "הסוכן עם הכי מעט שיחות",
    "Agent With Least Talk Time": "סוכן בר-זמן שיחה הקצר ביותר",
    "Agent ring settings": "הגדרות צלצול סוכן",
    "Agent ring time": "זמן צלצול אצל סוכן",
    "Agents": "סוכנים",
    "Agents In Queues": "נציגים בתורים",
    "Agents Ready": "נציגים זמינים",
    "Agents in call": "סוכנים בשיחה",
    "Alert dialog description": "פעולה זו אינה ניתנת לביטול. פעולה זו תמחק לצמיתות נתונים מהשרתים שלנו.",
    "All": "כל",
    "All Queues": "כל התורים",
    "All countries": "כל המדינות",
    "All groups": "כל הקבוצות",
    "All integrations": "כל האינטגרציות",
    "All selected files are unsupported": "כל הקבצים שנבחרו אינם נתמכים",
    "All selected files are unsupported.": "כל הקבצים שנבחרו אינם נתמכים.",
    "All teams": "כל הצוותים",
    "All the features of our plans": "כל התכונות של התוכניות שלנו",
    "All users": "כל המשתמשים",
    "Allow": "אפשר",
    "Allow Access From IP Whitelist Only": "אפשר רק IPv4, טווח IP או CIDR",
    "Allow Call Waiting": "אפשר שיחה ממתינה",
    "Allow calls waiting": "אפשר שיחות ממתינות",
    "Allow inbound calls": "אפשר שיחות נכנסות",
    "Allow only IPv4, IP Range or CIDR": "אפשר רק IPv4, טווח IP או CIDR",
    "Allow outbound calls": "אפשר שיחות יוצאות",
    "Allowed": "מותר",
    "Allowed Extensions": "שלוחות מותרות",
    "Allowed Pauses": "הפסקות מותרות",
    "Allowed pauses": "הפסקות מותרות",
    "Allowed statuses": "סטטוסים מותרים",
    "Already have a number? Start porting your number after sign-up.": "כבר יש לך מספר? התחל להעביר את המספר שלך לאחר ההרשמה.",
    "Already have an account?": "כבר יש לך חשבון?",
    "Amount": "סכום",
    "Amount billed monthly per user": "הסכום המחויב חודשי לכל משתמש:",
    "An audio played to the caller upon entering the queue": "שמע שמתנגן למתקשר בעת כניסתו לתור",
    "An error occurred while sending the invite": "אירעה שגיאה בעת שליחת ההזמנה",
    "An error occurred while trying to increase the number of seats": "אירעה שגיאה בניסיון להגדיל את מספר המושבים",
    "An extension created for Chrome and Edge allowing you to manage calls from anywhere in the browser": "תוסף שנוצר עבור Chrome ו-Edge המאפשר לנהל שיחות מכל מקום בדפדפן.",
    "An invitation email has been sent to ": "מייל עם הזמנה נשלח לכתובת: {email}.",
    "An invite email has been send to the entered email": "דוא\"ל הזמנה נשלח לכתובת הדוא\"ל שהוזנה",
    "An invite email has been sent to the entered email": "דוא\"ל הזמנה נשלח לכתובת הדוא\"ל שהוזנה",
    "Announcement": "הודעה",
    "Announcement description": "נגן הודעות מוקלטות מראש למתקשרים נכנסים בכל שלב בתהליך ההמתנה.",
    "Announcements": "הודעות",
    "Anonymous": "מספר חסוי",
    "Answered": "נענה",
    "Answered Calls": "שיחות שנענו",
    "Answered Calls (%)": "שיחות שנענו (%)",
    "Answered Calls + Answered %": "שיחות שנענו + אחוז נענות",
    "Answered Calls Ignored:": "מתעלמים משיחות שנענו:",
    "Answered and Unanswered": "נענו ולא נענו",
    "Answers (%)": "תשובות (%)",
    "AppTitle": "PBX.IM",
    "Applicable Disclaimers": "הסתייגויות ישימות",
    "Are there any additional features available with the Auto Attendant service?": "האם ישנם תכונות נוספות זמינות עם שירות האוטומט אדמין (Auto Attendant)?",
    "Are you absolutely sure?": "האם אתה בטוח לחלוטין?",
    "Are you sure you want to cancel?": "האם אתה בטוח שברצונך לבטל?",
    "Are you sure you want to check out and leave all queues?": "האם אתה בטוח שברצונך לצאת מכל התורים?",
    "Are you sure you want to delete account?": "האם אתה בטוח שברצונך למחוק את החשבון?",
    "Are you sure you want to delete this agent status?": "האם אתה בטוח שברצונך למחוק סטטוס סוכן זה?",
    "Are you sure you want to delete this automatic top-up": "האם אתה בטוח שברצונך למחוק תשלום אוטומטי זה",
    "Are you sure you want to delete this call queue?": "האם אתה בטוח שברצונך למחוק את תור השיחות הזה?",
    "Are you sure you want to delete this card": "האם אתה בטוח שברצונך למחוק כרטיס זה",
    "Are you sure you want to delete this contact?": "האם אתה בטוח שברצונך למחוק את איש הקשר הזה?",
    "Are you sure you want to delete this dial rule?": "האם אתה בטוח שברצונך למחוק את כלל החיוג הזה?",
    "Are you sure you want to delete this integration": "האם אתה בטוח שברצונך למחוק אינטגרציה זו?",
    "Are you sure you want to delete this invitation?": "האם אתה בטוח שברצונך למחוק הזמנה זו?",
    "Are you sure you want to delete this media?": "האם אתה בטוח שברצונך למחוק את המדיה הזו?",
    "Are you sure you want to delete this user?": "האם אתה בטוח שברצונך למחוק את המשתמש הזה?",
    "Are you sure you want to log out?": "האם אתה בטוח שברצונך להתנתק?",
    "Are you sure you want to revoke access for this user?": "האם אתה בטוח שברצונך לבטל את הגישה של משתמש זה?",
    "Are you sure you want to top up your account with {amount}": "האם אתה בטוח שברצונך להוסיף תשלום בחשבונך {amount}",
    "Are you sure?": "האם אתה בטוח?",
    "Are your sure?": "האם אתה בטוח?",
    "Area Code": "קִידוֹמֶת",
    "As an extra security measure we need to add your phone number": "כצעד אבטחה נוסף עלינו להוסיף את מספר הטלפון שלך.",
    "Ascending": "סדר עולה",
    "Ask a question": "שאל שאלה",
    "Ask anything": "שאל כל דבר",
    "Assign Chat to Agent": "שייך צ'אט לסוכן",
    "Assign agent status": "הקצה סטטוס לסוכן",
    "Assign to": "שייך אל",
    "Assign to Agent": "שייך לסוכן",
    "Assign to me": "שייך אליי",
    "Assign unique short codes for easy communication": "הקצה קודים קצרים ייחודיים לתקשורת קלה.",
    "Assigned": "הוקצה",
    "Assigned Agents": "סוכנים משוייכים",
    "Assigned Inboxes": "תיבות דואר משויכות",
    "Assigned Phone Numbers": "מספרי טלפון משויכים",
    "Assigned To": "משויך אל",
    "Assigned Users": "משתמשים משויכים",
    "Assigned agents": "סוכנים משויכים",
    "Assigned to": "משויך ל",
    "Assigned to queues": "משויך לתורים",
    "Assigned users": "משתמשים משוייכים",
    "At least 8 characters": "לפחות 8 תווים",
    "Attach File": "צורף קובץ",
    "Attach Message File": "צרף קובץ הודעה",
    "Attach Voicemail Recording": "צרף הקלטת תא קולי",
    "Attach file": "צרף קובץ",
    "Attachments": "קבצים מצורפים",
    "Audio": "שמע",
    "Audio Playback": "ניגון שמע",
    "Audio played after the selected media file": "שמע עוקב לקובץ המדיה שנבחר",
    "Audio played before the selected media file": "שמע מקדים לקובץ המדיה שנבחר",
    "Audio played once at the start of a call": "שמע שמתנגן פעם אחת בתחילת שיחה",
    "Audio played when an invalid key is pressed": "שמע שמתנגן כאשר נלחץ מקש לא חוקי",
    "Audio played when the max number of wrong options or no input max is reached, and the user is directed to the exit destination": "אודיו שמתנגן כאשר מספר האפשרויות הלא נכונות המקסימלי או מקסימום ללא קלט הושג, והמשתמש מופנה ליעד היציאה",
    "Audio that is played multiple times, after the main audio": "אודיו שמתנגן מספר פעמים, אחרי האודיו הראשי",
    "Audio that plays repeatedly after the main message It repeats instructions without the welcome message": "שמע שמתנגן שוב ושוב לאחר ההודעה הראשית. הוא חוזר על ההוראות ללא הודעת הברכה.",
    "Audio that plays when the caller reaches the limit of options or doesn't input anything, then directs to the exit": "שמע שמתנגן כאשר המתקשר מגיע למגבלת האפשרויות או לא מזין דבר, ואז מועבר ליציאה.",
    "Audio that will be played only once, at the beginning of the call": "אודיו שיתנגן פעם אחת בלבד, בתחילת השיחה",
    "Authentication": "אימות",
    "Authentication App": "אפליקציית אימות",
    "Authentication settings": "הגדרות אימות",
    "Auto": "אוטומטי",
    "Auto Answer": "מענה אוטומטי",
    "Auto Attendant": "נתב אוטומטי",
    "Auto Attendant was successfully saved": "הנתב האוטומטי נשמר בהצלחה.",
    "Auto Dialer": "חייגן אוטומטי",
    "Auto Top-up deleted": "תשלום אוטומטי נמחק",
    "Auto Top-up saved": "תשלום אוטומטי נשמר",
    "Auto Top-up successful": "תשלום אוטומטי בוצע בהצלחה",
    "Auto dialer": "חייגן אוטומטי",
    "Auto gain level": "רמת הגבר אוטומטית",
    "Auto record": "הקלטה אוטומטית",
    "Auto top-up": "תשלום אוטומטי",
    "Auto-answer calls for available agents": "מענה אוטומטי לשיחות עבור סוכנים זמינים",
    "Auto-pause on unanswered queue calls": "פסקהה אוטומטית בשיחות תור ללא מענה",
    "Auto-pause or not answered queue calls": "השהיה אוטומטית או שיחות בתור שלא נענו",
    "Auto: An agent joins a queue automatically on check in": "אוטומטי: סוכן מצטרף לתור אוטומטית בעת צ'ק-אין",
    "Automatic logout": "יציאה אוטומטית",
    "Automatically top up balance to {upTo} when it falls below {below}": "הוסף כספים ליתרה באופן אוטומטי ל{upTo} כאשר היא יורדת מתחת ל{below}",
    "Automatically top up balance with <b>{upTo}</b> when it falls below <b>{below}</b>": "תשלום אוטומטי ליתרה ב-<b>{upTo}</b> כאשר היא יורדת מתחת ל-<b>{below}</b>",
    "Automatically top up balance with {upTo} when it falls below {below}": "הוסף כספים ליתרה באופן אוטומטי עם {upTo} כאשר היא יורדת מתחת ל{below}",
    "Available": "זמין",
    "Available Extensions": "שלוחות זמינות",
    "Available User Seats": "מקומות משתמש זמינים",
    "Available agents": "סוכנים זמינים",
    "Available queues": "תורים זמינים",
    "Available users": "משתמשים זמינים",
    "Average": "ממוצע",
    "Average Call Duration": "משך שיחה ממוצע",
    "Average Calls Duration": "משך שיחות ממוצע",
    "Average Wait Time": "זמן המתנה ממוצע",
    "Average call length": "אורך שיחה ממוצע",
    "Average caller wait time": "זמן המתנה ממוצע של מתקשרים",
    "Avg Hold": "המתנה ממוצעת",
    "Avg Talk": "שיחה ממוצעת",
    "Avg Wait": "המתנה ממוצעת",
    "Avg call duration": "משך שיחה ממוצע",
    "Avg talk time": "זמן דיבור ממוצע",
    "Avg wait time": "זמן המתנה ממוצע",
    "BLF Extension": "שלוחת BLF",
    "Back": "חזור",
    "Back To Dashboard": "חזרה ללוח המחוונים",
    "Back to chat": "חזור לצ’אט",
    "Back to login": "חזרה להתחברות",
    "Balance": "יתרה",
    "Balance / Credit Limit": "יתרה \\ מסגרת אשראי",
    "Balance Below Threshold": "יתרה מתחת לסף",
    "Balance is too low": "המאזן נמוך מדי",
    "Barged In": "פרץ לשיחה",
    "Barged in": "פרץ לשיחה",
    "Base Role": "תפקיד בסיסי",
    "Basic Info": "מידע בסיסי",
    "Basic Phone Features": "תכונות טלפון בסיסיות",
    "Basic phone features": "תכונות טלפון בסיסיות",
    "Before Media": "לפני מדיה",
    "Begins with": "מתחיל ב",
    "Billable": "בר-חיוב",
    "Billing": "חיוב",
    "Billing Address": "כתובת לחיוב",
    "Billing Email": "דוא\"ל חיוב",
    "Billing Incr": "תוספת חיוב",
    "Billing Increments": "מקטעי חיוב",
    "Billing Info": "פרטי חיוב",
    "Billing Information": "פרטי חיוב",
    "Billing Notification": "הודעת חיוב",
    "Billing Period": "תקופת חיוב",
    "Billing address": "כתובת לחיוב",
    "Billing city name": "שם עיר החיוב",
    "Billing country name": "שם מדינת החיוב",
    "Billing email updated successfully": "אימייל חיוב עודכן בהצלחה",
    "Billing info": "פרטי חיוב",
    "Billing period": "תקופת חיוב:",
    "Billing state name": "שם מדינת החיוב",
    "Block Calls To Countries": "חסום שיחות למדינות",
    "Blocked countries": "מדינות חסומות",
    "Bottom Left": "שמאל למטה",
    "Bottom Right": "ימין למטה",
    "Branding": "מיתוג",
    "Break": "הפסקה",
    "Break Allocation": "הקצאת הפסקה",
    "Breaks": "הפסקות",
    "Browse": "עיון",
    "Browse Call Rates": "דפדף בתעריפי שיחה",
    "Browse file": "עיין בקובץ",
    "Browser Extension": "Browser Extension",
    "Browser session": "הפעלת דפדפן",
    "Business": "עסק",
    "Busy": "תפוס",
    "Busy delay": "השהיית תפוס",
    "Buy DID": "רכוש חי\"פ",
    "Buy Now": "קנה עכשיו",
    "By canceling you will lose access to the advanced features": "בביטול תוכנית תאבד גישה לתכונות מתקדמות",
    "By canceling your plan you will lose access to these features:": "בביטול התוכנית שלך תאבד גישה לתכונות אלה:",
    "By downgrading you plan you will lose access to these features": "על ידי שנמוך התוכנית שלך תאבד גישה לתכונות אלה:",
    "C2C through the browser is disabled": "C2C דרך הדפדפן מושבת.",
    "CDR": "יומן רישום שיחות",
    "CIDR": "CIDR",
    "CRM Integration": "הטמעת CRM",
    "CRM integration": "הטמעה עם CRM",
    "CRM integrations": "הטמעות CRM",
    "Call": "שיחה",
    "Call & Chat": "שיחה ושיח",
    "Call & Chat — coming soon": "Call & Chat — coming soon",
    "Call Center Agent": "נציג מוקד שירות",
    "Call Center Manager": "מנהל מוקד שירות",
    "Call Failed": "השיחה נכשלה",
    "Call Forwarding": "העברת שיחות",
    "Call Handling": "ניהול שיחות",
    "Call History": "היסטוריית שיחות",
    "Call Logs": "יומני שיחות",
    "Call Queues": "תורי שיחות",
    "Call Recording": "הקלטת שיחות",
    "Call Recording Access": "גישה להקלטות שיחות",
    "Call Routing": "ניתוב שיחות",
    "Call Stats": "סטטיסטיקת שיחות",
    "Call Timeout": "פסק זמן לשיחה",
    "Call Types": "סוגי שיחות",
    "Call Volume": "נפח שיחות",
    "Call Waiting Tone": "צליל המתנה לשיחה",
    "Call center": "מוקד טלפוני",
    "Call center API": "API של מוקד טלפוני",
    "Call distribution": "הפצת שיחות",
    "Call for as low as": "התקשר במחיר נמוך של",
    "Call forwarding": "העברת שיחות",
    "Call forwarding description": "הפנה שיחות למספר או שירות אחר.",
    "Call handling": "ניהול שיחות",
    "Call limit": "מגבלת שיחות",
    "Call limits": "מגבלות שיחה",
    "Call logs": "יומני שיחות",
    "Call number or contact": "התקשר למספר או איש קשר",
    "Call queue": "תור שיחות",
    "Call queues": "תורי שיחות",
    "Call rates": "תעריפי שיחות",
    "Call recording": "הקלטת שיחות",
    "Call recordings are stored by default for the amount of time corresponding to a plan": "הקלטות שיחות נשמרות כברירת מחדל למשך הזמן התואם לתוכנית.",
    "Call recordings storage": "אחסון הקלטות שיחות",
    "Call routing": "ניתוב שיחות",
    "Call timeout": "פסק זמן לשיחה",
    "Call type": "סוג שיחה",
    "Call types": "סוגי שיחות",
    "Call waiting": "המתנה בשיחה",
    "Call waiting in queue": "שיחה ממתינה בתור",
    "Call waiting settings": "הגדרות המתנה לשיחה",
    "Call {Company Name}": "התקשר ל-{Company Name}",
    "Caller": "מתקשר",
    "Caller ID": "מזהה מתקשר",
    "Caller ID Configuration": "הגדרת זיהוי מתקשר",
    "Caller ID Name": "שם מזהה מתקשר",
    "Caller ID Number": "מספר מזהה",
    "Caller ID by Destination Country": "זיהוי מתקשר לפי ארץ היעד",
    "Caller ID by country": "מזהה מתקשר לפי מדינה",
    "Caller ID is required": "נדרש מזהה",
    "Caller IDs": "מזהי מתקשר",
    "Caller IDs set by country take priority over the default caller ID listed above": "מזהי מתקשר שנקבעו לפי מדינה מקבלים עדיפות על פני מזהי המתקשר ברירת המחדל המפורטים למעלה.",
    "Caller Information": "מידע על המתקשר",
    "Caller Pre-Join": "שמע למתקשר טרום-הצטרפות",
    "CallerID Num": "מספר מזהה",
    "Calling From": "Calling From",
    "Calls": "שיחות",
    "Calls Caller ID": "מזהה מתקשר לשיחות",
    "Calls Duration": "משך שיחות",
    "Calls Recordings Access Restriction by Countries and/or IP Ranges": "הגבלת גישה להקלטות של שיחות לפי מדינות ו/או טווחי IP",
    "Calls Report": "דו\"ח שיחות",
    "Calls in Queues": "שיחות בתורים",
    "Campaign": "קמפיין",
    "Campaign ID: {id}, use case: {message}": "מזהה קמפיין: {id}, מקרה שימוש: {message}",
    "Campaigns": "קמפיינים",
    "Can I apply dial rules only to certain users or groups, instead of everyone?": "האם אני יכול להחיל חוקי חיוג רק על משתמשים או קבוצות מסוימות, במקום על כולם?",
    "Can I automatically record my conference calls?": "האם אני יכול להקליט אוטומטית את שיחות הכנס שלי?",
    "Can I create dial rules specific to different countries or regions?": "האם אני יכול ליצור חוקי חיוג ספציפיים למדינות או אזורים שונים?",
    "Can I customize how my caller ID shows up when forwarding calls?": "האם אני יכול להתאים אישית איך מזהה המתקשר שלי יופיע כאשר אני מפנה שיחות?",
    "Can I export the list of endpoints? What formats are available?": "האם אני יכול לייצא את רשימת מכשירי הקצה? אילו פורמטים זמינים לכך?",
    "Can I limit the number of simultaneous calls for my team?": "האם אני יכול להגביל את מספר השיחות במקביל עבור הצוות שלי?",
    "Can I set a time limit for how long the phone rings before going to voicemail?": "האם אני יכול להגדיר מגבלת זמן לכמה זמן הטלפון מצלצל לפני שעובר לדואר הקולי?",
    "Can I turn an extension on or off?  What does that mean?": "האם אני יכול להפעיל או לכבות שלוחה? מה זה אומר?",
    "Can I use extensions to set up separate phone lines for different departments?": "האם אני יכול להשתמש בשלוחות כדי להקים קווי טלפון נפרדים עבור מחלקות שונות?",
    "Can a deactivated user be reactivated?": "האם ניתן להפעיל מחדש משתמש שהושבת?",
    "Can agents set up their on status?": "האם נציגים יכולים יכולים ליצור סטטוס משלהם?",
    "Can agents set up their own status?": "האם נציגים יכולים להגדיר את הסטטוס שלהם באופן עצמאי?",
    "Can announcements help reduce the wait time?": "האם הודעות יכולות לעזור להפחית את זמן ההמתנה?",
    "Can manage most aspects of the account": "יכול לנהל את רוב היבטים של החשבון.",
    "Can one person be part of multiple teams?": "האם אדם אחד יכול להיות חלק מכמה קבוצות?",
    "Can only be removed by a manager": "ניתן להסרה רק על ידי מנהל",
    "Cancel": "ביטול",
    "Cancel DID Number": "בטל מספר חי\"פ",
    "Cancel Number": "בטל מספר",
    "Cancel Phone Number": "ביטול מספר טלפון",
    "Cancel Plan": "בטל תוכנית",
    "Cancellation Pending": "ביטול בהמתנה",
    "Cannot exceed Messages Per Day": "Cannot exceed Messages Per Day",
    "Cannot log out during user creation": "לא ניתן להתנתק במהלך יצירת משתמש",
    "Card added successfully": "הכרטיס נוסף בהצלחה",
    "Card deleted successfully": "הכרטיס נמחק בהצלחה",
    "Card number": "מספר כרטיס",
    "Cart": "עגלת מוצרים",
    "Categories": "Categories",
    "Categories — coming soon": "Categories — coming soon",
    "Change Own Password": "שנה סיסמה אישית",
    "Change Password": "שנה סיסמה",
    "Change password": "שנה סיסמה",
    "Change phone": "שינוי טלפון",
    "Change plan": "שנה תוכנית",
    "Change your password": "שנה את הסיסמה שלך",
    "Channel limits": "מגבלות ערוצים",
    "Channels assigned to a DID number": "ערוצים המשויכים למספר חי\"פ.",
    "Channels assigned to a phone number in your account.": "ערוצים שהוקצו למספר טלפון בחשבון שלך.",
    "Chat": "שיח",
    "Chat Script": "תסריט צ'אט",
    "Chat ended by": "הצ'אט הסתיים על ידי",
    "Chat history": "היסטוריית צ’אט",
    "Chat returned to queue (Agent offline)": "הצ'אט הוחזר לתור (הסוכן לא מחובר)",
    "Chat returned to queue by \"{by}\"": "הצ'אט הוחזר לתור על ידי \"{by}\"",
    "Chat room name": "שם חדר הצ'אט",
    "Chat routed by \"{by}\"": "הצ'אט נותב על ידי \"{by}\"",
    "Chat with SIP IO Support": "שוחח עם תמיכת SIP.IO",
    "Chats": "צ'אטים",
    "Check In": "התחבר",
    "Check Out": "התנתק",
    "Check-out": "צא החוצה",
    "CheckOut": "התנתק",
    "Checking…": "בודק…",
    "Checkout": "תשלום",
    "Chief Customer Officer": "ראש ניהול לקוחות ראשי",
    "Choose Country": "בחר מדינה",
    "Choose Date Format": "בחר פורמט תאריך",
    "Choose Destination": "בחר יעד",
    "Choose Greeting": "בחר ברכה",
    "Choose Integration Type": "בחר סוג אינטגרציה",
    "Choose Time Format": "בחר פורמט זמן",
    "Choose a dial rule": "בחר כלל חיוג",
    "Choose a plan that's right for you": "בחר את התוכנית שמתאימה לך",
    "Choose a prefix": "בחר תחילית",
    "Choose a user": "בחר משתמש",
    "Choose a value": "בחר ערך",
    "Choose an audio playback": "בחר קובץ להשמעה",
    "Choose another method": "בחר שיטה אחרת",
    "Choose approved campaign": "תבחר קמפיין מאושר",
    "Choose audio": "בחר שמע",
    "Choose campaign": "בחר קמפיין",
    "Choose country preset": "בחר קביעת מדינה מראש",
    "Choose digit": "בחר ספרה",
    "Choose distribution": "בחר הפצה",
    "Choose labels": "בחר תוויות",
    "Choose media file": "בחר קובץ מדיה",
    "Choose music": "בחר מוזיקה",
    "Choose one extension that you want to monitor from the dropdown menu": "בחר שלוחה אחת שברצונך לפקח עליה מתוך התפריט הנפתח.",
    "Choose outcome": "בחר תוצאה",
    "Choose payment method": "בחר אמצעי תשלום",
    "Choose placeholder": "בחר {what}",
    "Choose role": "בחר תפקיד",
    "Choose site": "בחר אתר",
    "Choose strategy": "בחר אסטרטגיה",
    "Choose teams": "בחר צוותים",
    "Choose tone": "בחר צליל",
    "Choose type": "בחר סוג",
    "Choose user": "בחר משתמש",
    "Choose value": "בחר ערך",
    "Choose voice": "בחר קול",
    "Chose an user": "בחר משתמש",
    "Chrome/Edge Extension": "תוסף Chrome/Edge",
    "Chrome/edge extension": "תוסף Chrome/Edge",
    "City": "עיר",
    "City *": "עיר *",
    "Clear Filters": "נקה מסננים",
    "Clear Search": "נקה חיפוש",
    "Clear filters": "נקה מסננים",
    "Click 2 Call": "קליק 2 קול (לחץ לשיחה)",
    "Click 2 Call Integration": "אינטגרציית קליק 2 קול (לחץ לשיחה)",
    "Close": "סגור",
    "Closed": "סגור",
    "Closed Conversations": "שיחות סגורות",
    "Cloud Phone System": "מערכת טלפון בענן",
    "Code": "קוד",
    "Collapse sidebar": "כווץ סרגל צד",
    "Color": "צבע",
    "Comfort noise": "רעש נוחות",
    "Coming soon": "בקרוב...",
    "Command sent successfully": "הפקודה נשלחה בהצלחה",
    "Commerce": "מסחר",
    "Company": "חברה",
    "Company Details": "פרטי החברה",
    "Company Logo": "לוגו החברה",
    "Company Name": "שם החברה",
    "Company Name *": "שם החברה *",
    "Company Phone *": "טלפון חברה *",
    "Company Role": "תפקיד בחברה",
    "Company Role *": "תפקיד בחברה *",
    "Company URL": "כתובת URL של החברה",
    "Company address": "כתובת החברה",
    "Company details": "פרטי העסק",
    "Company details description": "מידע רלוונטי על החברה שלך.",
    "Company details have been updated succesfully": "פרטי החברה עודכנו בהצלחה!",
    "Company details updated": "פרטי החברה עודכנו",
    "Company name": "שם העסק",
    "Company name *": "שם החברה *",
    "Company registration No": "מספר רישום חברה",
    "Company registration No *": "מספר רישום חברה *",
    "Company role": "תפקיד בחברה",
    "Complete": "הושלם",
    "Compliance": "תיאום",
    "Conditional Actions": "פעולות מותנות",
    "Conditions": "תנאים",
    "Conference": "ועידה",
    "Conference Rooms": "חדרי ועידה",
    "Conference rooms": "חדרי ועידה",
    "Conference rooms description": "נהל את כל חדרי הוועידות שלך.",
    "Configuration": "הגדרות",
    "Configure business hours and peak times for call routing": "הגדר שעות עבודה ושעות שיא לניתוב שיחות.",
    "Configure call menus": "הגדר תפריטי שיחות",
    "Configure wallboards": "הגדר לוחות תצוגה",
    "Configuring the 2FA for your account is required": "הגדרת אימות דו-שלבי עבור החשבון שלך נדרשת",
    "Confirm": "אשר",
    "Confirm Purchase": "אשר רכישה",
    "Confirm Seats": "אשר מושבים",
    "Confirm code": "אשר קוד",
    "Confirm new password": "אשר סיסמה חדשה",
    "Confirm password": "אשר סיסמה",
    "Confirm top-up": "אשר תשלום",
    "Connect": "התחבר",
    "Contact": "איש קשר",
    "Contact Created": "איש קשר נוצר",
    "Contact Details": "פרטי איש קשר",
    "Contact History": "היסטוריית איש קשר",
    "Contact Info": "פרטי יצירת קשר",
    "Contact Person": "איש קשר",
    "Contact Updated": "איש קשר עודכן",
    "Contacts": "אנשי קשר",
    "Contains": "מכיל",
    "Content": "תוכן",
    "Continue": "המשך",
    "Continue with Google": "המשך עם גוגל",
    "Continue with Microsoft": "המשך עם מיקרוסופט",
    "This organization requires single sign-on.": "ארגון זה מחייב כניסה מאוחדת (SSO).",
    "Login is temporarily unavailable. Please try again in a few minutes.": "ההתחברות אינה זמינה כרגע. נסה שוב בעוד כמה דקות.",
    "This account signs in with an email and password. Please use those instead.": "חשבון זה מתחבר עם אימייל וסיסמה. יש להשתמש בהם במקום.",
    "Single sign-on is not available for this organization.": "כניסה מאוחדת (SSO) אינה זמינה עבור ארגון זה.",
    "Sign-in was cancelled. Please try again.": "ההתחברות בוטלה. נסו שוב.",
    "This account belongs to a different organization.": "חשבון זה שייך לארגון אחר.",
    "This account is disabled. Please contact your administrator.": "חשבון זה מושבת. אנא פנו למנהל המערכת.",
    "Your account does not have access. Please contact your administrator.": "לחשבון שלך אין גישה. אנא פנו למנהל המערכת.",
    "Your account is not set up for single sign-on. Please contact your administrator.": "החשבון שלך אינו מוגדר לכניסה מאוחדת (SSO). אנא פנו למנהל המערכת.",
    "Your organization has no seats available. Please contact your administrator.": "לארגון שלך אין מושבים פנויים. אנא פנו למנהל המערכת.",
    "We couldn't find an account for that email. Please check which account you used.": "לא מצאנו חשבון עבור כתובת האימייל הזו. בדקו באיזה חשבון השתמשתם.",
    "Your organization isn't set up for sign-in yet. Please contact your administrator.": "הארגון שלך עדיין לא מוגדר להתחברות. אנא פנו למנהל המערכת.",
    "We couldn't sign you in. Please try again.": "לא הצלחנו לחבר אותך. נסו שוב.",
    "Contrast too low.": "הניגודיות נמוכה מדי.",
    "Copied": "Copied",
    "Copy": "העתק",
    "Copy Link": "העתק קישור",
    "Copy script": "Copy script",
    "Core": "ליבה",
    "Cost": "עלות",
    "Could not create account": "לא ניתן ליצור חשבון",
    "Could not delete the table row": "לא ניתן למחוק את השורה בטבלה",
    "Could not invite user ": "לא ניתן להזמין משתמש",
    "Could not resend invitation": "לא ניתן לשלוח את ההזמנה מחדש",
    "Could not save company details": "לא ניתן לשמור את פרטי החברה",
    "Could not set up billing information": "לא ניתן להגדיר את פרטי החיוב",
    "Could not setup 2FA": "לא ניתן להגדיר אימות דו-שלבי",
    "Could not start ID verification": "לא ניתן להתחיל את אימות הזהות",
    "Could not update billing email": "לא ניתן היה לעדכן את דוא\"ל החיוב",
    "Could not update dial rule settings": "לא ניתן היה לעדכן את הגדרות כלל החיוג",
    "Could not update general settings": "לא ניתן לעדכן הגדרות כלליות",
    "Could not update media settings": "לא ניתן היה לעדכן את הגדרות המדיה.",
    "Could not update the company details": "לא ניתן לעדכן את פרטי החברה",
    "Could not update the default call rate": "לא ניתן לעדכן את תעריף השיחה ברירת המחדל.",
    "Could not update the profile": "לא ניתן לעדכן את הפרופיל",
    "Could not validate the invitation": "לא ניתן לאמת את ההזמנה",
    "Could not verify the user": "לא ניתן לאמת את המשתמש",
    "Countries": "מדינות",
    "Country": "ארץ",
    "Country *": "ארץ *",
    "Country preset": "קביעת ארץ מראש",
    "Create": "צור",
    "Create Report": "צור דוח",
    "Create and manage all your media files": "צור ונהל את כל קבצי המדיה שלך.",
    "Create password": "צור סיסמה",
    "Create password *": "צור סיסמה *",
    "Create ticket": "צור כרטיס תמיכה",
    "Create transcription": "צור תמלול",
    "Create your account": "צור את חשבונך",
    "Creating Transcription": "יוצר תמלול",
    "Credit card": "כרטיס אשראי",
    "Current Seats": "מושבים נוכחיים",
    "Current Status": "סטטוס נוכחי",
    "Current Users": "משתמשים נוכחיים",
    "Current password": "סיסמה נוכחית",
    "Custom": "מותאם אישית",
    "Custom Amount": "Custom Amount",
    "Custom Rate": "תעריף מותאם אישית",
    "Customer Number": "מספר הלקוח",
    "Customer Service Manager": "מנהל שירות לקוחות",
    "Customize": "התאם אישית",
    "DEFAULT CARD": "כרטיס ברירת מחדל",
    "DID": "חי\"פ",
    "DID Channels": "{count} ערוצי חי\"פ",
    "DID Number": "מספר חי\"פ",
    "DID Numbers": "מספרי חי\"פ",
    "DID Numbers description": "מספרי חי\"פ הם מספרי טלפון וירטואליים המנתבים שיחות ישירות.",
    "DID numbers": "מספרי חי\"פ",
    "Dark": "כהה",
    "Dashboard": "לוח בקרה",
    "Dashboard description": "לוח בקרה בדרך...",
    "Dashboard title": "ברוך הבא {name}!",
    "Date": "תאריך",
    "Date / Time": "תאריך / זמן",
    "Date Format": "פורמט תאריך",
    "Date from": "תאריך מ",
    "Date issued": "תאריך הנפקה",
    "Date to": "תאריך עד",
    "Days": "ימים",
    "Days of the week": "ימי השבוע",
    "Deactivated": "מושבת",
    "Decimals not allowed": "לא ניתן להשתמש במספרים עשרוניים",
    "Dedicated Account Manager / Email / Chat / Phone": "מנהל חשבון ייעודי / דוא”ל / צ’אט / טלפון",
    "Default": "ברירת מחדל",
    "Default Call Rates": "תעריפי שיחה ברירת מחדל",
    "Default Call Routing Destination": "יעד ניתוב שיחות ברירת מחדל",
    "Default CallerID": "זיהוי מתקשר ברירת מחדל",
    "Default DID Destination": "יעד ברירת מחדל של חי\"פ",
    "Default Routing Destination": "יעד לניתוב שיחות",
    "Default account dial rule": "כלל חיוג ברירת מחדל לחשבון",
    "Default call rate updated successfully": "שיעור השיחה ברירת מחדל עודכן בהצלחה",
    "A rate plan change is still being applied. Try again in a few minutes.": "שינוי במסלול התעריפים עדיין מתבצע. נסו שוב בעוד כמה דקות.",
    "This rate plan cannot be applied to this account. Contact support.": "לא ניתן להחיל מסלול תעריפים זה על החשבון. פנו לתמיכה.",
    "Currency": "מטבע",
    "Call rates are not available right now.": "תעריפי השיחות אינם זמינים כרגע.",
    "Connection fee": "דמי חיבור",
    "This account has custom pricing. Contact support to change it.": "לחשבון זה יש תמחור מותאם אישית. כדי לשנות אותו, פנו לתמיכה.",
    "Default caller IDs": "מזהי מתקשר ברירת מחדל",
    "Default color: White": "Default color: White",
    "Default destination": "יעד ברירת מחדל",
    "Default destination type": "סוג יעד ברירת מחדל",
    "Default exit destination": "יעד יציאה ברירת מחדל",
    "Default music": "מוזיקה ברירת מחדל",
    "Defaults": "ברירות מחדל",
    "Define how outbound calls are processed and formatted": "הגדר כיצד מעובדות ומעוצבות שיחות יוצאות.",
    "Degraded": "ביצועים מופחתים",
    "Delay": "השהיה",
    "Delay time added after the caller inputs their selection": "זמן השהיה שנוסף לאחר שהמתקשר מזין את בחירתו.",
    "Delete": "מחק",
    "Delete Agent Status": "מחק סטטוס סוכן",
    "Delete Invitation": "מחק הזמנה",
    "Delete User": "מחק משתמש",
    "Delete account": "מחק חשבון",
    "Delete agent status": "מחק מצב סוכן",
    "Delete automatic top-up": "מחק תשלום אוטומטי",
    "Delete call queue": "מחק תור שיחות",
    "Delete card": "מחק כרטיס",
    "Delete contact": "מחק איש קשר",
    "Delete dial rule": "מחק חוק חיוג",
    "Delete integration": "Delete integration",
    "Delete media": "מחק מדיה",
    "Delete row description": "האם אתה בטוח שברצונך למחוק שורה זו? פעולה זו בלתי הפיכה.",
    "Deleted message": "הודעה שנמחקה",
    "Delivered": "נמסר",
    "Deny": "מנע",
    "Descending": "סדר יורד",
    "Description": "תיאור",
    "Description is required": "נדרש תיאור",
    "Destination": "יעד",
    "Destination - condition Matched": "יעד - תנאי תואם",
    "Destination - condition NOT Matched": "יעד - תנאי לא תואם",
    "Destination Country": "ארץ יעד",
    "Destination Name": "שם היעד",
    "Destination name": "שם היעד",
    "Destination type": "סוג יעד",
    "Details": "פרטים",
    "Detect Timeout": "זיהוי פסק זמן",
    "Device": "מכשיר",
    "Device / Flow": "מכשיר / זרימה",
    "Device not Available": "המכשיר אינו זמין",
    "Device parameters": "פרמטרים של מכשיר",
    "Devices": "מכשירים",
    "Dial Rule": "חוק חיוג",
    "A dial rule with this name already exists": "כלל חיוג בשם זה כבר קיים",
    "Dial rule created": "כלל החיוג נוצר",
    "Dial rule updated": "כלל החיוג עודכן",
    "Dial Rules": "חוקי חיוג",
    "Dial Status": "סטטוס חיוג",
    "Dial rule": "כלל חיוג",
    "Dial rules": "חוקי חיוג",
    "Dial rules (override)": "חוקי חיוג (עקיפה)",
    "Dialer": "חייגן",
    "Dialpad": "לוח חיוג",
    "Did you scan the QR code?": "האם סרקת את קוד ה-QR?",
    "Digit": "ספרה",
    "Digit length": "אורך ספרות",
    "Digits": "ספרות",
    "Direct Fax": "פקס ישיר",
    "Direct Inward dialing Channels": "ערוצי חיוג ישיר פנימה",
    "Direct extensions": "שלוחות ישירות",
    "Direct incoming calls to multiple phone numbers or extensions simultaneous or in sequence": "הפנה שיחות נכנסות למספרי טלפון או שלוחות מרובות בו-זמנית או בסדר מסוים.",
    "Disable 2FA": "השבת אימות דו-שלבי",
    "Disable Mute": "השבת השתקה",
    "Disable Mute Button in WD": "השבת את כפתור ההשתקה ב-WD",
    "Disabled": "מושבת",
    "Disabled for all users": "מושבת לכל המשתמשים",
    "Disallow changing Pause": "מנע שינוי הפסקה",
    "Discard": "בטל",
    "Discard unsaved changes?": "לבטל שינויים שלא נשמרו?",
    "Disconnected": "מנותק",
    "Do Not Disturb": "נא לא להפריע",
    "Do you want to add <b>{price}</b> now": "האם ברצונך להוסיף <b>{price}</b> עכשיו?",
    "Do you want to close the previous session and continue here": "האם ברצונך לסגור את ההחיבור הקודם ולהמשיך כאן?",
    "Do you want to proceed": "האם ברצונך להמשיך",
    "Do you want to proceed?": "האם ברצונך להמשיך?",
    "Do you want to proceeed?": "האם ברצונך להמשיך?",
    "Do you want to stay logged in?": "האם ברצונך להישאר מחובר?",
    "Docs": "מסמכים",
    "Document": "מסמך",
    "Documentation": "מדריך",
    "Does not match your password": "אינו תואם את הסיסמה שלך.",
    "Domain": "דומיין",
    "Don't have access to the web phone": "אין לך גישה לחייגן דפדפן",
    "Don't mask": "אל תסתיר",
    "Don't record": "אל תקליט",
    "Done": "סיום",
    "Download": "הורד",
    "Download All Countries' Rates (CSV)": "הורד את תעריפי כל המדינות (CSV)",
    "Downloading media...": "מוריד מדיה...",
    "Draft": "טיוטה",
    "Drag & drop here": "גרור ושחרר כאן",
    "Drop files here": "גרור קבצים לכאן",
    "Dropped before being answered": "נותקו לפני שנענו",
    "Due Later": "תשלום עתידי",
    "Due Now": "לתשלום עכשיו",
    "Duration": "משך",
    "Dynamic": "לפי משתנה",
    "Each seat grants access to the PBX system, and any unassigned seats are available for new users": "כל מושב מעניק גישה למערכת ה-PBX, וכל המושבים שאינם מוקצים זמינים למשתמשים חדשים",
    "Echo Cancelation": "ביטול הד",
    "Ecommerce": "מסחר אלקטרוני",
    "Edit": "ערוך",
    "Edit Account": "ערוך חשבון",
    "Edit Agent Status": "ערוך סטטוס סוכן",
    "Edit Call Queue": "ערוך תור שיחות",
    "Edit Contact": "ערוך איש קשר",
    "Edit DID number": "ערוך מספר חי\"פ",
    "Edit IVR": "ערוך IVR",
    "Edit Node": "ערוך קשר",
    "Edit Permission Group": "ערוך קבוצת הרשאות",
    "Edit Phone Number": "ערוך מספר טלפון",
    "Edit Role": "ערוך תפקיד",
    "Edit User": "ערוך משתמש",
    "Edit User Details": "ערוך פרטי משתמש",
    "Edit Widget": "ערוך וידג'ט",
    "Edit announcement": "ערוך הודעה",
    "Edit chat": "ערוך צ'אט",
    "Edit conference room": "ערוך חדר ועידה",
    "Edit device": "ערוך מכשיר",
    "Edit dial rule": "ערוך חוק חיוג",
    "Edit endpoint": "ערוך נקודת קצה",
    "Edit extension": "ערוך שלוחה",
    "Edit forward": "ערוך העברה",
    "Edit intercept group": "ערוך קבוצת יירוט",
    "Edit media file": "ערוך קובץ מדיה",
    "Edit queue": "ערוך תור",
    "Edit ring group": "ערוך קבוצת צלצול",
    "Edit team": "ערוך צוות",
    "Edit time condition": "ערוך שעות פעילות",
    "Edit time group": "ערוך קבוצת זמן",
    "Edit voicemail": "ערוך תא קולי",
    "Education": "חינוך",
    "Email": "דוא\"ל",
    "Email & Chat Support": "תמיכה בדוא\"ל וצ'אט",
    "Email *": "דוא\"ל *",
    "Email / Chat": "דוא\"ל \\ צ'אט",
    "Email / Chat / Phone": "דוא\"ל \\ צ'אט \\ טלפון",
    "Email Code": "קוד דוא\"ל",
    "Email Code *": "קוד דוא\"ל *",
    "Email Subject": "נושא דוא\"ל",
    "Email Tfa Item Description": "קבל קוד על ידי לחיצה על 'שלח את הקוד בדוא\"ל' כדי לקבל קוד.",
    "Email address": "כתובת דוא\"ל",
    "Email notification": "שלח את ההודעה בדוא\"ל",
    "Email sent successfully": "הדוא\"ל נשלח בהצלחה",
    "Email verification Link Sent": "קישור אימות דואר אלקטרוני נשלח",
    "Emails": "דוא\"לים",
    "Embed script": "Embed script",
    "Enable": "הפעל",
    "Enable 2 Factor Authentication": "הפעל אימות דו-שלבי",
    "Enable Auto-Top Up to automatically recharge your account balance": "הפעל תשלום אוטומטי בכדילמלא את יתרת החשבון שלך אוטומטית",
    "Enable Call Recording": "הפעל הקלטת שיחות",
    "Enable Caller ID by Destination Country": "אפשר זיהוי מתקשר לפי ארץ יעד",
    "Enable Calling": "Enable Calling",
    "Enable Call or Chat on at least one route": "יש להפעיל שיחה או צ'אט בלפחות מסלול אחד",
    "Enable Chat": "Enable Chat",
    "Enable For All Users": "אפשר לכל המשתמשים",
    "Enable Mute": "הפעל השתקה",
    "Enable SMS Routing": "הפעלת נתב הודעות",
    "Enable Welcome Message": "הפעל הודעת ברוכים הבאים",
    "Enable agent levels": "הפעל שלבי סוכן",
    "Enable by Suspicious Login": "הפעל התחברות חשודה",
    "Enable call recording": "הפעל הקלטת שיחה",
    "Enabled": "מופעל",
    "Enabled Direct Dial": "חיוג ישיר מופעל",
    "Enabled Outside of IP Range": "מאופשר מחוץ לטווח IP",
    "Enabled Outside of IP range": "מופעל מחוץ לטווח IP",
    "Enabled Outside of Login IP Range": "מאופשר מחוץ לטווח IP להתחברות",
    "Enabled for all users": "מאופשר לכל המשתמשים",
    "Enabled only on Suspicious Login": "מופעל רק בהתחברות חשודה",
    "End Chat": "סיים צ'אט",
    "End Current Call": "סיים שיחה נוכחית",
    "End Test": "סיים בדיקה",
    "End the test call before saving": "סיים את שיחת הבדיקה לפני השמירה",
    "End the test call before changing status": "סיים את שיחת הבדיקה לפני שינוי הסטטוס",
    "Endpoint": "נקודת קצה",
    "Endpoint created": "נקודת הקצה נוצרה",
    "Endpoint updated": "נקודת הקצה עודכנה",
    "Endpoint / Flow": "נקודת קצה \\ תזרים",
    "Endpoint not Available": "נקודת הקצה אינה זמינה",
    "Endpoint parameters": "פרמטרים של נקודת קצה",
    "Endpoints": "נקודות קצה",
    "Ends with": "מסתיים ב",
    "English": "אנגלית",
    "English (Default)": "אנגלית (ברירת מחדל)",
    "Enjoy $5 in free credit to try our service right away": "תהנה מ-$5 באשראי חינם כדי לנסות את השירות שלנו מיד.",
    "Enter URL": "הזן כתובת URL",
    "Enter Value": "הזן ערך",
    "Enter a Name": "הזן שם",
    "Enter a PIN": "הזן קוד",
    "Enter an Email Address": "הזן כתובת דוא\"ל",
    "Enter name": "הכנס שם",
    "Enter names separated by comma or new line": "הזן שמות מופרדים בפסיק או בשורה חדשה",
    "Enter the authentication code": "הזן את קוד האימות",
    "Enter the code that was sent to your new phone number": "הזן את הקוד שנשלח למספר הטלפון החדש שלך.",
    "Enter the six digits displayed in the app": "הכנס את ששת הספרות המופיעות באפליקציה",
    "Enter the verification code sent to your email": "הזן את קוד האימות שנשלח לדוא\"ל שלך",
    "Enter your card details and top up your account": "הכנס את פרטי הכרטיס שלך וטען את חשבונך.",
    "Enterprise": "ארגוני",
    "Entries": "רשומות: ",
    "Error": "שגיאה",
    "Error deleting integration": "שגיאה במחיקת האינטגרציה.",
    "Error in reviewing cart, please try again!": "שגיאה בבדיקת העגלה, נסה שוב!",
    "Essential": "חיוני",
    "Estimated Transfer Date": "תאריך העברה משוער",
    "Event Push Notifications": "Event Push Notifications",
    "Event push notifications": "Event push notifications",
    "Everybody": "כולם",
    "Everyday": "כל יום",
    "Everything in Advanced, and": "כל מה שיש במתקדם, ו",
    "Everything in Core, and": "כל מה שיש בליבה, ו",
    "Everything in Essential, and": "כל מה שיש בחיוני, ו",
    "Everything in Start-up, and": "כל מה שיש בסטארט-אפ, ו",
    "Exact": "שווה ל",
    "Example": "דוּגמָה",
    "Example:": "דוגמה: {example}",
    "Examples": "דוגמאות",
    "Exclude Groups": "לא לכלול קבוצות",
    "Exit Destinations": "יעדי יציאה",
    "Exit audio": "שמע יציאה",
    "Exit by digit": "יציאה לפי ספרה",
    "Exit destination": "יעד יציאה",
    "Exit destination type": "סוג יעד יציאה",
    "Exit sound": "צליל יציאה",
    "Expand sidebar": "הרחב סרגל צד",
    "Expiration": "תפוגה",
    "Expiration date": "תאריך תפוגה",
    "Export": "יצוא",
    "Expression used for replacing matches in the regex pattern": "ביטוי המשמש להחלפת התאמות בתבנית ה-regex.",
    "Expression used to find a match in the input text": "ביטוי המשמש למציאת התאמה בטקסט הקלט.",
    "Extend account settings": "הרחב הגדרות חשבון",
    "Extension": "שלוחה",
    "Extension currently available for Chrome and Edge only": "Extension currently available for Chrome and Edge only",
    "Extension is required": "נדרשת שלוחה",
    "Extension should be number": "השלוחה צריכה להיות מספר",
    "Extensions": "שלוחות",
    "External ID": "מזהה חיצוני",
    "External chats": "צ'אטים חיצוניים",
    "FAQ": "שאלות נפוצות",
    "FILTERED BY": "מסונן לפי",
    "FS Domain": "כתובת רישום",
    "Failed": "נכשל",
    "Failed to delete template": "מחיקת התבנית נכשלה",
    "Failed to generate API key": "נכשל ביצירת מפתח API.",
    "Failed to save the widget": "שמירת הווידג'ט נכשלה",
    "Failed to update template": "עדכון התבנית נכשל",
    "Fax": "פקס",
    "Fax option": "אפשרות פקס",
    "FaxBox": "תיבת פקס",
    "File": "קובץ",
    "File is required": "נדרש קובץ",
    "Filter": "מסנן",
    "Finance": "כספים",
    "Finance and banking": "פיננסים ובנקאות",
    "Financial": "כַּספִּי",
    "Financial User": "משתמש פיננסי",
    "Financial user": "משתמש פיננסי",
    "Finish": "סיום",
    "Finish Purchase": "סיים רכישה",
    "First Name": "שם פרטי",
    "First name": "שם פרטי",
    "First name *": "שם פרטי *",
    "First name can only contain letters": "השם הפרטי יכול להכיל רק אותיות",
    "Fixed amount": "סכום קבוע",
    "Flush Registration": "נקה רישום",
    "Flush registration": "נקה רישום",
    "Flush registration command sent": "הפקודה לניקוי רישום נשלחה",
    "Follow me 10s delay": "עקוב אחרי השהיה של 10 שניות",
    "Follow me 15s delay": "עקוב אחרי השהיה של 15 שניות",
    "Follow me 20s delay": "עקוב אחרי השהיה של 20 שניות",
    "Follow me 30s delay": "עקוב אחרי השהיה של 30 שניות",
    "Follow me 40s delay": "עקוב אחרי השהיה של 40 שניות",
    "Follow me 50s delay": "עקוב אחרי השהיה של 50 שניות",
    "Follow me 5s delay": "עקוב אחרי השהיה של 5 שניות",
    "Follow me 60s delay": "עקוב אחרי השהיה של 60 שניות",
    "Follow me 70s delay": "עקוב אחרי השהיה של 70 שניות",
    "Follow me 80s delay": "עקוב אחרי השהיה של 80 שניות",
    "Follow me 90s delay": "עקוב אחרי השהיה של 90 שניות",
    "For example, 60/1 means a minimum charge of 60 seconds, then billed in 1-second increments": "לדוגמה, 60/1 פירושו חיוב מינימלי של 60 שניות, ולאחר מכן חיוב במרווחים של שנייה אח.",
    "Force Password Reset": "כפה איפוס סיסמה",
    "Force password change": "חייב שינוי סיסמה",
    "Forced": "מאולץ",
    "Forced: An agent joins a queue automatically on check in": "מאולץ: סוכן מצטרף לתור אוטומטית בעת צ'ק-אין",
    "Forgot Password?": "שכחת סיסמה?",
    "Forgot password description": "הכנס את הדוא\"ל המשויך לחשבונך וקבל קישור לאיפוס הסיסמה.",
    "Forgot your password?": "שכחת את הסיסמה שלך?",
    "Format": "פורמט",
    "Forward": "העבר",
    "Forwarded message": "הודעה מועברת",
    "Found Users": "משתמשים שנמצאו",
    "Found group chats": "צ'אטים קבוצתיים שנמצאו",
    "Found numbers": "{count, plural, one {# מספר נמצא} other {# מספרים נמצאו}}",
    "Free": "חינם",
    "Fri": "שישי",
    "From": "מ",
    "From now": "מעכשיו",
    "General": "כללי",
    "General information": "מידע כללי",
    "Get Started": "התחל",
    "Get Started For Free": "התחל בחינם",
    "Get Verified": "אמת חשבון",
    "Get a code in your email at every login": "קבל קוד באימייל שלך בכל התחברות",
    "Get started with Inbox": "התחל עם תיבת הדואר הנכנס",
    "Get started with your new number ": "התחל עם המספר החדש שלך ",
    "Getting number...": "מקבל מספר...",
    "Go to first page": "עבור לעמוד הראשון",
    "Go to last page": "עבור לעמוד האחרון",
    "Go to next page": "עבור לעמוד הבא",
    "Go to previous page": "עבור לעמוד הקודם",
    "Google": "גוגל",
    "Google Authenticator": "מאמת של גוגל",
    "Google Authenticator code": "קוד מאמת של גוגל",
    "Great. I’ve created a ticket and our support will reach out to you when we have an answer": "מצוין. יצרתי כרטיס תמיכה, והצוות שלנו ייצור איתך קשר כאשר תהיה לנו תשובה.",
    "Great. I’ve created a ticket and our support will reach out to you when we have an answer.": "מצוין. יצרתי כרטיס תמיכה, והצוות שלנו ייצור איתך קשר כאשר תהיה לנו תשובה.",
    "Greeting": "ברכה",
    "Greeting is required": "נדרשת ברכה",
    "Greeting long": "ברכה ארוכה",
    "Greeting short": "ברכה קצרה",
    "Group": "קבוצה",
    "Group Name": "שם קבוצה",
    "Group name": "שם הקבוצה",
    "Hangup": "ניתוק",
    "Hangup Cause": "סיבת ניתוק",
    "Header": "כותרת",
    "Header Title": "טקסט הכותרת",
    "Healthcare": "שירותי בריאות",
    "Hebrew": "עברית",
    "Hello": "שלום",
    "Help us minimize the risk of fraud on your account": "עזור לנו לצמצם את הסיכון להונאה בחשבונך.",
    "Here’s the ticket:": "הנה הכרטיס:",
    "Hide Login with credentials": "הסתר התחברות עם פרטי משתמש",
    "Hide filters": "הסתר מסננים",
    "Hide keypad": "הסתר מקלדת",
    "High": "גבוה",
    "Hold": "המתנה",
    "Hours": "{value} שעות",
    "How calls are distributed in the queue to available agents": "כיצד שיחות מופצות בתור לסוכנים זמינים.",
    "How can I end my subscription?": "איך אני יכול לסיים את המנוי שלי?",
    "How can I let callers know how long the wait might be in a queue?": "איך אני יכול להודיע למתקשרים כמה זמן הם עלולים להמתין בתור?",
    "How can I use Time Conditions to handle after-hours customer support?": "איך אני יכול להשתמש בשעות פעילות לטיפול בתמיכה ללקוחות אחרי שעות העבודה?",
    "How can I use call forwarding to handle after-hours calls or when I'm traveling?": "איך אני יכול להשתמש בהפניית שיחות לטיפול בשיחות לאחר שעות העבודה או כאשר אני בטיו?",
    "How can I use conference rooms for project team meetings or remote training sessions?": "איך אני יכול להשתמש בחדרי ישיבות לצורך פגישות צוות פרויקטים או סשנים של הכשרה מרחו?",
    "How could call queues help my business during peak hours or holiday seasons?": "איך תורי שיחות יכולים לעזור לעסק שלי בשעות שיא או בעונות החגים?",
    "How do I assign an endpoint to a specific user?": "כיצד אני משייך מכשיר קצה ספציפי למשתמש ספציפי?",
    "How do I change a user's role?": "איך אני משנה את התפקיד של משתמש?",
    "How do I create a professional voicemail greeting for my business?": "איך אני יוצר הודעת תא קולי מקצועית לעסק שלי?",
    "How do I purchase a DID number?": "איך אני רוכש מספר DID?",
    "How do I purchase a phone number?": "איך אני רוכש מספר טלפון?",
    "How do I select which calls should hear a specific announcement?": "How do I select which calls should hear a specific announcement?",
    "How do I set my security features?": "כיצד אני מגדיר את תכונות האבטחה שלי?",
    "How do I set up call forwarding to a different number?": "איך אני מקבל הפניית שיחות למספר אחר?",
    "How does a Conference Room work?": "איך חדר ועידה עובד?",
    "How does the Auto Attendant improve customer service?": "איך האוטומט אדמין (Auto Attendant) משפר את שירות הלקוחות?",
    "How does the Auto Attendant work?": "איך עובד האוטומט אדמין (Auto Attendant)?",
    "How long a caller will wait when there are no agents in the queue, before being directed to the exit destination": "כמה זמן מתקשר ימתין כאשר אין סוכנים בתור, לפני שיופנה ליעד היציאה",
    "How long will the system try to reach the forwarded number before it gives up?": "How long will the system try to reach the forwarded number before it gives up?",
    "How many people can I add to an intercept group, and how many groups can a user be added to?": "כמה אנשים ניתן להוסיף לקבוצה שמרכזת חטיפת שיחות?ולכמה קבוצות כאלה יכול משתמש להצטרף במקביל?",
    "How many people can I add to an intercept group, and how many groups can one specific person be added to?": "כמה משתמשים ניתן להוסיף לקבוצה שמרכזת חטיפת שיחות?\r\nולכמה קבוצות ניתן להוסיף משתמש ספציפי?",
    "How many team members can I add under each billing plan?": "כמה חברי צוות ניתן להוסיף תחת כל תוכנית חיוב?",
    "How many users with the same role can there be?": "כמה משתמשים עם אותו תפקיד יכולים להיות?",
    "How the calls are distributed in the queue to available agents": "איך השיחות מופצות בתור לסוכנים הזמינים",
    "How to add contacts?": "איך להוסיף אנשי קשר?",
    "How to edit or delete a contact?": "איך לערוך או למחוק איש קשר?",
    "How to generate a report?": "איך ליצור דוח?",
    "How to set my security features?": "איך להגדיר את תכונות האבטחה שלי?",
    "How to set up email notifications for voicemails?": "איך להגדיר התראות דואר אלקטרוני עבור הודעות קוליות?",
    "How to use the insights from the Dashboard?": "איך להשתמש בתובנות מלוח המחוונים?",
    "How to view the details of a call?": "איך לצפות בפרטי שיחה?",
    "ID": "מזהה",
    "ID Verification": "אימות זהות",
    "ID Verification coming soon": "אימות זהות יגיע בקרוב...",
    "ID Verification description": "עזור לנו למזער את הסיכון להונאה בחשבונך.",
    "ID Verification full description": "אנו משתמשים ב-Stripe Identity לאימות זהות. כדי למנוע הונאות, אנו דורשים אימות זהות אם ברצונך לבצע או לקבל שיחות טלפון. תוכל גם להגדיר זאת מאוחר יותר בעמוד הפרופיל שלך.",
    "ID Verification:": "אימות זהות:",
    "IP": "IP",
    "IP Range": "טווח IP",
    "IP range": "טווח IP",
    "IP, IP Range or CIDR": "IP, טווח IP או CIDR",
    "IP:port": "IP:port",
    "IPv4": "IPv4",
    "IPv4 range": "טווח IPv4",
    "IPv4, Range or CIDR": "IPv4, טווח או CIDR",
    "IVR": "IVR",
    "IVR was successfully saved": "ה-IVR נשמר בהצלחה",
    "Idle": "זמן סרק",
    "Idle time": "זמן סרק",
    "If Replay greeting is missing it will be played multiple times": "אם חסרה ברכת השמעה מחדש, היא תנוגן מספר פעמים",
    "If a match is found, stop applying the next rules": "אם נמצאה התאמה, עצור את יישום הכללים הבאים.",
    "If the agent goes over the time limit, the manager is notified, and the agent's timer gets highlighted in red": "אם הסוכן עובר את מגבלת הזמן, המנהל מקבל הודעה, והטיימר של הסוכן מסומן באדום",
    "If you don't set up your two-factor authentication (TFA) now, you will need to do it the next time you log in": "אם לא תגדיר את האימות הדו-שלבי (TFA) כעת, תצטרך לעשות זאת בפעם הבאה שתתחבר",
    "If you regenerate the QR you will need to set up Google Authenticator again": "אם תחדש את קוד ה-QR תצטרך להגדיר מחדש את Google Authenticator",
    "Immediately": "מיד",
    "In Progress": "בתהליך",
    "In order to keep your account secure we recommend setting up Two-Factor Authentication.": "כדי לשמור על אבטחת החשבון שלך אנו ממליצים להגדיר אימות דו-שלבי.",
    "In the meantime, find us on": "בינתיים, מצא אותנו ב",
    "Included": "כלול",
    "Inbound": "נכנס",
    "Inbound Calls": "שיחות נכנסות",
    "Inbound Cost": "עלות שיחה נכנסת",
    "Inbound SMS": "סמס נכנס",
    "Inbound calls": "שיחות נכנסות",
    "Inbound external": "שיחות נכנסות מבחוץ",
    "Inbound internal": "שיחות נכנסות פנימיות",
    "Inbound queue": "תור נכנס",
    "Inbox": "תיבת דואר נכנס",
    "Inbox Number": "מספר תיבה",
    "Inboxes": "תיבות דואר נכנס",
    "Include in reports": "כלול בדוחות",
    "Incoming Call From": "שיחה נכנסת מאת",
    "Incoming call": "שיחה נכנסת",
    "Incr": "פעימה",
    "Increase team capacity": "הגדל את קיבולת הצוות",
    "Increment": "פעימה",
    "Increments": "Increments",
    "Industry": "תעשייה",
    "Industry *": "תעשייה *",
    "Info": "מידע",
    "Init Incr": "פעימה ראשונית",
    "Initial Increment": "פעימה ראשונית",
    "Initial fees": "עמלות ראשוניות",
    "Initial increment / Increment": "Initial increment / Increment",
    "Input": "קלט",
    "Input chat name": "הזן שם צ'אט",
    "Insert Token": "הכנס טוקן",
    "Instantly add funds to your account": "הוסף כספים לחשבונך באופן מיידי",
    "Integrates with some of the most popular CRMs": "מתממשק עם כמה מ-CRMs הפופולריים ביותר.",
    "Integration": "אינטגרציה",
    "Integration name": "שם אינטגרציה",
    "Integrations": "התממשקות",
    "Inter digit": "בחר ספרה",
    "Inter digit timeout": "פסק זמן בין ספרות",
    "Intercept Groups": "קבוצות יירוט",
    "Intercept groups": "קבוצות יירוט",
    "Intercept other groups": "יירוט קבוצות אחרות",
    "Internal": "פנימי",
    "Internal Calls": "שיחות פנימיות",
    "Internal calls": "שיחות פנימיות",
    "Internal chats": "צ'אטים פנימיים",
    "International": "בין לאומי",
    "Interval": "פעימה",
    "Intro audio": "שמע פתיחה",
    "Invalid amount": "כמות לא חוקית",
    "Invalid audio": "שמע לא תקין",
    "Invalid code": "קוד לא חוקי",
    "Invalid color": "צבע לא חוקי",
    "Invalid file type. Allowed types:": "סוג קובץ לא תקין. סוגים מותרים: {ext}.",
    "Invalid number": "מספר לא חוקי",
    "Invalid phone number": "מספר טלפון שגוי.",
    "Invalid selection audio": "קובץ מדיה שנבחר אינו תקין",
    "Invalid sound": "צליל לא חוקי",
    "Invalid type for number": "סוג מספר לא תקין",
    "Invalid verification code": "קוד אימות לא חוקי",
    "Invitation 2FA description": "האדם שהזמין אותך דרש שתפעיל אימות דו-שלבי. סרוק את קוד ה-QR למטה באמצעות אפליקציית Google Authenticator כדי לשפר את האבטחה",
    "Invitation Expired": "ההזמנה פגה",
    "Invitation sent successfully.": ".ההזמנה נשלחה בהצלחה",
    "Invitations": "הזמנות",
    "Invitations description": "ניהול משתמשים שהוזמנו ומצבם",
    "Invite Sent": "הזמנה נשלחה",
    "Invite created, email not sent": "ההזמנה נוצרה, האימייל לא נשלח",
    "Invite Sent Successfully": "ההזמנה נשלחה בהצלחה",
    "Invite people to chat": "הזמן אנשים לצ'אט",
    "Invite sent successfully": "ההזמנה נשלחה בהצלחה",
    "Invited": "הוזמן",
    "Invited At": "הוזמן ב",
    "Invoice": "חשבונית",
    "Invoice Total": "סכום החשבונית",
    "Invoice number": "מספר חשבונית",
    "Invoices": "חשבוניות",
    "Is agent": "סוכן",
    "Is it possible to schedule different greetings for different times of the day?": "האם אפשר לתכנן ברכות שונות לשעות שונות ביום?",
    "Is required": "{field} נדרש.",
    "Is there a way to automatically answer calls if an agent from a queue is free?": "איך תורי שיחות יכולים לעזור לעסק שלי בשעות שיא או בעונות החגים?",
    "Is there a way to limit the number of people who can join a conference at one time?": "האם יש דרך להגביל את מספר האנשים שיכולים להצטרף לכנס בזמן אחד?",
    "Is there a way to test my dial rules?": "האם ישנה דרך שבה אני אוכל לבדוק את חוקי החיוג שלי?",
    "It can repeat instructions, without the welcome message": "זה יכול לחזור על ההוראות, ללא הודעת הברכה",
    "It uses a high-speed internet connection to connect to a VoIP service provider": "הוא משתמש בחיבור אינטרנט מהיר כדי להתחבר לספק שירותי VoIP.",
    "It's paid until <b>{date}</b> and can be reactivated at any time before then": "שולם עד <b>{date}</b> וניתן להפעיל מחדש בכל עת לפני כן",
    "It's paid until <b>{date}</b> and can be reactivated at any time before then.": "הוא שולם עד {date} וניתן להפעילו מחדש בכל עת לפני כן.",
    "It's paid until <b>{date}</b> and can be reactivated until then": "המספר משולם עד <b>{date}</b> וניתן להפעילו מחדש עד אז",
    "Join": "הצטרף",
    "Join / leave by time group": "הצטרפות \\ עזיבה לפי קבוצת זמן",
    "Join Chat": "הצטרף לצ'אט",
    "Join Option": "אפשרות הצטרפות",
    "Join chat": "הצטרף לצ'אט",
    "Join option": "אפשרות הצטרפות",
    "Join this chat to start messaging": "הצטרף לצ'אט כדי להתחיל לשלוח הודעות",
    "Join/Leave Time Group": "קבוצת זמן הצטרפות/עזיבה",
    "Join/leave queue": "הצטרף/עזוב את התור",
    "Jump to": "קפוץ אל",
    "KPI": "KPI",
    "Keep Local File": "שמור קובץ מקומי",
    "Keep editing": "המשך לערוך",
    "Key": "מקש",
    "Keypad": "מקלדת",
    "Labels": "תוויות",
    "Labels or keywords for easier management, sorting, or categorization": "תוויות או מילות מפתח לניהול קל יותר, מיון או קטלוג.",
    "Lang": "שפה",
    "Language": "שפה",
    "Language of the dynamic audio": "שפת הקובץ שמע הדינמי",
    "Last 30 days": "30 הימים האחרונים",
    "Last 7 days": "Last 7 days",
    "Last Login": "התחברות אחרונה",
    "Last Name": "שם משפחה",
    "Last Reg": "רישום אחרון",
    "Last Update": "עדכון אחרון",
    "Last message": "הודעה אחרונה",
    "Last month": "חודש שעבר",
    "Last name": "שם משפחה",
    "Last name *": "שם משפחה *",
    "Last name can only contain letters": "שם המשפחה יכול להכיל רק אותיות",
    "Last week": "שבוע שעבר",
    "Lead Link Url": "קישור לליד",
    "Leave": "עזוב",
    "Leave your number for exclusive updates:": "השאר את מספרך לקבלת עדכונים בלעדיים:",
    "Legal": "משפטי",
    "Length": "אורך",
    "Length of the digit inputs": "אורך הזנת הספרות",
    "Less filters": "פחות מסננים",
    "Let's talk": "בוא נדבר",
    "Let’s verify your email": "בוא נאמת את הדוא\"ל שלך",
    "Level": "שלב",
    "Level wait time": "זמני המתנת שלב",
    "Library of media content": "ספריית תוכן מדיה",
    "Light": "בהיר",
    "Linked Inbox": "תיבת דואר נכנס מקושרת",
    "Listen": "האזנה",
    "Listen to Own Calls Recordings": "האזן להקלטות השיחות שלך",
    "Listening": "מאזין",
    "Live": "חי",
    "Live Calls": "שיחות חיות",
    "Live calls": "שיחות פעילות",
    "Load more": "טען עוד",
    "Loading": "טוען",
    "Loading...": "טוען…",
    "Localized": "מקומי",
    "Location": "מיקום",
    "Log Out": "התנתק",
    "Log in": "התחבר",
    "Log in to your account": "התחבר לחשבון שלך",
    "Log out all users": "נתק את כל המשתמשים",
    "Log user out": "נתק משתמש",
    "Log users out": "נתק משתמשים",
    "Logging out": "מתנתק",
    "Logging you out": "מנתק אותך",
    "Login": "התחבר",
    "Login & SIP registration by countries and/or IP ranges": "כניסה ורישום SIP לפי מדינות ו/או טווחי IP",
    "Login Access": "גישה להתחברות",
    "Logout": "התנתק",
    "Logs for all previous calls": "היסטוריה לכל השיחות הקודמות",
    "Longest Idle Agent": "הסוכן שלא ענה הכי הרבה זמן",
    "Longest Waiting Call": "השיחה הממתינה הארוכה ביותר",
    "Longest waiting call": "השיחה עם זמן ההמתנה הארוך ביותר",
    "Low": "נמוך",
    "Low balance threshold": "סף יתרה נמוך",
    "Lower than Range Start": "נמוך יותר מנקודת התחלה.",
    "Lowercase letters (a-z)": "אותיות קטנות באנגלית (a-z)",
    "MB": "MB",
    "MIN": "דקה",
    "MP3 Call Recording": "הקלטת שיחות MP3",
    "MP3 call recordings Storage": "אחסון הקלטות שיחות MP3",
    "Mac": "Mac",
    "Mail": "דואר",
    "Main audio": "שמע ראשי",
    "Main greeting": "ברכה ראשית",
    "Make default": "הפוך לברירת מחדל",
    "Make default card": "הפוך לכרטיס ברירת מחדל",
    "Makes and receives calls": "מבצע ומקבל שיחות.",
    "Making calls, receiving calls, voicemail, email, ring groups, class-5 telephone switch": "ביצוע שיחות, קבלת שיחות, תא קולי, דוא\"ל, קבוצות צלצול, מתגי class 5 לטלפוניה",
    "Manage IVRs": "נהל נתבים",
    "Manage Seats": "נהל מושבים",
    "Manage accounts": "נהל חשבונות",
    "Manage all the users for this account": "נהל את כל המשתמשים עבור חשבון זה.",
    "Manage all your phones (softphones or physical) in one place": "נהל את כל הטלפונים שלך (טלפונים תוכנתיים או פיזיים) במקום אחד.",
    "Manage and setup your call queues": "נהל והגדר את תורי השיחות שלך",
    "Manage incoming calls when all lines are busy or agents are unavailable": "נהל שיחות נכנסות כאשר כל הקווים תפוסים או שסוכנים אינם זמינים.",
    "Manage numbers, check details, and define call routing per number.": "נהל מספרי טלפון, עיין בפרטיהם, והגדר ניתוב שיחות לכל מספר.",
    "Manage ring groups and associated devices and destinations": "נהל קבוצות חיוג ומכשירים ויעדים מקושרים",
    "Manage teams": "נהל צוותים.",
    "Manage the account's general settings": "נהל את הגדרות החשבון הכלליות.",
    "Manage the company info and settings": "נהל את פרטי החברה וההגדרות.",
    "Manage the list of dial rules affecting the calls": "נהל את רשימת כללי החיוג המשפיעים על השיחות",
    "Manage the list of statuses an agent can have": "נהל את רשימת הסטטוסים של הסוכן",
    "Manage the profile info and settings": "נהל את פרטי הפרופיל וההגדרות.",
    "Manage time conditions and their destinations": "נהל שעות פעילות ויעדיהם",
    "Manage timegroups and their destinations": "נהל קבוצות זמן ויעדיהם",
    "Manage user data and settings": "נהל נתוני משתמש והגדרות.",
    "Manage user groups": "נהל קבוצות משתמשים",
    "Manage your company profile, payment plans and call rates": "נהל את פרופיל החברה שלך, תוכניות התשלום ותעריפי השיחות",
    "Manage your company profile, payment plans and security": "נהל את פרופיל החברה שלך, תוכניות תשלום ואבטחה.",
    "Manage your existing endpoints": "נהל את נקודות הקצה הקיימות שלך",
    "Management Emails": "דוא\"לים לניהול",
    "Manages most financial aspects": "מנהל את רוב ההיבטים הפיננסיים.",
    "Manages the account": "מנהל את החשבון.",
    "Manual": "ידני",
    "Manual: An agent joins a queue manually": "ידני: סוכן מצטרף לתור באופן ידני",
    "Manufacturing and Logistics": "ייצור ולוגיסטיקה",
    "Mask All calls": "הסתר את כל השיחות",
    "Mask Inbound calls": "הסתר שיחות נכנסות",
    "Mask Outbound calls": "הסתר שיחות יוצאות",
    "Mask phone number": "הסתר מספר טלפון",
    "Masking Format": "פורמט הסתרה",
    "Masking Options": "אפשרויות הסתרה",
    "Mastercard": "מאסטרקארד",
    "Match destination": "יעד תואם",
    "Matched": "התאים",
    "Max": "מקסימום",
    "Max Channels": "מקסימום ערוצים",
    "Max N": "Max {n}",
    "Max N chars": "חייב להכיל לכל היותר {n} תווים",
    "Max N for US/CA": "Max {n} for US/CA",
    "Max N labels": "ניתן להוסיף לכל היותר {n} תוויות",
    "Max Simultaneous calls per user": "מקסימום מספר השיחות שמשתמש יכול לקבל בו-זמנית",
    "Max Wait": "המתנה מקסימלית",
    "Max characters": "מקסימום {number} תווים",
    "Max characters: 100": "Max characters: 100",
    "Max digit length": "אורך מקסימלי של ספרות",
    "Max digits": "מקסימום ספרות",
    "Max duration must be greater than min": "המשך המרבי חייב להיות גדול מהמשך המזערי",
    "Max failures": "מספר כשלונות מקסימלי",
    "Max members": "מספר מרבי של חברים",
    "Max number of users for this account": "מספר המשתמשים המקסימלי לחשבון זה.",
    "Max snooze number": "מספר השהיות מרבי",
    "Max time a caller will wait in the queue before being directed to the exit destination": "הזמן המקסימלי שמתקשר ימתין בתור לפני שינותב ליעד היציאה.",
    "Max value": "ערך מקסימלי הוא {max}",
    "Max wait time": "זמן המתנה מקסימלי",
    "Max wait time - no agents": "זמן המתנה מקסימלי - ללא סוכנים",
    "Maximum 10 files per upload. The extra files were not included.": "מקסימום 10 קבצים בכל העלאה. הקבצים הנוספים לא נכללו.",
    "Maximum call wait time": "זמן המתנה מקסימלי לשיחה",
    "Media": "מדיה",
    "Media File": "קובץ מדיה",
    "Media Files": "קבצי מדיה",
    "Media could not be delivered.": "לא ניתן היה לשלוח את המדיה.",
    "Media could not be retrieved.": "לא ניתן היה לאחזר את המדיה.",
    "Media expired — no longer available.": "המדיה פגה — אינה זמינה עוד.",
    "Media file is not used": "קובץ המדיה לא בשימוש",
    "Media files": "קבצי מדיה",
    "Media is not available.": "המדיה אינה זמינה.",
    "Medium": "בינוני",
    "Member authentication": "אימות משתמש",
    "Members": "חברים",
    "Merge": "איחוד",
    "Merge Calls": "איחוד שיחות",
    "Message Count": "מספר הודעות",
    "Message could not be delivered.": "לא ניתן היה לשלוח את ההודעה.",
    "Message is too long. Maximum is 2000 characters.": "ההודעה ארוכה מדי. המקסימום הוא 2000 תווים.",
    "Messages Per Day": "Messages Per Day",
    "Messages Per Hour": "Messages Per Hour",
    "Messages allocated disk space": "נפח דיסק מוקצה להודעות",
    "Messaging blocked": "ההודעות חסומות",
    "Microphone": "מיקרופון",
    "Microphone and output endpoint are not connected to this computer.": "המיקרופון ונקודת הקצה אינם מחוברים למחשב זה.",
    "Microphone is not connected.": "המיקרופון אינו מחובר.",
    "Microsoft": "מיקרוסופט",
    "Microsoft Teams": "Microsoft Teams",
    "Middle name": "שם אמצעי",
    "Min": "מינימום",
    "Min Dur": "זמן שיחה מינימלי",
    "Min N chars": "חייב להכיל לפחות {n} תווים",
    "Min value": "ערך מינימלי הוא {min}",
    "Min. Billing Increment": "מרווח חיוב מינימלי",
    "Min. Subscription Period": "תקופת מנוי מינימלית",
    "Minute": "דקה",
    "Minute Cost (Inbound)": "עלות לדקה (שיחה נכנסת)",
    "Minutes": "{value} דקות",
    "Missed": "שיחה שלא נענתה",
    "Missed inbound": "שיחה נכנסת שלא נענתה",
    "Missed outbound": "שיחה יוצאת שלא נענתה",
    "Mobile phone number should be in international format (e164)": "מספר הטלפון הנייד צריך להיות בפורמט בינלאומי (e164)",
    "Module": "מודול",
    "Module permissions": "הרשאות מודול",
    "Mon": "שני",
    "Monitoring not available": "ניטור לא זמין",
    "Monitors information without making changes": "עוקב אחר מידע ללא ביצוע שינויים.",
    "Mono playback": "השמעה מונו",
    "Month": "חודש",
    "Month / User": "חודש / משתמש",
    "Monthly": "חודשי",
    "Monthly Cost": "עלות חודשית",
    "Monthly Price": "מחיר חודשי",
    "Monthly Recurring": "חודשי קבוע",
    "Monthly cost": "עלות חודשית",
    "Monthly invoice": "חשבונית חודשית",
    "Months": "{number} חודשים",
    "Months count": "{count} חודשים",
    "More actions": "עוד פעולות",
    "More filters": "עוד פילטרים",
    "Music": "מוזיקה",
    "Music on hold": "מוזיקה בהמתנה",
    "Must be a positive integer": "Must be a positive integer",
    "Mute": "השתק",
    "Mute Toggle": "מתג השתקה",
    "Mute on Join": "השתקה בעת הצטרפות",
    "My Caller ID": "מזהה המתקשר שלי",
    "My Company": "החברה שלי",
    "My Profile": "הפרופיל שלי",
    "N/A": "לא זמין",
    "NAME": "שם",
    "Name": "שם",
    "Name cannot be empty.": "השם לא יכול להיות ריק.",
    "Name is required": "נדרש שם",
    "Name of the Auto Attendant": "שם נתב אוטומטי",
    "Name of the IVR": "שם ה-IVR",
    "Name of the current IVR": "שם ה-IVR הנוכחי",
    "Name's inbox": "תיבת דואר נכנס של {name}",
    "Need an Account?": "צריך חשבון?",
    "Need to add another card?": "צריך להוסיף כרטיס נוסף?",
    "New": "חדש",
    "New Chat": "צ'אט חדש",
    "New Preset": "שם הפילטר",
    "New chat": "צ'אט חדש",
    "New chat in queue": "צ'אט חדש בתור",
    "New contact has been saved": "איש קשר חדש נשמר",
    "New contact has been updated": "איש קשר חדש עודכן",
    "New device": "מכשיר חדש",
    "New endpoint": "נקודת קצה חדשה",
    "New extension": "שלוחה חדשה",
    "New forward": "העברה חדשה",
    "New intercept group": "קבוצת יירוט חדשה",
    "New password": "סיסמה חדשה",
    "New password must be different from current password": "הסיסמה החדשה חייבת להיות שונה מהסיסמה הנוכחית",
    "New permission group": "קבוצת הרשאות חדשה",
    "New queue": "תור חדש",
    "New time condition": "שעות פעילות חדש",
    "New time group": "קבוצת זמן חדשה",
    "New voicemail - {vm_box_name} [{datetime}]": "הודעה קולית חדשה - '{vm_box_name}' ['{datetime}']",
    "Next": "הבא",
    "Next Invoice Date": "תאריך החשבונית הבא",
    "Next billing": "החיוב הבא:",
    "No": "לא",
    "No Agents Reject": "דחיית 'אין סוכנים'",
    "No Answer": "אין מענה",
    "No Numbers Available": "אין מספרים זמינים",
    "No Presets": "אין הגדרות מראש",
    "No Repeat": "ללא חזרה",
    "No SLA": "ללא SLA",
    "No agents assigned": "לא שויכו סוכנים",
    "No answer": "אין מענה",
    "No answer delay": "השהיית ללא מענה",
    "No chat history, yet": "אין היסטוריית צ’אט עדיין",
    "No chats available": "אין צ'אטים זמינים",
    "No chats match your search": "אף צ'אט לא תואם לחיפוש",
    "No closed conversations": "אין שיחות סגורות",
    "No contacts found": "לא נמצאו אנשי קשר",
    "No conversations": "אין שיחות",
    "No conversations found": "לא נמצאו שיחות",
    "No countries found": "לא נמצאו מדינות",
    "No data to show": "אין נתונים להצגה",
    "No filters or search applied": "לא נבחרו מסננים או חיפוש",
    "No hardware and maintenance costs": "ללא עלויות חומרה ותחזוקה.",
    "No history": "אין היסטוריה",
    "No input max": "מקסימום ללא קלט",
    "No input threadshold": "סף ללא קלט",
    "No input threshold": "סף קלט חסר",
    "No input wait time": "זמן המתנה ללא קלט",
    "No live calls": "אין שיחות חיות",
    "No match destination": "אין יעד מתאים",
    "No numbers found": "לא נמצאו מספרים",
    "No numbers found. Please try different filters": "לא נמצאו מספרים. אנא נסה מסננים שונים.",
    "No payment method on record": "אין שיטת תשלום רשומה",
    "No people match your search": "אף משתמש לא תואם לחיפוש",
    "No relevant information could be found in the documentation about this topic": "No relevant information could be found in the documentation about this topic",
    "No relevant information could be found in the documentation about this topic.": "לא נמצאה מידע רלוונטי בדוקומנטציה על נושא זה.",
    "No results": "אין תוצאות",
    "No results found": "לא נמצאו תוצאות",
    "No state found": "לא נמצאה מדינה",
    "No templates found": "לא נמצאו תבניות",
    "No timeout": "אין פסק זמן",
    "Nobody": "אף אחד",
    "Noise Suppression": "דיכוי רעש",
    "Non Billable": "לא ניתן לחיוב",
    "Non-Billable": "לא ניתן לחיוב",
    "None": "ללא",
    "Not Matched": "לא התאים",
    "Not Verified": "לא מאומת",
    "Not answered": "לא נענה",
    "Not available": "לא זמין",
    "Not checked-in": "לא בצ'ק-אין",
    "Not in use": "לא בשימוש",
    "Note": "הערה",
    "Notes": "הערות",
    "Notification Email": "דוא\"ל התראות",
    "Number": "מספר",
    "Number Of Pauses": "מספר ההפסקות",
    "Number Range": "טווח מספרים",
    "Number is required": "נדרש מספר",
    "Number of Agents In Queues": "מספר הנציגים בתורים",
    "Number of Users": "מספר משתמשים",
    "Number of agents ready for calls": "מספר הנציגים הזמינים לשיחות",
    "Number of calls": "מספר שיחות",
    "Number of calls answered by agents": "מספר שיחות שנענו על ידי נציגים",
    "Number of users": "מספר משתמשים:",
    "Number transformation rules": "חוקי המרת מספרים",
    "Numbers": "מספרים",
    "Numbers in certain countries require end user details for activation based on the country's telecom regulations.": "מספרים במדינות מסוימות דורשים פרטי משתמש קצה להפעלה בהתאם לתקנות התקשורת של המדינה.",
    "Occupation": "תעסוקה",
    "Occupation time": "זמן תעסוקה",
    "Offline": "מנותק",
    "Ok": "אישור",
    "Ok, got it": "בסדר, קיבלתי.",
    "Ok, got it. Here’s the ticket:": "בסדר, קיבלתי. הנה כרטיס התמיכה:",
    "Ok, let me know then if I can help you with any other issue": "בסדר, תן לי לדעת אם אני יכול לעזור לך בבעיה נוספת.",
    "Ok, let me know then if I can help you with any other issue.": "בסדר, תן לי לדעת אם אני יכול לעזור לך בבעיה נוספת.",
    "On Call": "בשיחה",
    "On Hold": "בהמתנה",
    "On Pause": "בהפסקה",
    "On Phone": "בשיחה",
    "On hold": "בהמתנה",
    "On low balance": "בעת יתרה נמוכה",
    "Once activated, a prorated charge will apply for the rest of this {period}": "לאחר ההפעלה, יחול חיוב יחסי עבור שארית {תקופה} זו",
    "One Time Password *": "סיסמא חד-פעמית *",
    "One or more email addresses are invalid": "אחת או יותר מכתובות הדוא\"ל אינן תקינות",
    "One or more names are invalid": "אחד או יותר מהשמות אינם חוקיים",
    "One seat has been allocated to the new user": "מושב אחד הוקצה למשתמש החדש",
    "One time password": "סיסמה חד פעמית",
    "One time password is required": "נדרשת סיסמה חד פעמית",
    "One time password must be 6 characters": "הסיסמה החד פעמית חייבת להיות באורך של 6 תווים",
    "One time password must be 6 characters long": "הסיסמה החד פעמית חייבת להיות באורך של 6 תווים",
    "One-time": "חד פעמי",
    "One-time charges include the setup cost, prorated charge for the current month, and charges for the minimum subscription period": "חיובים חד-פעמיים כוללים את עלות ההגדרה, חיוב יחסי עבור החודש הנוכחי, וחיובים עבור תקופת המנוי המינימלי.",
    "One-time fee includes setup & prorated charges": "תשלום חד-פעמי כולל עלות הגדרה וחיובים יחסיים",
    "One-time password": "סיסמה חד-פעמית",
    "Online": "מחובר",
    "Only one browser session is allowed You’ve already enabled it in another C2C integration": "רק הפעלת דפדפן אחת מותרת. כבר הפעלת אותה באינטגרציית C2C אחרת.",
    "Oops! This page does not exist": "אופס! דף זה אינו קיים",
    "Open": "פתח",
    "Open menu": "פתח תפריט",
    "Open support ticket": "פתח כרטיס תמיכה",
    "Operating time": "זמן פעילות",
    "Options": "אפשרויות",
    "Organization admin": "מנהל הארגון",
    "Organization owner": "בעל הארגון",
    "Other": "אחר",
    "Other Industry": "תעשייה אחרת",
    "Our customer service will email you to get the required details and documents": "שירות הלקוחות שלנו ישלח לך דוא\"ל כדי לקבל את הפרטים והמסמכים הנדרשים",
    "Our team will contact you shortly with next steps on the port-in request": "הצוות שלנו ייצור איתך קשר בקרוב בנוגע לשלבים הבאים בנוגע לבקשת ההעברה.",
    "Outbound": "יוצא",
    "Outbound Calls": "שיחות יוצאות",
    "Outbound SMS": "הודעות יוצאות",
    "Outbound call": "שיחה יוצאת",
    "Outbound calls": "שיחות יוצאות",
    "Outbound external": "שיחה יוצאת חיצונית",
    "Outbound internal": "שיחה יוצאת פנימית",
    "Outbund calls": "שיחות יוצאות",
    "Output Endpoint": "נקודת יציאה",
    "Output endpoint is not connected": "נקודת היציאה אינה מחוברת",
    "Outro audio": "שמע יציאה",
    "Override device parameters": "דרוס פרמטרים של מכשיר",
    "Override endpoint parameters": "עקיפת פרמטרים של נקודת קצה",
    "Overrides": "הגדרות עוקפות",
    "Overwrite account settings": "עקוף הגדרות חשבון",
    "Owner Email": "דוא\"ל בעלים",
    "PENDING": "ממתין",
    "PIN": "קוד אישי",
    "PM": "אחה\"צ",
    "PRICE": "מחיר",
    "Pages": "דפים",
    "Pagination message": "{current_page} מתוך {last_page}",
    "Paid Until": "שולם עד",
    "Paid Untill": "משולם עד",
    "Parameters": "פרמטרים",
    "Part": "חלק {index}",
    "Password": "סיסמה",
    "Password *": "סיסמה *",
    "Password Expiration": "מדיניות ססמאות",
    "Password Reset Confirmation": "אישור איפוס סיסמה",
    "Password Reset Successfully": "הסיסמה אופסה בהצלחה",
    "Password confirmation": "אישור סיסמה",
    "Password confirmation doesn’t match the new password": "אימות הסיסמה אינו תואם לסיסמה החדשה.",
    "Password expiration period": "אורך חיי סיסמה",
    "Password must be at least 6 characters": "הסיסמה חייבת להיות לפחות 6 תווים",
    "Password must be at least 8 characters long": "הסיסמה חייבת להיות באורך של לפחות 8 תווים",
    "Password must be at most 25 characters long": "הסיסמה חייבת להיות באורך של עד 25 תווים",
    "Password must be minimum 8 characters and should contain numbers letters and uppercase letters": "הסיסמה חייבת להיות באורך של לפחות 8 תווים ולהכיל מספרים, אותיות ואותיות רישיות באנגלית",
    "Password must contain at least 1 digit": "הסיסמה חייבת להכיל לפחות ספרה אחת",
    "Password must contain at least 1 lowercase letter": "הסיסמה חייבת להכיל לפחות אות אחת קטנה באנגלית",
    "Password must contain at least 1 special character (!@#$%^&*_)": "הסיסמה חייבת להכיל לפחות תו מיוחד אחד (!@#$%^&*_)",
    "Password must contain at least 1 special symbol": "הסיסמה חייבת להכיל לפחות תו מיוחד אחד",
    "Password must contain at least 1 uppercase letter": "הסיסמה חייבת להכיל לפחות אות אחת גדולה באנגלית",
    "Password must contain at least one special character from the following list: !@#$%^&*_-": "הסיסמה חייבת להכיל לפחות תו מיוחד אחד מהרשימה הבאה: !@#$%^&*_-",
    "Password must include": "הסיסמה חייבת לכלול:",
    "Password must include:": "הסיסמה חייבת לכלול:",
    "Password must not contain spaces": "הסיסמה לא יכולה להכיל רווחים",
    "Password repeat": "חזור על הסיסמה",
    "Password successfully changed": "הסיסמה שונתה בהצלחה",
    "Password was copied": "הסיסמה הועתקה",
    "Passwords do not match": "הסיסמאות אינן תואמות",
    "Pause": "הפסקה",
    "Pause Time": "זמן הפסקה",
    "Pause Type": "סוג הפסקה",
    "Pause time": "זמן הפסקה",
    "Pauses": "הפסקות",
    "Pay": "שלם",
    "Payment method": "שיטת תשלום",
    "Payment methods": "אמצעי תשלום",
    "Payment methods associated with your account": "שיטות תשלום המשויכות לחשבונך.",
    "Payments": "תשלומים",
    "Pending": "מחכה",
    "Pending Removal": "הסרה ממתינה",
    "Pending email": "דוא\"ל בהמתנה",
    "People": "אנשים",
    "People in chat": "משתתפים בצ'אט",
    "Period": "בוקר/ערב",
    "Period ends": "התקופה מסתיימת",
    "Permission": "הרשאה",
    "Permission Groups": "קבוצות הרשאות",
    "Personal": "אישי",
    "Phone": "טלפון",
    "Phone (optional)": "טלפון (אופציונלי)",
    "Phone *": "טלפון *",
    "Phone Call Extension": "שלוחת הטלפון",
    "Phone Code": "קוד טלפון",
    "Phone Code *": "קוד טלפון *",
    "Phone Masking": "הסתרת מספר טלפון",
    "Phone No": "מספר טלפון",
    "Phone Number": "מספר טלפון",
    "Phone Numbers": "מספרי טלפון",
    "Phone Support": "תמיכה טלפונית",
    "Phone inactivity": "חוסר פעילות בטלפון",
    "Phone number": "מספר טלפון",
    "Phone number not provided": "לא סופק מספר טלפון",
    "Phone numbers": "מספרי טלפון",
    "Photo": "תמונה",
    "Photos": "תמונות",
    "Pin": "הצמד",
    "Pin Retries": "ניסיונות קוד אישי חוזרים",
    "Plan Successfully Changed": "התוכנית שונתה בהצלחה",
    "Plan upgraded": "תוכנית שודרגה",
    "Play": "נגן",
    "Play Name": "נגן שם",
    "Play sound on call connection": "נגן צליל בעת חיבור שיחה",
    "Play sound on call disconnection": "נגן צליל בעת ניתוק שיחה",
    "Play sound when the call is connected": "נגן צליל כאשר השיחה מחוברת",
    "Play sound when the call is disconnected": "נגן צליל כאשר השיחה מנותקת",
    "Please Search again": "אנא חפש שוב",
    "Please add a payment method!": "אנא הוסף אמצעי תשלום!",
    "Please add at least one node": "אנא הוסף לפחות קשר אחד",
    "Please add at least one rule": "אנא הוסף לפחות חוק אחד",
    "Please apply filters or click search to view results": "נא בחר מסננים או לחץ על חיפוש כדי להציג תוצאות",
    "Please check in to WebDialer first to make calls": "יש להתחבר ל-WebDialer לפני ביצוע שיחות",
    "Please choose a new password for your account": "אנא בחר סיסמה חדשה לחשבונך",
    "Please choose one of the methods below": "אנא בחר אחת מהשיטות למטה",
    "Please choose user or groups": "אנא בחר משתמש או קבוצות",
    "Please complete the captcha by ticking the checkbox": "אנא השלם את ה-Captcha על ידי סימון התיבה.",
    "Please describe the issue you’re encountering": "אנא תאר את הבעיה שאתה נתקל בה",
    "Please describe the issue you’re encountering.": "אנא תאר את הבעיה שאתה נתקל בה.",
    "Please enable microphone permission in order to initiate a call": "אנא אפשר הרשאת מיקרופון כדי ליזום שיחה.",
    "Please ensure the link from the email is valid": "אנא ודא שהקישור מהדוא\"ל תקין",
    "Please enter a low balance threshold amount": "אנא הכנס סכום סף למאזן נמוך",
    "Please enter a valid": "אנא הכנס {what} חוקי",
    "Please enter a valid URL": "אנא הזן כתובת URL תקפה, למשל 'https://www.example.com'",
    "Please enter a valid credit card": "אנא הכנס כרטיס אשראי בתוקף",
    "Please enter a valid email": "אנא הכנס דוא\"ל חוקי",
    "Please enter a valid email or username": "אנא הכנס דוא\"ל או שם משתמש חוקיים",
    "Please enter a valid username or email": "אנא הכנס שם משתמש או דוא\"ל חוקי",
    "Please enter an username": "אנא הכנס שם משתמש",
    "Please enter the company name": "אנא הכנס את שם החברה",
    "Please enter the subdomain": "אנא הכנס את תת-הדומיין",
    "Please enter your company address": "אנא הכנס את כתובת החברה שלך",
    "Please enter your company city": "אנא הכנס את עיר החברה שלך",
    "Please enter your company country": "אנא הכנס את ארץ החברה שלך",
    "Please enter your company postal code": "אנא הכנס את המיקוד של החברה שלך",
    "Please enter your country": "אנא הכנס את ארצך",
    "Please enter your first name": "אנא הכנס את שמך הפרטי",
    "Please enter your last name": "אנא הכנס את שם המשפחה שלך",
    "Please fill in this field": "Please fill in this field.",
    "Please fill in time row(s)": "אנא מלא שורות זמן",
    "Please indicate that you have read and agree to the Privacy Policy": "אנא ציינו שקראתם והסכמתם למדיניות הפרטיות.",
    "Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy": "אנא ציין שקראת והסכמת לתנאי השימוש ומדיניות הפרטיות",
    "Please let me know what I can help with, I’ll do my best to answer based on the documentation.": "Please let me know what I can help with, I’ll do my best to answer based on the documentation.",
    "Please log in": "אנא התחבר",
    "Please provide a valid phone number": "אנא הזן מספר טלפון תקף!",
    "Please search phone numbers": "חפש מספרי טלפון",
    "Please select a conversation": "אנא בחר שיחה",
    "Please select a role": "אנא בחר תפקיד",
    "Please select a top up amount": "אנא בחר סכום הטענה",
    "Please select a value": "אנא בחר ערך",
    "Please select an SSO service": "אנא בחר שירות SSO",
    "Please select any row first": "ראשית אנא בחר שורה",
    "Please select at least 1 user": "נא לבחור לפחות משתמש אחד",
    "Please select at least one device": "אנא בחר לפחות מכשיר אחד",
    "Please select at least one endpoint": "אנא בחר לפחות נקודת קצה אחת",
    "Please select at least one user": "אנא בחר לפחות משתמש אחד",
    "Please select destination type": "אנא בחר סוג יעד",
    "Please select the role": "אנא בחר תפקיד",
    "Please select the strategy": "אנא בחר אסטרטגיה",
    "Please select time group": "אנא בחר קבוצת זמן",
    "Please set up Two-Factor Authentication (TFA) to continue using the application": "אנא הגדר אימות דו-שלבי (TFA) כדי להמשיך להשתמש באפליקציה",
    "Please set up Two-Factor Authentication (TFA) to continue using the application Scan the QR code below using the Google Authenticator app to enhance security": "אנא הגדר אימות דו-שלבי (TFA) כדי להמשיך להשתמש באפליקציה. סרוק את קוד ה-QR למטה באמצעות אפליקציית Google Authenticator כדי להגביר את האבטחה",
    "Please set up a payment method": "אנא הגדר אמצעי תשלום!",
    "Please sign in again to resume your session": "אנא התחבר שוב כדי להמשיך את הפעילות שלך",
    "Please tell us where your company is located": "אנא ספר לנו היכן ממוקמת החברה שלך",
    "Please try again": "אנא נסה שוב.",
    "Please try again later": "אנא נסה שוב מאוחר יותר",
    "Please try different filters": "אנא נסה מסננים שונים",
    "Please verify your phone number": "אנא אמת את מספר הטלפון שלך",
    "Port-In Limit Exceeded": "כמות הניודים הגיעה למגבלה",
    "Port-In Number": "מספר יציאה",
    "Port-In Numbers": "מספר כניסה",
    "Port-in is limited to N phone numbers": "ניוד מוגדל לכמות {count} של מספרים טלפון.",
    "Port-in request Submitted": "בקשת ניוד הוגשה",
    "Position": "מיקום",
    "Position On Page": "מיקום בעמוד",
    "Post Format": "תבנית פוסט",
    "Post format": "תבנית פוסט",
    "Pre-Bridge Announcement": "הודעה לפני חיבור",
    "Pre-Bridge Announcement is required": "נדרשת הודעה לפני החיבור",
    "Predictive Auto Dialer": "חייגן אוטומטי חיזויי",
    "Prefix": "תחילית",
    "Prefix / Number": "קידומת / מספר",
    "Prefix/Number": "קידומת/מספר",
    "Premium Rate": "תעריף פרימיום",
    "Preset: Adds CODE prefix": "קביעה מראש: מוסיף תחילית {country_code}",
    "Presets": "פילטרים שמורים",
    "Prev": "הקודם",
    "Previous": "קודם",
    "Price": "מחיר",
    "Price / Seat": "מחיר / מושב",
    "Price / User": "מחיר \\ משתמש",
    "Price / user": "מחיר \\ משתמש:",
    "Price Sheet": "מחירון",
    "Privacy Policy": "מדיניות פרטיות",
    "Private": "פרטי",
    "Private contact": "איש קשר פרטי",
    "Profile Details": "פרטי פרופיל",
    "Profile updated": "הפרופיל עודכן",
    "Progressive": "פרוגרסיבי",
    "Progressive / Preview": "פרוגרסיבי \\ תצוגה מקדימה",
    "Progressive / Preview / Predictive": "מתקדם \\ תצוגה מקדימה \\ חיזויי",
    "Progressive Auto Dialer": "חייגן אוטומטי מתקדם",
    "Prorated": "יחסי",
    "Prorated Cost": "עלות יחסית",
    "Prorated Total": "סה\"כ יחסי",
    "Provide your answer here": "הזן את תשובתך כאן",
    "Province": "מחוז",
    "Provision": "הגדר",
    "Publish": "פרסם",
    "Published": "פורסם",
    "Purchase Successful": "הרכישה הצליחה",
    "Quantity": "כמות",
    "Quantity must be greater than 0": "הכמות חייבת להיות גדולה מ-0",
    "Quantity must be less than or equal to": "הכמות חייבת להיות קטנה או שווה ל",
    "Quantity must be less than or equal to stock": "הכמות חייבת להיות קטנה או שווה למלאי",
    "Question": "שאלה {number}",
    "Queue": "תור",
    "Queue Calls": "שיחות בתור",
    "Queue Membership": "חברות בתור",
    "Queue greeting": "ברכת תור",
    "Queues": "תורים",
    "Queues Report": "דו\"ח תורים",
    "Quick KPI Preview": "תצוגה מקדימה",
    "Quote": "ציטוט",
    "Random": "אקראי",
    "Range": "טווח",
    "Rate": "תעריף",
    "Rate Group": "קבוצת תעריפים",
    "Rates are displayed per minute": "התעריפים מוצגים לדקה",
    "Rates charged for making and receiving calls on this account": "התעריפים החלים על ביצוע וקבלת שיחות בחשבון זה.",
    "Raw": "ללא פורמט",
    "Read": "קראו",
    "Ready": "מוכן",
    "Ready Idle": "מוכן במצב סרק",
    "Reapply": "החל מחדש",
    "Reason for rejection": "סיבת הדחייה",
    "Reboot": "הפעל מחדש",
    "Reboot command sent": "הפקודה להפעלה מחדש נשלחה",
    "Recents": "אחרונים",
    "Record": "הקלט",
    "Record Calls": "הקלט שיחות",
    "Record again": "הקלט שוב",
    "Record calls": "הקלט שיחות",
    "Record stereo": "הקלט סטריאו",
    "Record voice note": "הקלט הודעה קולית",
    "RegExp": "RegExp",
    "Regenerate": "צור מחדש",
    "Regenerate QR Code": "צור מחדש קוד QR",
    "Regenerate hash": "Regenerate hash",
    "Regex rules": "חוקי Regex",
    "Register invite description": "תודה על קבלת ההזמנה. עזור לנו להגדיר את חשבונך.",
    "Registered": "רשום",
    "Registration Domain": "דומיין רישום",
    "Registration domain": "דומיין רישום",
    "Registration domain was copied": "דומיין רישום הועתק",
    "Regular Devices": "מכשירים רגילים",
    "Regular expression": "Regular Expression",
    "Reject delay": "השהיית דחייה",
    "Remove": "הסר",
    "Remove attachment": "הסר קובץ מצורף",
    "Removed message": "הודעה שהוסרה",
    "Rename": "שנה שם",
    "Repeat": "חזור",
    "Repeat Password": "חזור על הסיסמה",
    "Replace": "החלף",
    "Replace / Type": "החלף \\ סוג",
    "Replay audio": "השמעה מחדש של שמע",
    "Replay greeting": "נגן שוב את הברכה",
    "Reports": "דוחות",
    "Require 2FA": "דרוש אימות דו-שלבי",
    "Require 2FA description": "כאשר מופעל, המשתמש יידרש להגדיר אימות דו-שלבי בעת יצירת חשבונו.",
    "Require Two-Factor Authentication": "דרוש אימות דו-שלבי",
    "Require two-Factor Authentication for all users": "דרוש אימות דו-שלבי לכל המשתמשים",
    "Required": "נדרש",
    "Required documents": "מסמכים נדרשים",
    "Required information": "מידע נדרש",
    "Resend": "שלח מחדש",
    "Resend Code": "שלח מחדש קוד{seconds}",
    "Resend Invitation": "שלח הזמנה מחדש",
    "Resend Invitation ?": "לשלוח את ההזמנה מחדש?",
    "Resend Verification Link": "שלח מחדש קישור אימות",
    "Resend invitation description": "בשליחה מחדש, המשתמש יקבל דוא\"ל הזמנה חדש. האם אתה בטוח שברצונך לשלוח מחדש?",
    "Resend seconds": "שלח מחדש ({seconds})",
    "Reserve": "שמור",
    "Reserved: A manager adds/removes an agent from a queue that is only visible to the manager": "שמור: מנהל מוסיף/מסיר סוכן מתור שרק הוא רואה",
    "Reset Password": "אפס סיסמה",
    "Reset password": "אפס סיסמה",
    "Reset password description": "אנא בחר סיסמה חדשה עבור חשבונך.",
    "Reset password sent successfully": "איפוס הסיסמה נשלח בהצלחה.",
    "Reset your password": "אפס את הסיסמה שלך",
    "Response type": "סוג תגובה",
    "Restore DID Number": "שחזר מספר DID",
    "Restore Phone Number": "שחזור מספר טלפון",
    "Restrict Login to SSO": "הגבל התחברות ל-SSO",
    "Restrict by Countries and IP Ranges": "הגבל לפי מדינות וטווחי IP",
    "Restricted": "מוגבל",
    "Result": "תוצאה",
    "Resume": "המשך",
    "Retail": "קמעונאות",
    "Retry": "נסה שוב",
    "Return to login": "חזור להתחברות",
    "Review": "סקירה",
    "Review cart": "עגלת קניות",
    "Revoke Access": "בטל גישה",
    "Ring": "צלצול",
    "Ring & Devices": "חיוג ומכשירים",
    "Ring & Endpoints": "צלצול ונקודות קצה",
    "Ring All": "צלצל לכולם",
    "Ring Endpoint": "נקודת צלצול",
    "Ring Group": "קבוצת צלצול",
    "Ring Group name": "שם קבוצת צלצול",
    "Ring Groups": "קבוצות צלצול",
    "Ring groups": "קבוצות צלצול",
    "Ringback Tone": "צליל חיוג",
    "Ringtone": "צלצול",
    "Role": "תפקיד",
    "Roles": "תפקידים",
    "Roles & Permissions": "תפקידים והרשאות",
    "Roles available in the application": "תפקידים זמינים באפליקציה",
    "Round Robin": "מעגל עוקב",
    "Routes": "מסלולים",
    "Routing": "ניתוב",
    "Rows per page": "שורות לעמוד",
    "Rules": "חוקים",
    "Run Report": "הפעל דוח",
    "SIP Desk Phones": "טלפונים שולחניים SIP",
    "SIP Domain": "דומיין סיפ",
    "SIP Domain hint": "יש להזין בשדה Domain או Registrar בטלפון.",
    "SIP Server": "שרת סיפ",
    "SIP Server hint": "יש להזין בשדה Outbound Proxy או Server בטלפון.",
    "SIP IP": "SIP IP",
    "SLA": "SLA",
    "SLA Calls / (Total Calls - Abandoned in SLA)": "שיחות SLA / (סך כל השיחות - ננטשו ב-SLA)",
    "SLA Calls / Total Calls": "שיחות SLA / סך כל השיחות",
    "SLA Strategy": "אסטרטגיית SLA",
    "SLA Strategy Explanation": "הסבר אסטרטגיית SLA",
    "SLA formula": "נוסחת SLA",
    "SLA target": "יעד SLA",
    "SMS": "מסרון",
    "SMS Caller ID": "מזהה מתקשר למסרון",
    "SMS Forwarding": "הפניית הודעות",
    "SMS caller ID": "מזהה מתקשר למסרון",
    "SMS default sender": "מזהה שולח מסרון ברירת מחדל",
    "SMS enabled": "מספר עם SMS",
    "SMS sender names": "שמות שולחי מסרון",
    "SPI Domain": "תחום SPI",
    "STATUS": "סטטוס",
    "Same as contact info": "זהה לפרטי יצירת קשר",
    "Sample Data": "נתוני דוגמה",
    "Sat": "שבת",
    "Save": "שמור",
    "Save Contact": "שמור איש קשר",
    "Save Email": "שמור אימייל",
    "Saving...": "שומר…",
    "Say hello to your new PBX number!": "אמור שלום למספר ה-PBX החדש שלך!",
    "Scan QR code warning": "אנא אשר שסרקת את קוד ה-QR עם אפליקציית האימות שלך. תמיד תוכל להגדיר את האימות הדו-שלבי מאוחר יותר בפרופיל שלך.",
    "Scan the QR code and enter the authentication code to save": "סרוק את קוד ה-QR והזן את קוד האימות לשם שמירה",
    "Scan the QR code below using the Google Authenticator app to enhance security": "סרוק את קוד ה-QR למטה באמצעות אפליקציית Google Authenticator כדי לשפר את האבטחה.",
    "Search": "חפש",
    "Search Templates": "חפש תבניות",
    "Search by number": "Search by number",
    "Search chats or people": "חפש צ'אטים או אנשים",
    "Search templates": "חפש תבניות",
    "Search...": "חפש…",
    "Seats": "מושבים",
    "Seats Added Successfully": "מושבים נוספו בהצלחה",
    "Seats Removed Successfully": "המושבים הוסרו בהצלחה",
    "Second(s)": "שנייה(ות)",
    "Seconds": "{value} שניות",
    "Security": "אבטחה",
    "Security Email": "דוא\"ל אבטחה",
    "See QR Code": "ראה קוד QR",
    "See Requirements & Disclaimers": "ראה דרישות והסתייגויות",
    "See transcription": "צפה בתמלול",
    "Segments": "פלחים",
    "Select": "בחר",
    "Select Destination Route": "בחר נתיב יעד",
    "Select Greeting": "בחר ברכה",
    "Select Number": "בחר מספר",
    "Select Role": "בחר תפקיד",
    "Select Site": "בחר אתר",
    "Select Statuses": "בחר סטטוסים",
    "Select Strategy": "בחר אסטרטגיה",
    "Select a chat to start messaging": "בחר צ'אט כדי להתחיל לשלוח הודעות",
    "Select a question": "בחר שאלה",
    "Select a service to save the settings": "Select a service to save the settings.",
    "Select a template": "בחר תבנית",
    "Select call type": "בחר סוג שיחה",
    "Select country": "בחר ארץ",
    "Select date": "בחר תאריך",
    "Select date to simulate": "בחר תאריך להדמיה",
    "Select days": "בחר ימים",
    "Select destination": "בחר יעד",
    "Select inbox": "בחר תיבת דואר נכנס",
    "Select industry": "בחר תעשייה",
    "Select join option": "בחר אפשרות הצטרפות",
    "Select language": "בחר שפה",
    "Select or Create Labels": "בחר או צור תוויות",
    "Select rate sheet": "בחר מחירון",
    "Select state": "בחר מדינה",
    "Select type": "בחר סוג",
    "Selected": "נבחר",
    "Send": "שלח",
    "Send Code": "שלח קוד",
    "Send Code Via SMS": "שלח קוד ב-SMS",
    "Send Code Via WhatsApp": "שלח קוד בוואטסאפ",
    "Send From:": "שלח מאת:",
    "Send Invitation Right Away": "שלח הזמנה מיד",
    "Send Invite": "שלח הזמנה",
    "Send Reset Password": "שלח איפוס סיסמה",
    "Send SMS": "שלח SMS",
    "Send Template": "שלח תבנית",
    "Send a message to start the conversation.": "שלח הודעה כדי להתחיל את השיחה.",
    "Send an SMS starting at": "שלח SMS במחיר התחלתי של",
    "Send code in Email": "שלח קוד בדוא\"ל",
    "Send code in email": "שלח קוד בדוא\"ל",
    "Send recovery email": "שלח דוא\"ל שחזור",
    "Send test email": "שלח דוא\"ל בדיקה",
    "Send to queue": "שלח לתור",
    "Send, receive messages and keep all conversations in one place.": "שלח, קבל הודעות ושמור את כל השיחות במקום אחד.",
    "Sending Rate": "Sending Rate",
    "Sending SMS in the US & Canada": "שליחת סמס בארה\"ב ובקנדה",
    "Sending…": "שולח…",
    "Sent Count": "מספר שליחות",
    "Sequentially By Agent Order": "לפי סדר סוכנים",
    "Sequentially By Next Agent Order": "לפי סדר הסוכן הבא",
    "Service Level Agreement (SLA)": "הסכם רמת שירות (SLA)",
    "Service level for a selected strategy": "רמת שירות לאסטרטגיה נבחרת",
    "Session": "הפעלה",
    "Session time": "זמן הפעלה",
    "Set New Password": "הגדר סיסמה חדשה",
    "Set Up 2FA": "הגדר אימות דו-שלבי",
    "Set Up Two-Factor Authentication": "הגדר אימות דו-שלבי",
    "Set by agent": "נקבע על ידי סוכן",
    "Set password expiration": "הגדר תפוגת סיסמה",
    "Set the group members who will receive calls when they ring for another user in the group": "הגדר את חברי הקבוצה שיקבלו שיחות כאשר הן מצלצלות למשתמש אחר בקבוצה.",
    "Set up later": "הגדר מאוחר יותר",
    "Set up your Two-Factor Authentication": "הגדר את האימות הדו-שלבי שלך",
    "Set your password": "הגדר את הסיסמה שלך",
    "Settings": "הגדרות",
    "Settings applied to the whole account": "הגדרות החלות על החשבון כולו",
    "Setup": "התקנה",
    "Setup Your new password": "הגדר את הסיסמה החדשה שלך",
    "Setup cost": "מחיר התקנה",
    "Setup your security questions": "הגדר את שאלות האבטחה שלך",
    "Should be a number": "{field} צריך להיות מספר",
    "Should be a number between": "צריך להיות מספר בין {min} ל-{max}",
    "Should be a number with max digits": "צריך להיות מספר עם מקסימום {digits} ספרות",
    "Show Deactivated Users": "הצג משתמשים מושבתים",
    "Show Draft Users": "הצג משתמשים בטיוטה",
    "Show Estimated Wait Time": "הצג זמן המתנה משוער",
    "Show Invited Users": "הצג משתמשים מוזמנים",
    "Show Welcome Message After": "הצג הודעת ברכה לאחר",
    "Show filters": "הצג מסננים",
    "Show password": "הצג סיסמה",
    "Sign Up": "הירשם",
    "Sign Up Verify email subtitle": "שמור על החשבון שלך מאובטח ואמת את הדוא\"ל שלך. אנא הזן את הקוד שנשלח ל-{email}",
    "Sign Up and Start Calling": "הירשם והתחל להתקשר",
    "Sign up with Google": "הירשם באמצעות גוגל",
    "Sign up with Microsoft": "הירשם עם מיקרוסופט",
    "Simulate password expiration": "הדמיית תפוגת סיסמה",
    "Simultaneous": "בו-זמני",
    "Simultaneous Calls": "Simultaneous Calls",
    "Simultaneous Calls count": "{count} שיחות סימולטניות",
    "Simultaneous calls": "שיחות בו זמנית",
    "Single File": "קובץ בודד",
    "Single Sign-On (SSO)": "כניסה אחת (SSO)",
    "Sip term status": "סטטוס Sip",
    "Sites": "אתרים",
    "Skip": "דלג",
    "Skip Tiers with no Available Agents": "דלג על רמות ללא סוכנים זמינים",
    "Skip Voicemail Operation Instructions": "דלג על הוראות הפעלת תא קולי",
    "Skip greeting": "דלג על הפתיח",
    "Skip if variable is empty": "דלג אם המשתנה ריק",
    "Skip levels with no available agents": "דלג על שלבים ללא סוכנים זמינים",
    "Snooze": "נמנום",
    "Some SBC hubs are unreachable; calls still route but redundancy is degraded": "חלק מצומתי ה-SBC אינם זמינים; השיחות עדיין מנותבות אך היתירות פגומה",
    "Some files were skipped because they": "חלק מהקבצים דולגו מכיוון ש",
    "Some unsupported files were skipped": "כמה קבצים שאינם נתמכים הושמטו",
    "Some unsupported files were skipped.": "כמה קבצים שאינם נתמכים הושמטו.",
    "Something went wrong": "משהו השתבש.",
    "Something went wrong, please try again": "משהו השתבש, אנא נסה שוב",
    "Sorry, the page you're looking for cannot be found": "מצטערים, הדף שאתה מחפש לא נמצא",
    "Sort": "מיין",
    "Sound": "צליל",
    "Sources:": "Sources:",
    "Spanish": "ספרדית",
    "Special characters (!@#$%^&*_-)": "תווים מיוחדים (!@#$%^&*_-)",
    "Special permissions": "הרשאות מיוחדות",
    "Specific exit destinations": "יעדי יציאה ספציפיים",
    "Speech": "דיבור",
    "Spy message": "הודעת ריגול",
    "Standard": "רגיל",
    "Standard Business Hours": "שעות עסקים סטנדרטיות",
    "Standard DID": "חי\"פ רגיל",
    "Standard Rate": "תעריף סטנדרטי",
    "Start Chat": "התחל צ'אט",
    "Start Date": "תאריך התחלה",
    "Start conversation": "התחל שיחה",
    "Start registration": "החל תהליך רישום",
    "Start time": "שעת התחלה",
    "Start topping up when the balance falls below this threshold": "התחל לטעון כאשר היתרה יורדת מתחת לסף זה",
    "Start-up": "סטארט-אפ",
    "State": "מדינה",
    "State / Province": "מדינה \\ מחוז",
    "Stats": "סטטיסטיקות",
    "Status": "סטטוס",
    "Status name": "שם הסטטוס",
    "Stereo playback": "השמעה סטריאו",
    "Sticker": "מדבקה",
    "Stock": "מלאי",
    "Stop": "עצור",
    "Stop Rule": "עצור חוקיות",
    "Storage": "אחסון",
    "Strategy": "אסטרטגיה",
    "Street Address": "כתובת רחוב",
    "Street Address *": "כתובת רחוב *",
    "Stripe verification": "אנו משתמשים ב-Stripe Identity לאימות הזהות שלך. אנא לחץ על הכפתור למטה כדי להתחיל בתהליך.",
    "Subdomain can only contain lower case letters and numbers": "תת-הדומיין יכול להכיל רק אותיות קטנות באנגלית ומספרים",
    "Subdomain must be at least 3 characters": "תת-הדומיין חייב להיות לפחות 3 תווים",
    "Subject": "נושא",
    "Submit": "שלח",
    "Submit Port-In Request": "הגשת בקשת העברה",
    "Subscription Plan": "תוכנית מנוי",
    "Subscription upgraded to": "המנוי שודרג ל{שם}",
    "Subscriptions": "מנויים",
    "Success": "הצלחה",
    "Suffix": "סיומת",
    "Suite": "מספר",
    "Sun": "ראשון",
    "Supervisor": "מפקח",
    "Support Email": "דוא\"ל תמיכה",
    "Support availability": "זמינות תמיכה",
    "Support channels": "ערוצי תמיכה",
    "Support channels available to each plan": "ערוצי התמיכה הזמינים לכל תוכנית.",
    "Supported formats": "פורמטים נתמכים",
    "Supported: pdf, docx, jpg, png, mp4, mov": "נתמך: pdf, docx, jpg, png, mp4, mov",
    "Supported: pdf, docx, jpg, png, mp4, mov.": "נתמך: pdf, docx, jpg, png, mp4, mov.",
    "Supports incoming SMS messages": "תומך בהודעות סמס נכנסות",
    "Supports outgoing SMS messages": "תומך בהודעות סמס יוצאות",
    "Synced {count} template(s) from Meta": "סונכרנו {count} תבנית/ות מ-Meta",
    "System": "מערכת",
    "System wait time for caller input, before prompting for next action": "זמן ההמתנה של המערכת להזנת קלט מהמתקשר, לפני מעבר לפעולה הבאה.",
    "TFA Code Incorrect": "קוד אימות שהוזן שגוי. אנא בדוק והזן מחדש סיסמה חד פעמית.",
    "Tags": "תגיות",
    "Take": "קח",
    "Talk": "שיחה",
    "Talk time": "זמן דיבור",
    "Target": "יעד",
    "Target balance": "יתרת יעד",
    "Team": "צוות",
    "Team Leader": "ראש צוות",
    "Team Size": "גודל צוות",
    "Teams": "צוותים",
    "Technical Support Specialist": "מומחה טכני",
    "Technologies used in call centers to manage incoming calls and connect them with the most appropriate agent": "טכנולוגיות המשמשות מוקדי טלפון לניהול שיחות נכנסות ולחיבורן לסוכן המתאים ביותר.",
    "Technology": "טכנולוגיה",
    "Tell us a bit about your company": "ספר לנו קצת על העסק שלך",
    "Tell us a bit more about your company": "ספר לנו עוד קצת על החברה שלך",
    "Template": "תבנית",
    "Template deleted successfully": "התבנית נמחקה בהצלחה",
    "Template updated successfully": "התבנית עודכנה בהצלחה",
    "Templates": "תבניות",
    "Testing area": "אזור בדיקה",
    "Text color is used for the text and logo.": "Text color is used for the text and logo.",
    "Text is required for this type of media file": "נדרש טקסט לסוג זה של קובץ מדיה",
    "Text to speech": "טקסט לדיבור",
    "Thank you": "תודה",
    "Thanks for you order, your DID numbers have been added to the list": "תודה על ההזמנה שלך, מספרי ה-חי\"פ נוספו לרשימה.",
    "Thanks for you order, your phone numbers have been added to the list": "תודה על ההזמנה שלך, מספרי הטלפון שלך נוספו לרשימה.",
    "The \"Increment” defines\" the time units, also in seconds, used for billing after the initial segment": "ה-“Increment” מגדיר את יחידות הזמן, גם בשניות, בהן נעשה שימוש לצורך חיוב לאחר הקטע ההתחלתי",
    "The \"Initial Increment\" refers to the minimum time billed for the first segment of an inbound call, usually in seconds": "ה-“Initial Increment” מתייחס לזמן המינימלי שיחויב עבור הקטע הראשון של שיחה נכנסת, בדרך כלל בשניו.",
    "The 24-hour WhatsApp conversation window has expired. You can only send a pre-approved template message.": "חלון השיחה של 24 שעות בוואטסאפ פג. ניתן לשלוח רק הודעת תבנית מאושרת מראש.",
    "The Date From must be before the Date To": "התאריך מ- חייב להיות לפני התאריך ל-.",
    "The Number has been Successfully Cancelled": "המספר בוטל בהצלחה",
    "The Number has been Successfully Restored": "המספר שוחזר בהצלחה",
    "The Time To must be later than the Time From": "הזמן ל- חייב להיות מאוחר יותר מהזמן מ-.",
    "The account password has been updated": "סיסמת החשבון עודכנה.",
    "The amount of time allotted for an agent to answer a call, before it's transferred to another agent": "משך הזמן המוקצב לסוכן לענות לשיחה, לפני שהיא מועברת לסוכן אחר.",
    "The card ending in <b>{last4}</b> will be charged for the prorated amount": "הכרטיס שמסתיים ב-<b>{last4}</b> יחויב בסכום היחסי.",
    "The card ending in will be charged for this amount": "הכרטיס המסתיים ב-{last4} יחויב בסכום זה.",
    "The code is invalid, please try again": "הקוד אינו תקף, אנא נסה שוב.",
    "The cost per minute of inbound calls on this phone number": "העלות לדקה עבור שיחות נכנסות למספר טלפון זה",
    "The destination the call will be directed to, if any thresholds or limits are exceeded": "היעד אליו תנותב השיחה, אם יחרגו כל ספים או מגבלות",
    "The email 2FA has been successfully updated": "האימות הדו-שלבי באימייל עודכן בהצלחה",
    "The email has already been taken": "האימייל כבר נמצא בשימוש",
    "The end date must be after the start date": "תאריך הסיום חייב להיות לאחר תאריך ההתחלה.",
    "The expected level of service for a queue defined by the strategy and target interval": "רמת השירות הצפויה עבור תור מוגדרת על ידי האסטרטגיה והמרווח היעד",
    "The inbox is currently empty.": "תיבת הדואר הנכנס ריקה כעת.",
    "The interval when support channels are available": "הפרקי זמן שבו ערוצי התמיכה זמינים.",
    "The invoice history for your subscription plan, top-ups, and DID numbers": "היסטוריית החשבוניות של תוכנית המנוי שלך, הטענות ומספרי DID",
    "The invoice history for your subscription plan, top-ups, and phone numbers": "היסטוריית החשבוניות עבור תוכנית המנוי שלך, טעינות ומספרי טלפון",
    "The link is valid for 24 hours": "הקישור תקף ל-24 שעות",
    "The max number of times without any selection before the call is directed to the exit destination": "מספר הפעמים המקסימלי ללא כל בחירה לפני שהשיחה מנותבת ליעד היציאה",
    "The maximum amount of time a caller waits when no agents are available before being directed to the exit destination": "משך הזמן המרבי שמתקשר ממתין כאשר אין סוכנים זמינים לפני שהוא מופנה ליעד יציאה.",
    "The maximum length of this field": "האורך המרבי לשדה זה הוא {number}",
    "The maximum length of this field is 6": "האורך המרבי של שדה זה הוא 6",
    "The maximum number of times a caller can make an invalid input before being directed to the exit destination": "מספר הפעמים המקסימלי שמתקשר יכול להזין קלט לא חוקי לפני שיועבר ליעד היציאה.",
    "The media I upload, where it is used?": "המדיה שאני מעלה, היכן היא משמשת?",
    "The minimum billable call duration (in seconds) and the increment used for billing": "משך השיחה המינימלי לחיוב (בשניות) והמרווח המשמש לחיוב",
    "The minimum commitment duration for which the DID number must be purchased": "משך ההתחייבות המינימלי שבו יש לרכוש את מספר ה-DID",
    "The minimum commitment duration for which the phone number must be purchased": "משך ההתחייבות המינימלי שבו יש לרכוש את מספר הטלפון",
    "The minimum cost per inbound call on this DID number": "העלות המינימלית לשיחה נכנסת על מספר ה-DID הזה",
    "The minimum cost per inbound call on this phone number": "העלות המינימלית לשיחה נכנסת למספר טלפון זה",
    "The minimum length for this field should be": "האורך המינימלי לשדה זה צריך להיות {value}",
    "The new plan has been added to your account": "התוכנית החדשה נוספה לחשבונך",
    "The new settings have been successfully saved.": "ההגדרות החדשות נשמרו בהצלחה.",
    "The number below must be dialed within two minutes to complete the check-in process": "יש לחייג את המספר הבא תוך שתי דקות להשלמת תהליך הצ'ק-אין",
    "The number of seats can’t be lower than the active and invited users in the account.": "מספר המושבים אינו יכול להיות נמוך ממספר המשתמשים הפעילים והמוזמנים בחשבון.",
    "The number of times a caller can press a wrong option before being directed to the exit destination": "מספר הפעמים שמתקשר יכול ללחוץ על אפשרות שגויה לפני שהוא מופנה ליעד היציאה",
    "The numbers will be activated after review and approval": "המספרים יופעלו לאחר בדיקה ואישור",
    "The password contains unsupported symbols": "הסיסמה מכילה סימנים שאינם נתמכים",
    "The password has been reset successfully": "הסיסמה אופסה בהצלחה",
    "The password must meet all requirements": "הסיסמה חייבת לעמוד בכל הדרישות.",
    "The pause between digit inputs should be less than this value": "ההפסקה בין קלטי הספרות צריכה להיות פחות מערך זה",
    "The phone has already been taken": "הטלפון כבר נמצא בשימוש",
    "The phone number is not valid": "מספר הטלפון אינו תקין.",
    "The reset will happen next time the member logs in": "האיפוס יתרחש בפעם הבאה שהחבר יתחבר",
    "The selected amount will not be enough to cover the low balance threshold": "הסכום שנבחר לא יספיק לכסות את סף היתרה הנמוכה.",
    "The session is now closed": "הסשן נסגר כעת",
    "The shortest duration of a call that will be billed, measured in seconds, for which billing is charged when a phone number is used for calls": "משך השיחה הקצר ביותר שיחויב, נמדד בשניות, אשר מחויב כאשר נעשה שימוש במספר טלפון לשיחות",
    "The sound an agent hears while waiting for the person they are calling to answer": "הצליל שסוכן שומע בזמן שהוא ממתין לתשובה של האדם אליו הוא מתקשר",
    "The system will automatically dial numbers from uploaded list and connect leads with agents": "המערכת תחייג באופן אוטומטי את המספרים מרשימת הקבצים המועלה ותתחבר עם סוכני המכירו.",
    "The time an agent has to answer a call before it’s transferred to another agent": "משך הזמן שיש לסוכן לענות לשיחה לפני שהיא מועברת לסוכן אחר.",
    "The type of destination the call will be directed to": "סוג היעד אליו תנותב השיחה",
    "The uploaded file is not an audio file": "הקובץ שהועלה אינו קובץ שמע.",
    "The uploaded file is not an image": "הקובץ שנבחר אינו תמונה. אנא העלה קובץ תמונה תקין.",
    "The user has been created": "המשתמש נוצר",
    "The user has been notified via email at": "המשתמש קיבל התראה בדואר אלקטרוני ב-{email}.",
    "The user has been notified via email at ": "המשתמש קיבל התראה בדוא\"ל שנשלחה לכתובת: {email}.",
    "The username and password are automatically generated Use them to connect your phone": "שם המשתמש והסיסמה נוצרים אוטומטית. השתמש בהם כדי לחבר את הטלפון שלך.",
    "The uuid was copied:": "ה-uuid הועתק:",
    "Theme": "נושא",
    "There are no available DID for selected country": "אין מספרי טלפון זמינים עבור הארץ שנבחרה",
    "There can be only one active session": "רק חיבור פעיל אחד רשאי באותה עת",
    "There is already an account with this email address": "כבר קיים חשבון עם כתובת האימייל הזו",
    "There was a problem retrieving the numbers": "הייתה בעיה באחזור המספרים",
    "There's no transcription available for this call.": "אין תמלול זמין לשיחה זו.",
    "This amount represents the fee incurred for receiving calls on this number, measured in cost per minute": "סכום זה מייצג את דמי הקבלה עבור קבלת שיחות על מספר זה, הנמדדים כעלות לכל דקה",
    "This balance is available for making phone calls": "יתרה זו זמינה לביצוע שיחות טלפון",
    "This chat is currently active with {name}.": "הצ'אט פעיל כעת עם {name}.",
    "This conversation is blocked because this number cannot send SMS.": "שיחה זו חסומה מכיוון שמספר זה אינו יכול לשלוח SMS.",
    "This day": "היום",
    "This file format is not supported": "פורמט הקובץ הזה אינו נתמך",
    "This file format is not supported.": "פורמט הקובץ הזה אינו נתמך.",
    "This file is too large and is not supported.": "הקובץ גדול מדי ואינו נתמך.",
    "This file was blocked for security reasons.": "קובץ זה נחסם מסיבות אבטחה.",
    "This inbox doesn’t have a phone number linked yet. Please contact your administrator or link a number to enable messaging.": "לתיבת דואר זו עדיין אין מספר טלפון מקושר. אנא פנה למנהל המערכת או קשר מספר כדי לאפשר התכתבות.",
    "This is the URL assigned to your account": "זוהי כתובת אתר ה- PBX שתוקצה לחשבון שלך",
    "This is the password used to log into this account": "זו הסיסמה המשמשת להתחברות לחשבון זה.",
    "This list includes all numbers in your account, where you can view details and define call routing for each number.": "רשימה זו כוללת את כל המספרים בחשבון שלך, שם תוכל לצפות בפרטים ולהגדיר ניתוב שיחות עבור כל מספ.",
    "This member will need to change their password next time he logs into the app": "חבר זה יצטרך לשנות את הסיסמה בפעם הבאה שיתחבר לאפליקציה",
    "This message shows up in a bubble above the widget icon, after the delay set here.": "This message shows up in a bubble above the widget icon, after the delay set here.",
    "This month": "החודש",
    "This option is not available yet": "אפשרות זו עדיין אינה זמינה",
    "This name is already in use": "שם זה כבר בשימוש",
    "This number will be removed on <b>{date}</b> if cancellation is not aborted": "מספר זה יוסר ב-<b>{date}</b> אם הביטול לא ייעצר",
    "This period represents the shortest time frame (usually in months) that you are required to pay for and keep the number active": "תקופה זו מייצגת את פרק הזמן הקצר ביותר (בדרך כלל בחודשים) שעליך לשלם עבורו ולשמור על המספר פעי",
    "This queue not available for this Agent": "התור הזה אינו זמין לסוכן זה",
    "This represents the number of users available in the current plan minus total number of account users (in any status)": "זה מייצג את מספר המשתמשים הזמינים בתוכנית הנוכחית פחות מספר המשתמשים הכולל בחשבון (בכל סטטוס)",
    "This value is already taken": "ערך זה כבר בשימוש",
    "This week": "השבוע",
    "This will allow the user to set a new password": "פעולה זו תאפשר למשתמש להגדיר סיסמה חדשה.",
    "This will also remove your current auto top-up": "פעולה זו תסיר גם את התשלום האוטומטי הנוכחי שלך",
    "This will send verification code to saved mobile": "זה ישלח קוד אימות למכשיר הנייד השמור",
    "This will send verification code to the saved e-mail": "זה ישלח קוד אימות לדוא\"ל השמור",
    "Threshold": "סף",
    "Thresholds": "ספים",
    "Thu": "יום ד'",
    "Tier": "רמה",
    "Tier Rules Apply": "כללי רמות חלים",
    "Tier rules": "חוקיות רמה",
    "Tier wait time": "זמן המתנה לרמה",
    "Time": "זמן",
    "Time Condition": "שעות פעילות",
    "Time Conditions": "שעות פעילות",
    "Time Format": "פורמט זמן",
    "Time Groups": "קבוצות זמן",
    "Time allocation": "הקצאת זמן",
    "Time base score": "ציון מבוסס זמן",
    "Time condition": "שעות פעילות",
    "Time condition name": "שם שעות פעילות",
    "Time conditions": "שעות פעילות",
    "Time from": "שעה מ",
    "Time group": "קבוצת זמן",
    "Time groups": "קבוצות זמן",
    "Time interval in which no option has been pressed": "מרווח זמן בו לא נלחצה אף אפשרות",
    "Time intervals, measured in seconds, used to calculate the duration of a phone call for billing purposes": "מרווחי זמן, הנמדדים בשניות, המשמשים לחישוב משך השיחה לצורכי חיוב",
    "Time left": "זמן שנותר",
    "Time limit": "מגבלת זמן",
    "Time to": "שעה עד",
    "Timeout": "פסק זמן",
    "Timeout destination": "יעד פסק זמן",
    "Timeouts": "פסקי זמן",
    "Times": "זמנים",
    "Timezone": "אזור זמן",
    "Title": "כותרת",
    "To": "אל",
    "To be implemented": "ליישום",
    "To check-in to the dialer select the device type and follow the prompts.": "כדי לבצע צ'ק-אין למערכת החיוג, בחר את סוג המכשיר ופעל לפי ההוראות.",
    "To start monitoring, your current call will be ended.": "כדי להתחיל לנטר, השיחה הנוכחית שלך תסתיים.",
    "To:": "אל:",
    "Today": "היום",
    "Toggle": "החלף",
    "Top Down": "מלמעלה למטה",
    "Top up amount": "סכום הטענה",
    "Top-up": "תשלום",
    "Top-up now": "שלם כעת",
    "Top-up successful": "שולם בהצלחה",
    "Total": "סה\"כ",
    "Total Cost": "עלות כוללת",
    "Total Live Calls": "סה\"כ שיחות חיות",
    "Total Talk": "שיחה כוללת",
    "Total agents": "סה\"כ סוכנים",
    "Total calls": "סך כל השיחות",
    "Total daily activity time, encompassing all active, idle and pause periods": "סה\"כ זמן הפעילות היומי, הכולל את כל תקופות הפעילות, זמן הסרק וההפסקות",
    "Total daily pause duration, including both billable and non-billable pauses": "סה\"כ משך הפסקות יומי, כולל הפסקות לחיוב והפסקות שאינן לחיוב",
    "Total duration of ring time while attempting to contact customers": "סה\"כ משך זמן הצלצול בעת ניסיון ליצור קשר עם לקוחות",
    "Total file size must be under 10MB": "סך גודל הקובץ חייב להיות מתחת ל-10MB",
    "Total file size must be under 15MB": "סך גודל הקובץ חייב להיות מתחת ל-15MB.",
    "Total number of calls": "סך כל השיחות",
    "Total talk time": "Total talk time",
    "Total time": "זמן כולל",
    "Total time the user was neither on the phone nor paused": "סה\"כ הזמן שבו המשתמש לא היה בטלפון ולא בהפסקה",
    "Total wait time": "סה\"כ זמן המתנה",
    "Transcription Unavailable": "תמלול לא זמין",
    "Transcription generation has started.": "יצירת התמלול החלה.",
    "Transcription in progress": "תמלול בתהליך",
    "Transcription unavailable": "תמלול לא זמין",
    "Transfer": "העבר",
    "Transfer to inbox": "העבר לתיבת דואר",
    "Transfer to user": "העבר למשתמש",
    "Travel and Hospitality": "נסיעות ואירוח",
    "Trusted devices": "מכשירים מהימנים",
    "Try using different keywords.": "נסה להשתמש במילות מפתח אחרות.",
    "Tue": "יום ב'",
    "Two factor authentication": "אימות דו-שלבי",
    "Two-Factor Authentication": "אימות דו-שלבי",
    "Two-Factor Authentication Required": "דרוש אימות דו-שלבי",
    "Two-Factor Authentication updated": "אימות דו-שלבי עודכן",
    "Type": "סוג",
    "Type Email": "הקלד דוא\"ל",
    "Type a phone number or select from contacts": "הקלד מספר טלפון או בחר מאנשי קשר",
    "Type city": "הקלד עיר",
    "Type email": "הקלד דוא\"ל",
    "Type name": "הקלד שם",
    "Type notes": "הקלד הערות",
    "Type placeholder": "הזן {what}",
    "UI inactivity": "חוסר פעילות בממשק המשתמש",
    "UNVERIFIED": "לא מאומת",
    "UPDATE SEATS IN PLAN": "עדכן מושבים בתוכנית",
    "URL": "כתובת URL",
    "URL:": "כתובת אתר: {url}",
    "UUID": "UUID",
    "UUID Copied": "UUID הועתק",
    "Unable to process your request": "לא ניתן לעבד את הבקשה שלך",
    "Unable to process your request. Please try again later.": "Unable to process your request. Please try again later.",
    "Unanswered": "ללא מענה",
    "Unassigned": "לא משויך",
    "Unavailable while account is under review": "לא זמין בזמן שהחשבון בבדיקה",
    "Unique calls": "שיחות ייחודיות",
    "Unit Cost": "עלות ליחידה",
    "Unknown": "לא ידוע",
    "Unlimited": "ללא הגבלה",
    "Unlimited DID Channels": "ערוצי חי\"פ ללא הגבלה",
    "Unlimited Simultaneous Calls": "שיחות סימולטניות ללא הגבלה",
    "Unlimited Users": "משתמשים ללא הגבלה",
    "Unmute": "בטל השתקה",
    "Unpin": "בטל הצמדה",
    "Unsupported file format": "פורמט קובץ לא נתמך",
    "Up To Users": "עד {count} משתמשים",
    "Update": "עדכן",
    "Update media file": "עדכן קובץ מדיה",
    "Upgrade plan": "שדרג תוכנית",
    "Upload": "העלה",
    "Upload failed due to a network error, please try again.": "ההעלאה נכשלה בשל שגיאת רשת, אנא נסה שוב.",
    "Upload logo": "העלה לוגו",
    "Upon call answer, a voice recording is played to the agent before connecting to the caller": "בעת מענה לשיחה, הקלטת קול מנוגנת לסוכן לפני חיבור המתקשר",
    "Uppercase letters (A-Z)": "אותיות גדולות באנגלית (A-Z)",
    "Use Authentication app to generate code": "השתמש באפליקציית אימות ליצירת קוד",
    "Use Google Authenticator or another app": "השתמש ב-Google Authenticator או באפליקציה אחרת",
    "Use Google Authentificator": "השתמש במאמת של גוגל",
    "Use Google authentificator to generate code": "השתמש במאמת של גוגל ליצירת קוד",
    "Use the code sent to your email address {email}": "השתמש בקוד שנשלח לכתובת הדוא\"ל שלך {email}",
    "Used by": "בשימוש על ידי",
    "User": "משתמש",
    "User Login": "התחברות משתמש",
    "User Name": "שם משתמש",
    "User Pin": "קוד משתמש",
    "User Profile Edit": "עריכת פרופיל משתמש",
    "User agent": "סוכן משתמש",
    "User created": "משתמש נוצר",
    "User group": "קבוצת משתמשים",
    "User groups": "קבוצות משתמשים",
    "User has been successfully logged out": "המשתמש נותק בהצלחה",
    "User password will be invalidated and a link to set a new password will be sent to the verified user Email and/or Phone": "הסיסמה של המשתמש תבוטל וקישור להגדרת סיסמה חדשה יישלח למייל ו/או לטלפון המאומת של המשתמש",
    "User profile added successfully.": "פרופיל המשתמש נוסף בהצלחה.",
    "User profile created. Invitation not sent yet.": "פרופיל המשתמש נוצר. ההזמנה טרם נשלחה.",
    "User type": "סוג משתמש",
    "Username": "שם משתמש",
    "Username *": "שם משתמש *",
    "Username was copied": "שם המשתמש הועתק",
    "Users": "משתמשים",
    "Users & Roles": "משתמשים ותפקידים",
    "Users & Roles description": "רשימה של משתמשים לחשבון זה והתפקידים שהוקצו להם.",
    "Users / Devices": "משתמשים / מכשירים",
    "Users / Endpoints": "משתמשים \\ נקודות קצה",
    "Users has been successfully logged out": "המשתמשים נותקו בהצלחה",
    "Users override": "עקיפת משתמשים",
    "Usually contains a welcome message and instructions": "בדרך כלל מכיל הודעת ברכה והוראות",
    "Usually it will contain a welcome message and instructions": "לרוב יכיל הודעת פתיחה והוראות",
    "Usually, it repeats instructions, but without the welcome message": "בדרך כלל, הוא חוזר על ההוראות, אך ללא הודעת הברכה",
    "Uuid": "Uuid",
    "VAT number": "מספר מע\"מ",
    "VAT number (optional)": "מספר מע\"מ (אופציונלי)",
    "VERIFIED": "מאומת",
    "Value": "ערך",
    "Value is required": "יש להזין ערך",
    "Value should start with": "הערך צריך להתחיל ב-$",
    "Variable": "משתנה",
    "Variable '{name}' already in use": "המשתנה '{name}' כבר בשימוש",
    "Variable name cannot be longer than 50 characters.": "שם המשתנה לא יכול להיות ארוך מ-50 תווים.",
    "Variable name must consist of English letters and numbers, and cannot begin with a number.": "שם המשתנה חייב להיות מורכב מאותיות באנגלית ומספרים, ואינו יכול להתחיל במספר.",
    "Verification code expired": "קוד האימות פג תוקף. אנא בקש קוד חדש.",
    "Verified": "מאומת",
    "Verify Email": "אמת דוא\"ל",
    "Verify Mobile": "אמת טלפון נייד",
    "Web device": "מכשיר רשת",
    "Wrap up time (queue)": "זמן ניירת (תור)",
    "Wrap up time (outbound)": "זמן ניירת (שיחות יוצאות)",
    "Web Phone": "חייגן דפדפן",
    "months": "{number} חודשים",
    "Web Domain": "דומיין",
    "ZIP / Postal code": "מיקוד",
    "Website": "אתר אינטרנט",
    "is too long": "{what} ארוך מדי",
    "We will soon be rolling out PBX, which is currently in its final stages of development": "בקרוב נשיק את PBX, שנמצא כעת בשלבים האחרונים של הפיתוח",
    "We value your interest and are eager to share it with you!": "אנו מעריכים את העניין שלך ונרגשים לחלוק אותו איתך!",
    "You may enter multiple Emails, separated by Comma": "אתה יכול להזין מספר דוא\"לים, מופרדים בפסיק",
    "Voice Only Destinations": "יעדי קול בלבד",
    "Voice with Fax Detection": "קול עם זיהוי פקס",
    "Virtual": "וירטואלי",
    "Visa": "ויזה",
    "Voice": "קול",
    "Voice is required": "נדרש קול",
    "Voice recording": "הקלטה קולית",
    "Voicemail": "תא קולי",
    "Voicemail description": "ניהול רשימת הודעות הקול.",
    "Wait": "המתן",
    "Wait moderator": "המתן למארח",
    "Waiting calls": "שיחות ממתינות",
    "Wallboard": "לוח מחוונים",
    "Wallboard saved successfully": "לוח התצוגה נשמר בהצלחה",
    "Wallboards": "לוחות תצוגה",
    "Warning": "אזהרה",
    "We need a few details to set up your account": "אנחנו צריכים כמה פרטים כדי להגדיר את החשבון שלך",
    "We use encryption to make sure your calls stay private": "אנו משתמשים בהצפנה כדי להבטיח שהשיחות שלך יישארו פרטיות.",
    "We've automatically logged you out due to inactivity to safeguard your account": "ניתקנו אותך אוטומטית עקב חוסר פעילות כדי להגן על החשבון שלך",
    "We've sent you a SMS with verification code": "שלחנו לך מסרון עם קוד אימות",
    "We've sent you an SMS with a verification code": "שלחנו לך הודעת SMS עם קוד אימות",
    "We've sent you an email with a verification code": "שלחנו לך אימייל עם קוד אימות",
    "We've sent you an email with further instructions": "שלחנו לך דוא\"ל עם הוראות נוספות",
    "We've sent you an email with verification code": "שלחנו לך דוא\"ל עם קוד אימות",
    "Web Devices": "מכשירים רשתיים",
    "Web Widget Builder": "בונה וידג'ט האתר",
    "Web phone": "טלפון אינטרנטי",
    "WebDialer is not properly initialized": "WebDialer לא אותחל כראוי",
    "Webhook notifications": "התראות אירועים",
    "Webphone": "חייגן דפדפן",
    "Webphone Number Format": "פורמט מספר",
    "Wed": "רביעי",
    "Week count": "{count} שבוע",
    "Welcome Message": "הודעת ברכה",
    "Welcome,": "ברוך הבא,",
    "We’ll send financial notifications to the email below": "נשלח הודעות פיננסיות לדוא\"ל שלהלן.",
    "What  is an Auto Attendant?": "מהו אוטומט אדמין (Auto Attendant)?",
    "What are KPIs, and how can I set them for my call reports?": "מהם KPI's וכיצד אני יכול להגדיר אותם עבור דוחות השיחה שלי?",
    "What are announcements, and how can they help me communicate with my callers?": "מהן הודעות, ואיך הן יכולות לעזור לי לתקשר עם המתקשרים שלי?",
    "What are contacts?": "מה הם אנשי קשר?",
    "What are phone numbers used for?": "למה משמשים מספרי טלפון?",
    "What are statuses and how do I add one?": "מהם הסטטוסים ואיך אני מוסיף אחד?",
    "What are statuses and how to add one?": "מה הם הסטטוסים וכיצד אני יכול להוסיף סטטוס?",
    "What are teams, and why should I create one?": "מהן קבוצות, ולמה כדאי לי ליצור אחת?",
    "What are the 'Matched' and 'Not Matched' routing options in Time Conditions?": "מהן אפשרויות הניתוב ‘תואם’ ו-‘לא תואם’ בשעות פעילות?",
    "What are the Matched and Not Matched routing options in Time Conditions?": "מהן אפשרויות הניתוב בשעות הפעילות כאשר הבדיקה \"תואמת\" לתנאי או \"אינה תואמת\" לתנאי?",
    "What are the available time intervals for creating a report?": "מהם מרווחי הזמן הזמינים ליצירת דוח?",
    "What are the benefits and use cases of voicemail?": "מהם היתרונות והשימושים של דואר קולי?",
    "What are the costs associated with DID numbers?": "מהם העלויות הקשורות למספרי DID?",
    "What are the costs associated with phone numbers?": "מהם העלויות הקשורות למספרי טלפון?",
    "What are the presets in call logs?": "מהן ההגדרות המקדימות ביומני שיחות?",
    "What are the responsibilities of a supervisor?": "מהם תחומי האחריות של מנהל המוקד?",
    "What are the use cases of Announcements?": "What are the use cases of Announcements?",
    "What details can I find in the call logs?": "אילו פרטים ניתן למצוא ביומני השיחות?",
    "What does BLF mean, and how can I use it?": "מהי המשמעות של BLF? ומה השימוש בו?",
    "What exactly are dial rules, and why would I need to use them?": "מה בדיוק הן חוקי חיוג, ולמה אני צריך להשתמש בהם?",
    "What exactly is an extension, and why would I use one?": "מה בדיוק היא שלוחה, ולמה אני אשתמש בה?",
    "What features are typically included with a DID number?": "אילו תכונות כלולות בדרך כלל עם מספר DID?",
    "What features are typically included with a phone number?": "אילו תכונות נכללות בדרך כלל במספר טלפון?",
    "What filters can be applied to call logs?": "אילו מסננים ניתן להחיל על יומני שיחות?",
    "What happens if I change my subscription plan while one is active?": "מה קורה אם אני משנה את תוכנית המנוי שלי בזמן שתוכנית פעילה?",
    "What happens if I delete a Time Condition or a Time Group?": "מה קורה אם אני מוחק שעות פעילות או קבוצת זמן?",
    "What happens if I delete a Time Condition?": "מה קורה כאשר אני מוחק שעות פעילות?",
    "What happens if I delete a Time Group?": "מה קורה אם אני מוחק קבוצת זמן?",
    "What happens if I delete a voicemail?": "מה קורה אם אני מוחק תא קולי?",
    "What happens if I delete an Auto Attendant?": "מה קורה אם אני מוחק את ה”אוטומט אדמין” (Auto Attendant)?",
    "What happens if I delete an endpoint?": "מה קורה אם אני מוחק מכשיר קצה?",
    "What happens if I delete an intercept group?": "מה יקרה אם אמחק קבוצה שמרכזת חטיפת שיחות?",
    "What happens if I need to edit or delete an existing announcement?": "מה קורה אם אני צריך לערוך או למחוק הודעה קיימת?",
    "What happens if I no longer need a phone number?": "מה קורה אם אני כבר לא צריך מספר טלפון?",
    "What happens if I no longer need my DID number?": "מה קורה אם אני כבר לא צריך את מספר ה-DID שלי?",
    "What happens if a number doesn't match any of my dial rules?": "מה קורה אם מספר הטלפון לא תואם לאף אחד מחוקי החיוג הקיימים?",
    "What happens if a user is deactivated?": "מה קורה אם משתמש מושבת?",
    "What happens if no one in the Ring Group picks up the call?": "מה קורה אם אף אחד בקבוצת החיוג לא עונה לשיחה?",
    "What happens if no one is available in the intercept group?": "מה קורה אם אף אחד מהנציגים לא זמין בקבוצה שמרכזת חטיפת שיחות?",
    "What happens if someone joins the conference while others are already talking?": "מה קורה אם מישהו מצטרף לכנס כאשר אחרים כבר מדברים?",
    "What happens if the balance is low?": "מה קורה אם היתרה נמוכה?",
    "What happens if the forwarded number doesn't answer?": "מה קורה אם המספר המפונה לא עונה?",
    "What happens when I delete media used in the app? Is there a fallback?": "מה קורה כאשר אני מוחק מדיה ששימשה באפליקציה?  האם ישנה אפשרות לשחזר את הפעולה?",
    "What if my team works remotely or in different time zones – how can extensions help?": "מה אם הצוות שלי עובד מרחוק או בזמני אזורים שונים – איך שלוחות יכולות לעזור?",
    "What is 'Call Distribution' refering to?": "What is 'Call Distribution' refering to?",
    "What is Call Distribution?": "מה זה מנתב השיחות?",
    "What is Caller ID?": "מהו מזהה המתקשר?",
    "What is a Caller ID?": "מזה זה מזהה המתקשר?",
    "What is a DID number?": "מהו מספר DID?",
    "What is a KPI and how to set it?": "מהו KPI ואיך להגדיר אותו?",
    "What is a Ring Group, and how does it help my team answer calls faster?": "מהי קבוצת צלצול? ואיך היא עוזרת לצוות שלי לענות לשיחות במהירות רבה יותר?",
    "What is a Time Condition, and how does it affect call routing?": "מהו שעות פעילות, ואיך הוא משפיע על ניתוב השיחות?",
    "What is a call report and what does it contain?": "מהו דוח שיחות ומה הוא מכיל?",
    "What is a queue report and what does it contain?": "מהו דוח תור ומה הוא מכיל?",
    "What is a ring strategy and how to set one?": "מהי אסטרטגיית חיוג ואיך להגדיר אחת כזו?",
    "What is an endpoint, and how does it work in PBX?": "מהו מכשיר קצה? וכיצד הוא פועל בPBX?",
    "What is the Text-to-Speech option, and how do I use it?": "מהי האפשרות של המרת טקסט לדיבור וכיצד ניתן להשתמש בה?",
    "What is the balance used for?": "עבור מה משמש היתרה?",
    "What is the difference between 'Record Stereo' and standard call recording?": "מהו ההבדל בין \"הקלטת סטריאו\" להקלטת שיחה רגילה?",
    "What is the difference between standard call rates and premium rates?": "מה ההבדל בין תעריפי שיחה סטנדרטיים לתעריפים פרימיום?",
    "What is the purpose of 'Time Groups,' and how do I create one?": "מה המטרה של ‘קבוצות זמן’, ואיך אני יוצר אחת?",
    "What is the purpose of Time Groups and how do I create one?": "מהי המטרה של קבוצות זמנים וכיצד ניתן ליצור אותן?",
    "What kind of reports are available?": "אילו סוגי דוחות זמינים?",
    "What metrics are used to determine call efficiency?": "אילו מדדים משמשים לקביעת יעילות השיחות?",
    "What security measures are available for my account?": "אילו אמצעי אבטחה זמינים עבור החשבון שלי?",
    "What statuses are allowed for a team?": "אילו סטטוסים מותר לקבוע לקבוצה?",
    "What types of users are available in PBX?": "אילו סוגי משתמשים זמינים בPBX?",
    "What's a Ring Group, and how does it help my team answer calls faster?": "מהו קבוצת חיוג, ואיך זה עוזר לצוות שלי לענות לשיחות מהר יותר?",
    "What's a call queue?": "What's a call queue?",
    "What's the difference between a ring group and an intercept group?": "מהו ההבדל בין קבוצת צלצול לקבוצה שמרכזת חטיפת שיחות?",
    "What. happens when I delete a used media, is there a fallback?": "מה יקרה אם אמחק מדיה בשימוש?האם יש חלופה?",
    "When checked, the audio will play more than once": "כאשר מסומן, השמע יתנגן יותר מפעם אחת",
    "When the balance falls below the threshold, top up to a target balance, example: top up until the balance is $50": "כאשר היתרה יורדת מתחת לסף, שלם עד יתרת יעד. לדוגמה: שלם עד שהיתרה תהיה 50$",
    "When the balance falls below the threshold, top-up with specified amount": "כאשר היתרה יורדת מתחת לסף, טען בסכום שצוין",
    "Where do calls go when someone dials an extension? Can I change that?": "לאן השיחות הולכות כשמישהו מחייג לשלוחה? האם אני יכול לשנות את זה?",
    "Where is the media I uploaded used?": "איפה נעשה שימוש במדיה שהעליתי?",
    "Whispering": "לוחש",
    "Why are labels necessary for time groups?": "למה תוויות נחוצות עבור קבוצות זמן?",
    "Why are statuses useful?": "מדוע הסטטוסים שימושיים?",
    "Why is tracking calls important?": "למה מעקב שיחות חשוב?",
    "Why should I use media?": "למה כדאי לי להשתמש במדיה?",
    "Work Time": "זמן עבודה",
    "Work time": "זמן עבודה",
    "Write a message": "כתוב הודעה",
    "Year count": "{count} שנה",
    "Yearly invoice": "חשבונית שנתית",
    "Yes": "כן",
    "Yes, I'm here": "כן, אני כאן",
    "Yes, delete": "כן, מחק",
    "Yes, discard": "כן, בטל שינויים",
    "Yesterday": "אתמול",
    "You": "אתה",
    "You are about to add <b>{amount}</b> seats for a prorated total of <b>{total}</b>": "אתה עומד להוסיף <b>{מספר}</b> מושבים עבור סך יחסי של <b>{סה\"כ}</b>.",
    "You are about to cancel": "אתה עומד לבטל",
    "You are about to invite as a team member": "אתה עומד להזמין {email} כחבר צוות",
    "You are about to purchase": "אתה עומד לרכוש {quantity} מספרי חי\"פ בסכום כולל של {total}.",
    "You are about to remove <b>{amount}</b> seats from your plan": "אתה עומד להסיר <b>{מספר}</b> מושבים מהתוכנית שלך.",
    "You are about to restore": "אתה עומד לשחזר",
    "You are about to send a password reset link to": "אתה עומד לשלוח קישור לאיפוס סיסמה אל {email}.",
    "You are already in the call": "אתה כבר בשיחה",
    "You are not checked-in": "לא ביצעת צ'ק-אין",
    "You are now checked into the web dialer": "כעת נרשמת למערכת החיוג באינטרנט",
    "You can send it later from User > Send Invite option.": "תוכל לשלוח אותה מאוחר יותר דרך כניסה להגדרת הפרופיל של המשתמש ולחיצה על \"שלח הזמנה\".",
    "You can send it later using the Send Invite option": "תוכל לשלוח זאת מאוחר יותר באמצעות אפשרות שלח הזמנה",
    "You cannot delete the last payment method because you have an active subscription plan": "אינך יכול למחוק את אמצעי התשלום האחרון מכיוון שיש לך תוכנית מנוי פעילה",
    "You do not have permission to send SMS.": "אין לך הרשאה לשלוח SMS.",
    "You have been logged out due to inactivity": "נותקת עקב חוסר פעילות",
    "You need to check-in before listening to a call": "עליך לבצע צ'ק-אין לפני האזנה לשיחה",
    "Active and invited users. Each one holds a seat on your plan.": "משתמשים פעילים ומוזמנים. כל אחד מהם תופס מושב בתוכנית שלך.",
    "You will automatically be logged out in <b>{seconds}s</b> due to inactivity": "תנותק אוטומטית בעוד <b>{seconds}</b> שניות עקב חוסר פעילות",
    "You'll be among the first to receive a personal call from our team with all the details about our rollout": "תהיה בין הראשונים לקבל שיחה אישית מהצוות שלנו עם כל הפרטים על ההשקה שלנו",
    "Your PBX account has been verified successfully": "חשבון ה-PBX שלך אומת בהצלחה!",
    "Your PBX email has been verified successfully": "כתובת האימייל של ה-PBX שלך אומתה בהצלחה!",
    "Your Profile": "הפרופיל שלך",
    "Your changes will be lost.": "השינויים שלך יאבדו.",
    "Your current balance is below the set threshold": "היתרה הנוכחית שלך מתחת לסף שנקבע.",
    "Your invoice history for your subscription plan": "היסטוריית החשבוניות שלך עבור תוכנית המנוי שלך",
    "Your new business number is live. Call, text, and connect instantly.": "מספר העסק החדש שלך פעיל. התקשר, שלח הודעות והתחבר מיד.",
    "ZIP Code": "מיקוד",
    "ZIP Code *": "מיקוד *",
    "Zip / Postal Code": "מיקוד",
    "Zip / Postal code": "מיקוד",
    "abandoned calls": "שיחות נטושות",
    "abandoned calls tooltip kpi": "אחוז השיחות שהתנתקו לפני שהתקבלו על ידי סוכן. אחוז גבוה יותר עשוי להעיד על זמני המתנה ארוכים או חוסר שביעות רצון מצד המתקשרים.",
    "accept phone policy": "אני מסכים/ה לקבל הודעות אימות ושירות מ־ PBX.IM למספר הטלפון שלי. ייתכן חיוב בתעריפים רגילים. לשליחת בקשת הסרה, השב/י \"STOP\".",
    "activity time": "זמן פעילות",
    "address": "כתובת",
    "adds + to a number not starting with 0": "מוסיף + למספר שאינו מתחיל ב-0",
    "adds the 123 prefix to the number": "מוסיף את התחילית 123 למספר",
    "adds the 789 suffix to the number": "מוסיף את הסיומת 789 למספר",
    "admin email": "דוא\"ל מנהל",
    "advanced": "מתקדם",
    "advanced settings": "הגדרות מתקדמות",
    "ai_first_message": "שלום {name}! איך אני יכול לעזור לך?",
    "allowed countries": "מדינות מותרות",
    "and": "ו",
    "answered calls": "שיחות שנענו",
    "answered calls tooltip calls report kpi": "אחוז השיחות שהתקבלו. אחוזים גבוהים בדרך כלל הם טובים יותר.",
    "answered calls tooltip kpi": "אחוז השיחות שהתקבלו על ידי סוכנים. אחוזים גבוהים מצביעים על שיעורי תגובה טובים יותר והתמודדות יעילה עם השיחות.",
    "are listening": "מאזינים",
    "are whispering": "לוחשים",
    "ask your AI assistant": "שאל את העוזר הווירטואלי שלך",
    "avatar": "אווטאר",
    "avg call duration": "משך שיחה ממוצע",
    "avg call duration tooltip kpi": "המשך ממוצע של שיחות עבור התקופה והסוג הנבחרים.",
    "avg talk time": "זמן שיחה ממוצע",
    "avg talk time tooltip kpi": "ממוצע הזמן של שיחות שטופלו על ידי סוכנים. מדד זה יכול לעזור להעריך את היעילות והאפקטיביות של טיפול בשיחות.",
    "avg wait time": "זמן המתנה ממוצע",
    "avg wait time tooltip kpi": "המשך ממוצע של זמן ההמתנה של המתקשרים לפני שהתקבלו. ערכים נמוכים מצביעים על זמני המתנה קצרים יותר ותגובה מהירה יותר מצד הסוכנים.",
    "billing": "חיוב",
    "billing email": "דוא\"ל חיוב",
    "by paying yearly": "על ידי תשלום שנתי.",
    "c2c_card_description": "הפכו מספרי טלפון ביישומי CRM ואינטרנט שלכם לקישורים הניתנים ללחיצה, ובכך מבטלים את הצורך בחיוג ידני. לאחר הלחיצה, המרכזייה תחבר את השיחה בצורה חלקה.",
    "call queues": "תורי שיחות",
    "call recording": "הקלטת שיחות",
    "call talk time": "זמן דיבור בשיחה",
    "call volume": "נפח שיחות",
    "call volume tooltip kpi": "מספר השיחות הכולל שהתקבלו במהלך התקופה הנבחרת. מדד זה מסייע להעריך את עומס העבודה הכללי ונפח התעבורה של השיחות.",
    "callRateMinTooltip": "<b>זמן שיחה מינימלי</b>: זמן שיחה זמן מינימלי עבור החיוב המוחל.<br />גם אם השיחה שלך קצרה מזה, תחויב עבור כל זמן שיחה הזמן.<br /><br /><b>תוספת </b>: לאחר זמן שיחה המינימום, הטעינה תגדל בנתחים השווים זמן שיחה זה, <br />גם אם נעשה בו שימוש חלקי.<br /><br />דוגמה:<br />זמן שיחה המינימום: 45 שניות (0.75 דקות)<br />תוספת: 30 שניות (0.5 דקות)<br />תעריף: $0.25/דקה<br />עבור זמן שיחה שיחה של 20 שניות עדיין תחויב בעלות זמן שיחה המינימום.<br />כלומר, $0.25 * 0.75 דקות = $0.1875<br />זמן שיחה שיחה של 60 שניות תחויב בעלות זמן שיחה המינימום, בתוספת התוספות שבהן נעשה שימוש.<br />כלומר, $0.1875 + $0.25 * 0.5 דקות = $0.3125<br />",
    "calls": "שיחות",
    "calls stats": "סטטיסטיקת שיחות",
    "calls tooltip kpi": "מספר השיחות הכולל שבוצעו במהלך התקופה והסוג הנבחרים.",
    "calls within sla": "שיחות בתוך SLA",
    "calls within sla tooltip kpi": "אחוז השיחות שהתקבלו בתוך זמן ההסכם לשירות (SLA) שנקבע מראש. זה משקף את יעילות זמני התגובה.",
    "cancel plan": "בטל תוכנית",
    "chat form": "טופס צ'אט",
    "chat menu {name}": "תפריט צ'אט {name}",
    "city": "עיר",
    "company": "חברה",
    "company address": "כתובת החברה",
    "company name": "שם החברה",
    "copied_to_clipboard": "הועתק ללוח.",
    "copy_failed": "העתקה נכשלה.",
    "core": "ליבה",
    "counter of": "{start} מתוך {end}",
    "country": "ארץ",
    "credit": "אשראי",
    "current balance": "יתרה נוכחית",
    "current plan": "תוכנית נוכחית",
    "debit": "חיוב",
    "default": "ברירת מחדל",
    "default card": "כרטיס ברירת מחדל",
    "description": "תיאור",
    "dial time": "זמן חיוג",
    "digit": "ספרה",
    "documentation": "מדריך למשתמש",
    "done": "סיימתי",
    "email": "דוא\"ל",
    "email or username": "דוא\"ל או שם משתמש",
    "enabled count": "מופעל ({count})",
    "ended the chat": "סיים את הצ'אט",
    "enterprise": "ארגוני",
    "essential": "חיוני",
    "example mask end": "דוגמה: +44 1234 567 XXX",
    "example mask middle": "Example: +44 1234 XXX 890",
    "exceeded the file size": "חרג מגודל הקובץ",
    "exceeded the file size or was unsupported": "חרג מגודל הקובץ או שלא נתמך",
    "exceeded the file size or were unsupported": "חרגו מגודל הקובץ או שלא נתמכו",
    "ext_card_description": "Install the extension to instantly start calls from any browser tab.",
    "external ID": "מזהה חיצוני",
    "fax": "פקס",
    "female": "נקבה",
    "finance-tour-step-1": "ברוך הבא ל-PBX.IM!",
    "finance-tour-step-2": "כאן תמצא את תמונת הפרופיל שלך, שמך ושם החברה. לחץ כאן לגישה לאופציות נוספו.",
    "finance-tour-step-3": "לחץ על ‘החברה שלי’.",
    "finance-tour-step-4": "Click on the 'Billing' tab.",
    "finance-tour-step-5": "סעיף זה מכסה את כל הצרכים החיוביים שלך. טען את חשבונך, צפה בחשבוניות, נהל אמצעי תשלום ועוד. {br} אם תרצה ללמוד עוד על תכונות נוספות, אנא עיין ב-{documentation}.",
    "first name": "שם פרטי",
    "forced sso": "SSO מאולץ",
    "from the chat": "מהצ'אט",
    "general": "כללי",
    "get answer": "קבל תשובה",
    "has joined": "הצטרף לשיחה",
    "have joined": "הצטרפו לשיחה",
    "hours": "{value} שעות",
    "hours label": "שעות",
    "https://": "https://",
    "idle time": "זמן סרק",
    "ip_invalid": "Invalid IP address.",
    "is listening": "מאזין",
    "is required": "נדרש",
    "is typing": "מקליד",
    "is typing...": "מקליד...",
    "is whispering": "לוחש",
    "joined the chat": "הצטרף לצ'אט",
    "last name": "שם משפחה",
    "left the chat": "עזב את הצ'אט",
    "male": "זכר",
    "mask digits at the end": "הסתר את הספרות בסוף",
    "mask digits in the middle": "הסתר את הספרות באמצע",
    "max wait time": "זמן המתנה מקסימלי",
    "max wait time tooltip kpi": "זמן ההמתנה הארוך ביותר במהלך התקופה הנבחרת. מדד זה עוזר לזהות עומסים בשעות שיא ובעיות בזמן התגובה.",
    "maximum_files": "אתה יכול להעלות עד {max} קבצים.",
    "mic permission denied": "הרשאת המיקרופון נדחתה. אנא אפשר גישה למיקרופון בהגדרות הדפדפן שלך כדי להמשי.",
    "middle name": "שם אמצעי",
    "minimum charge seconds": "שניות חיוב מינימליות",
    "minutes label": "דקות",
    "month": "חודש",
    "monthly": "חודשי",
    "more count": "+ {count} עוד",
    "multiple channels": "ערוצים מרובים",
    "name": "שם",
    "never": "לעולם לא",
    "no agent answer timeout": "אין מענה מסוכן (פג הזמן)",
    "no message timeout": "אין הודעה (פג הזמן)",
    "no of users": "{numberOfSeats} משתמשים",
    "no-limits music on hold": "מוזיקה בהמתנה ללא הגבלה",
    "notes": "הערות",
    "now": "עכשיו",
    "number": "מספר",
    "numbers max": "{count} מספרים מקסימלי.",
    "of": "מתוך",
    "offline": "לא מחובר",
    "on call": "בשיחה",
    "on hold": "בהמתנה",
    "ready": "מוכן",
    "ringing": "מצלצל",
    "powered by PBX": "powered by PBX",
    "wait ~30s": "המתנה ~30 שנ׳",
    "waiting": "ממתין",
    "replace prefix 44 with 0 in a number with length of 8-15 digits": "החלף את הקידומת 44 ב-0 במספר שאורכו 8-15 ספרות",
    "queue calls": "שיחות תור",
    "your password again": "הזן שוב את הסיסמה שלך",
    "plan": "תוכנית",
    "startup": "סטארט-אפ",
    "upgrade plan": "שדרג תוכנית",
    "yearly": "שנתי",
    "year": "שנה",
    "prepaid": "משולם מראש",
    "two-Factor Authentication": "אימות דו-שלבי",
    "time stats": "סטטיסטיקות זמן",
    "onboarding-tour-flow-step-1": "ברוכים הבאים ל-PBX.IM! עקוב אחר השלבים הבאים כדי לבצע את שיחת הבדיקה הראשונה שלך.",
    "onboarding-tour-flow-step-10": "כתובת ה-IP שדרכה נקודת הקצה שלך מחוברת ל-PBX.IM",
    "onboarding-tour-flow-step-11": "פרטים אודות סוג המכשיר או גרסת התוכנה.",
    "onboarding-tour-flow-step-12": "כתובת ה-MAC של נקודת הקצה.",
    "onboarding-tour-flow-step-13": "הפעם האחרונה שנקודת הקצה התחברה ל-PBX.IM",
    "onboarding-tour-flow-step-14": "מציג את סטטוס נקודת הקצה.",
    "onboarding-tour-flow-step-15": "סקור את היתרה שלך. הוספנו $5 לחשבונך לצורך שיחות בדיקה.",
    "onboarding-tour-flow-step-16": "לחץ על חייגן הדפדפן.",
    "onboarding-tour-flow-step-17": "ודא שהמיקרופון שלך מחובר.",
    "onboarding-tour-flow-step-18": "הקלד את מספר הטלפון שברצונך לחייג אליו.",
    "onboarding-tour-flow-step-19": "לחץ על 'התקשר'.",
    "onboarding-tour-flow-step-2": "עבור לתפריט הצד.",
    "onboarding-tour-flow-step-3": "לחץ על \"הגדרות\".",
    "onboarding-tour-flow-step-4": "לחץ על \"נקודות קצה\".",
    "onboarding-tour-flow-step-5": "הסמל יציג את סוג נקודת הקצה. סמל הגלובוס מייצג טלפון אינטרנטי.",
    "onboarding-tour-flow-step-6": "שם נקודת הקצה שלך.",
    "onboarding-tour-flow-step-7": "שם המשתמש המשויך לנקודת הקצה.",
    "onboarding-tour-flow-step-8": "שלוחת הטלפון שהוקצתה לנקודת הקצה.",
    "onboarding-tour-flow-step-9": "המשתמש אליו משויכת נקודת הקצה.",
    "or": "או",
    "otp expired warning": "הופנת לדף הכניסה עקב חוסר פעילות בדף האימות. אנא היכנס מחדש כדי להמשיך.",
    "owner email": "דוא\"ל בעלים",
    "owner-tour-step-1": "ברוך הבא ל-PBX.IM. בוא נעבור במהירות על איך להוסיף את חברי הצוות שלך ולבצע את השיחה הראשונה של!",
    "owner-tour-step-2": "לחץ על “הגדרות” מלוח הצד.",
    "owner-tour-step-3": "לחץ כאן כדי להוסיף ולעדכן משתמשים. לחילופין, תוכל גם לחפש משתמשים דרך חיפוש מהיר.",
    "owner-tour-step-4": "לחץ כאן כדי להוסיף משתמש חדש.",
    "owner-tour-step-5": "כדי להוסיף משתמש, הזן את המידע הנדרש ולחץ על ‘שלח הזמנה’. לחילופין, אפשר לשמור את פרטי המשתמש כטיוטה ולשלוח הזמנה מאוחר יותר.",
    "owner-tour-step-6": "מעולה! עכשיו למדת כיצד להזמין חבר צוות! האם תרצה עכשיו ללמוד איך לבצע את השיחה הראשונה שלך?",
    "owner-tour-step-7": "אם יש לך שאלות, אל תהסס להשתמש בצ’אט ה-AI שלנו כדי לקבל תשובות במהירות. תודה שבחרת -PBX.IM!",
    "password change dialog disabled description": "נראה שעשית שימוש ברשתות חברתיות כדי ליצור את החשבון שלך. לצערנו, אנו לא מאפשרים לשנות סיסמאות לחשבונות שנוצרו באמצעות רשתות חברתיו.",
    "password repeat": "חזור על הסיסמה",
    "pause": "הפסקה",
    "pause time": "זמן הפסקה",
    "per page": "לעמוד",
    "phone": "טלפון",
    "phone number": "מספר טלפון",
    "please top-up to proceed": "אנא שלם כדי להמשיך",
    "powered by": "מופעל על ידי",
    "premium support": "תמיכה פרימיום",
    "previous value": "קודם: {value}",
    "pricing": "תמחור",
    "quantity": "כמות",
    "queue timeout": "פג הזמן בתור",
    "queues": "תורים",
    "range end": "סיום טווח",
    "range start": "תחילת טווח",
    "rate sheet": "גיליון תעריפים",
    "removed": "הוסר",
    "required_field_error": "שדה זה נדרש.",
    "resend_in_minutes": "שלח מחדש בעוד {minutes} דקות",
    "resend_in_minutes_and_seconds": "שלח מחדש בעוד {minutes} דקות ו-{seconds} שניות",
    "resend_in_seconds": "שלח מחדש בעוד {seconds} שניות",
    "row(s) selected": "שורה(ות) נבחרה(ו).",
    "s": "שניות",
    "same as company address": "זהה לכתובת החברה",
    "search": "חיפוש",
    "seats": "מושבים",
    "sec": "שניות",
    "security": "אבטחה",
    "security email": "דוא\"ל אבטחה",
    "selected": "נבחר",
    "should be a minimum length of": "{what} צריך להיות באורך מינימלי של {length}.",
    "sla": "SLA (הסכם רמת שירות)",
    "sms failed error": "שליחה של SMS נכשלה. אנא נסה שוב.",
    "sso authorization failed": "נכשל באימות ספק SSO",
    "sso authorization required": "אנא אשר ספק חברתי כדי לאפשר כניסה יחידה מאולצת (SSO).",
    "sso authorization title": "קישור חשבון חברתי",
    "sso emails dont match": "כתובת האימייל של החשבון שסופק אינה תואמת לכתובת האימייל שלך!",
    "sso account already linked": "חשבון Google או Microsoft זה כבר מקושר למשתמש אחר. בחרו חשבון אחר.",
    "sso provider authorized": "החשבון החברתי אומת בהצלחה!",
    "sso providers": "ספקי SSO",
    "sso_password_change": "חשבון זה נוצר באמצעות פרטי SSO. כדי לבטל את ה-SSO, תצטרך להגדיר סיסמה. הדואר האלקטרוני שלך יישאר ללא שינו.",
    "start_ip_must_be_less_than_end_ip": "כתובת ה-IP ההתחלתית חייבת להיות קטנה מכתובת ה-IP הסופית.",
    "state": "מדינה",
    "state / province": "מדינה \\ מחוז",
    "steps count": "{current_step} מתוך {total_steps}",
    "subdomain": "תת-דומיין",
    "supervisor-tour-step-1": "ברוך הבא ל-PBX.IM! בוא נעבור במהירות על לוח המחוונים והדוחות.",
    "supervisor-tour-step-2": "ברגע שיש לך קבוצות, תוכל לבחור קבוצה אחת או כמה קבוצות.",
    "supervisor-tour-step-3": "כאן יש לך מידע בזמן אמת על הקבוצות שנבחרו.",
    "supervisor-tour-step-4": "בדומה למידע בזמן אמת, אנו יכולים גם לצפות בנתונים קודמים. כדי לגשת לדוחות, לחץ כא.",
    "supervisor-tour-step-5": "כפי שאתה רואה, ישנם סוגים שונים של דוחות. עבור סיור זה, לחץ על ‘דוח שיחות’",
    "supervisor-tour-step-6": "כאן תוכל למצוא מידע מפורט יותר על השיחות, כגון סך זמן השיחה, משך השיחה הממוצע ועו.",
    "supervisor-tour-step-7": "כדי לחקור פרטים נוספים על שיחה מסוימת, פשוט בדוק את יומני השיחות על ידי לחיצה כא.",
    "supervisor-tour-step-8": "כאן תוכל לראות שיחות שבוצעו במהלך התקופה שנבחרה. אם יש שיחות, תוכל ללחוץ עליהם כדי לראות מידע מפורט יותר. {br} אם תרצה ללמוד עוד על תכונות נוספות, אנא עיין ב-{documentation}.",
    "support email": "דוא\"ל תמיכה",
    "talk time tooltip kpi": "סך כל זמן השיחה עבור התקופה והסוג הנבחרים.",
    "test": "היי {name}! איך אני יכול לעזור לך?",
    "timeout calls": "שיחות שפגו זמנן",
    "timeout calls tooltip kpi": "אחוז השיחות שנפלו לפני שהגיעו לסוכן. אחוזים גבוהים עשויים להצביע על בעיות בנתיב השיחות או חוסר זמינות של סוכנים.",
    "timezone": "אזור זמן",
    "top up info": "טען אוטומטית את יתרת החברה ב-<amount>{upTo}</amount> כאשר היא יורדת מתחת ל-<amount>{below}</amount>.",
    "total rows": "{rows, plural, =0 {אין שורות} =1 {שורה אחת} other {# שורות}}",
    "total time": "זמן כולל",
    "transferred chat to": "העביר את הצ'אט אל",
    "unanswered calls": "שיחות שלא נענו",
    "unanswered calls tooltip calls report kpi": "אחוז השיחות שלא התחברו או לא נענו. אחוזים נמוכים בדרך כלל הם טובים יותר.",
    "unique calls": "שיחות ייחודיות",
    "unique calls tooltip kpi": "מודד את אחוז השיחות שביצע או קיבל הסוכן למספרים ייחודיים. אחוזים גבוהים מצביעים על תדירות גבוהה יותר של שיחות למספרים שונים.",
    "unread": "לא נקרא",
    "username": "שם משתמש",
    "users count": "+ {users} משתמשים",
    "var": "$var",
    "was unsupported": "לא נתמך",
    "web domain": "דומיין",
    "web widgets": "יישומוני רשת",
    "webphone-tour-step-1": "לחץ כאן כדי לפתוח את הטלפון האינטרנטי שלך!",
    "webphone-tour-step-2": "ודא שהמיקרופון שלך מחובר.",
    "webphone-tour-step-3": "אנא הזן את מספר הטלפון שברצונך לחייג.",
    "webphone-tour-step-4": "לחץ על שיחה.",
    "webphone-tour-step-5": "מעולה! עכשיו למדת כיצד לבצע שיחה! אם ברצונך ללמוד עוד על תכונות נוספות, אנא עיין ב-{documentation}.",
    "webphone-tour-step-agent-1": "הסטטוס שלך מוצג כאן לפני הפעלת הטלפון.",
    "webphone-tour-step-agent-2": "לחץ כאן כדי להפעיל ולבצע צ’ק-אין.",
    "webphone-tour-step-agent-3": "ביצעת צ’ק-אין בהצלחה. עכשיו, לחץ על ‘לוח החיוג’ כדי לנווט ולבצע את השיחה הראשונה של.",
    "webphone-tour-step-welcome": "Welcome to PBX.IM. Let's quickly make your first call!",
    "website": "אתר אינטרנט",
    "were unsupported": "לא נתמכו",
    "when it falls below a specified threshold": "כאשר הוא יורד מתחת לסף שנקבע",
    "yesterday": "אתמול",
    "zip / postal code": "מיקוד",
    "{count} others": "עוד אחד | {count} אחרים",
    "{current_step} of {total_steps}": "{current_step} מתוך {total_steps}",
    "{field} should be number": "{field} צריך להיות מספר",
    "{n} Seconds": "{n} שניות",
    "{quantity} seats have been added to your account.": "{כמות} מושבים נוספו לחשבון שלך.",
    "{quantity} seats have been removed from your account.": "{כמות} מושבים הוסרו מהחשבון שלך.",
    "Verify your ID": "אמת את זהותך",
    "Verifying user": "אנחנו מגדירים את חשבונך...",
    "Video": "וידאו",
    "Videos": "סרטונים",
    "View Invoices": "צפה בחשבוניות",
    "A server error occurred during request execution": "אירעה שגיאת שרת במהלך ביצוע הבקשה",
    "Forbidden": "אסור",
    "Plan User Limit Reached": "הגעת למגבלת המשתמשים של התוכנית",
    "Server Error": "שגיאת שרת",
    "Sorry, you have exceeded the number of tries. Please try again in {minutes} minute.": "מצטערים, חרגת ממספר הניסיונות. אנא נסה שוב בעוד {minutes} דקה.",
    "Sorry, you have exceeded the number of tries. Please try again in {minutes} minutes.": "מצטערים, חרגת ממספר הניסיונות. אנא נסה שוב בעוד {minutes} דקות.",
    "Sorry, you have exceeded the number of tries. Please try again in {seconds} second.": "מצטערים, חרגת ממספר הניסיונות. אנא נסה שוב בעוד {seconds} שנייה.",
    "Sorry, you have exceeded the number of tries. Please try again in {seconds} seconds.": "מצטערים, חרגת ממספר הניסיונות. אנא נסה שוב בעוד {seconds} שניות.",
    "Too many attempts": "יותר מדי ניסיונות",
    "Validation Error": "שגיאת אימות",
    "Your session expired. Please login in again to use the application": "תוקף ההפעלה שלך פג. אנא התחבר שוב כדי להשתמש באפליקציה",
    "Choose messages to forward!": "בחר הודעות להעברה!",
    "Voice note rejected": "הודעה קולית נדחתה",
    "{count} new message": "הודעה חדשה אחת",
    "{count} new messages": "{count} הודעות חדשות",
    "Search user": "חיפוש משתמש",
    "Select Type": "בחר סוג",
    "Image": "תמונה",
    "{ext} file": "קובץ {ext}",
    "Something went wrong, please try again later": "משהו השתבש, נסה שוב מאוחר יותר",
    "+ Add:": "+ הוסף:",
    "Link Preview Image": "תמונת תצוגה מקדימה של קישור",
    "Template not yet supported": "התבנית אינה נתמכת עדיין",
    "Drag & drop here or": "גרור ושחרר כאן או",
    "upload a local file": "העלה קובץ מקומי",
    "Drop here": "שחרר כאן",
    "Upload failed": "ההעלאה נכשלה",
    "Click to retry": "לחץ כדי לנסות שוב",
    "Image (JPEG or PNG)": "תמונה (JPEG או PNG)",
    "Video (MP4)": "וידאו (MP4)",
    "Animated (MP4)": "מונפש (MP4)",
    "Document (PDF only)": "מסמך (PDF בלבד)",
    "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator or complete setup under Settings › Channels.": "כדי לשלוח SMS מהמספר הזה נדרשים מותג וקמפיין A2P 10DLC מאושרים. אנא פנה למנהל המערכת או השלם את ההגדרה תחת הגדרות ‹ ערוצים.",
    "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator.": "כדי לשלוח SMS מהמספר הזה נדרשים מותג וקמפיין A2P 10DLC מאושרים. אנא פנה למנהל המערכת.",
    "Type to search contacts...": "הקלד כדי לחפש אנשי קשר...",
    "10 seconds": "10 שניות",
    "60 seconds": "60 שניות",
    "A2P Campaign": "קמפיין A2P",
    "ADD CONTACT": "הוסף איש קשר",
    "ASR": "ASR",
    "Accent": "הדגשה",
    "Activate Web Phone": "הפעל חייגן דפדפן",
    "Activate the flow to make a test call.": "הפעל את הזרימה לביצוע שיחת בדיקה.",
    "Add Call Flow": "הוסף זרימת שיחה",
    "Add Channels": "הוסף ערוצים",
    "Add SMS Campaign": "הוסף קמפיין SMS",
    "Add nodes to the flow first.": "הוסף קשרים לזרימה תחילה.",
    "Age": "גיל",
    "Allowed characters: letters, digits, spaces, dot, underscore, hyphen": "תווים מותרים: אותיות, ספרות, רווחים, נקודה, קו תחתון, מקף",
    "Answer": "ענה",
    "Apply for A2P": "הגש בקשה ל-A2P",
    "Apply the policy and assign the DID to a Teams user": "החל את המדיניות והקצה את מספר החי\"פ למשתמש Teams",
    "Are you sure you want to cancel creating this campaign? Your campaign will be saved as a draft.": "האם אתה בטוח שברצונך לבטל את יצירת הקמפיין? הקמפיין שלך יישמר כטיוטה.",
    "Are you sure you want to change this node?": "האם אתה בטוח שברצונך לשנות את הקשר הזה?",
    "At least one of IP Authentication Host / ACL or Destination Host is required": "נדרש לפחות אחד מבין: מארח אימות IP / ACL או מארח יעד",
    "Authentication Required": "נדרש אימות",
    "Auto Gain Level": "רמת הגבר אוטומטית",
    "Auto-detect": "זיהוי אוטומטי",
    "Auto-layout": "פריסה אוטומטית",
    "Average: {value}": "ממוצע: {value}",
    "Bar chart": "תרשים עמודות",
    "Browser Check-in": "צ'ק-אין בדפדפן",
    "Build the voice routing policy": "בנה את מדיניות ניתוב הקול",
    "Busy Delay": "השהיית תפוס",
    "By proceeding, you consent to receive verification and service messages from PBX.IM. Standard rates may apply. Reply STOP to unsubscribe.": "בהמשך, אתה מסכים לקבל הודעות אימות ושירות מ-PBX.IM. תעריפים רגילים עשויים לחול. הגב STOP להסרה מהרשימה.",
    "CNAME for {host} is not yet pointing to {target}": "CNAME עבור {host} עדיין לא מצביע על {target}",
    "Calculating recipients…": "מחשב נמענים…",
    "Call Flow Name": "שם תזרים השיחה",
    "Call ended...": "השיחה הסתיימה...",
    "Call failed": "השיחה נכשלה",
    "Call from any browser tab.": "התקשר מכל לשונית דפדפן.",
    "Campaign Name": "שם הקמפיין",
    "Campaign created successfully": "הקמפיין נוצר בהצלחה",
    "Campaign saved as draft": "הקמפיין נשמר כטיוטה",
    "Campaign stats": "סטטיסטיקות קמפיין",
    "Campaign submitted successfully": "הקמפיין נשלח בהצלחה",
    "Campaign updated successfully": "הקמפיין עודכן בהצלחה",
    "Campaign will be sent to <b>{n} Contacts</b>.": "הקמפיין יישלח ל-<b>{n} אנשי קשר</b>.",
    "Cancel SMS Campaign": "ביטול קמפיין SMS",
    "Cancel the test call.": "בטל את שיחת הבדיקה.",
    "Card": "כרטיס",
    "Card name": "שם בעל הכרטיס",
    "Chat returned to queue by": "הצ'אט הוחזר לתור על ידי",
    "Chat routed by": "הצ'אט נותב על ידי",
    "Check-in with Browser": "צ'ק-אין עם הדפדפן",
    "Check-in with Phone": "צ'ק-אין עם הטלפון",
    "Choose A2P Campaign": "בחר קמפיין A2P",
    "Choose Call List": "בחר רשימת שיחות",
    "Choose Sender ID": "בחר מזהה שולח",
    "Choose node": "בחר צומת",
    "Choose time zone": "בחר אזור זמן",
    "Concurrent Calls": "שיחות במקביל",
    "Connect the webphone to make a test call.": "חבר את הטלפון האינטרנטי כדי לבצע שיחת בדיקה.",
    "Connected": "מחובר",
    "Connection timed out. Please try again.": "תם פסק הזמן לחיבור. אנא נסה שוב.",
    "Cost Estimation": "הערכת עלות",
    "Could not upload list": "לא ניתן להעלות את הרשימה",
    "Couldn't load setup info — refresh and try again": "לא ניתן לטעון את פרטי ההגדרה — רענן ונסה שוב",
    "Create a PSTN usage record + voice route": "צור רשומת שימוש ב-PSTN + מסלול קול",
    "Current Balance": "יתרה נוכחית:",
    "Customer Domain (SIP URI)": "דומיין לקוח (SIP URI)",
    "DND": "אל תפריע",
    "DNS not verified": "ה-DNS לא אומת",
    "Default (Disabled)": "ברירת מחדל (מושבת)",
    "Delay before ringing this user": "השהיה לפני צלצול אצל משתמש זה",
    "Delivery log": "יומן מסירה",
    "Destinations": "יעדים",
    "Direct Extensions": "שלוחות ישירות",
    "Disconnected nodes": "קשרים מנותקים",
    "Dismiss": "סגור",
    "Domain description not loaded": "תיאור הדומיין לא נטען",
    "Don't Send To": "אל תשלח אל",
    "Down": "לא פעיל",
    "Downgrading to {name} on {date}": "שנמוך לתוכנית {name} בתאריך {date}",
    "During Hours": "בשעות הפעילות",
    "Each concurrent call requires one Microsoft Teams channel.": "כל שיחה מקבילה דורשת ערוץ Microsoft Teams אחד.",
    "Each segment = 1 SMS billed. Messages are split into 150 character segments.": "כל קטע = חיוב SMS אחד. הודעות מפוצלות לקטעים של 150 תווים.",
    "Edit Inbox Destination": "ערוך יעד תיבת דואר נכנס",
    "Edit Microsoft Teams": "ערוך Microsoft Teams",
    "Enable Direct Dial": "הפעל חיוג ישיר",
    "End monitoring session?": "לסיים את פעילות הניטור?",
    "Enforce 2FA for all users": "אכוף אימות דו-שלבי לכל המשתמשים",
    "Enter Message": "הזן הודעה",
    "Enter Sample Message": "הזן הודעה לדוגמה",
    "Enter a name for the flow before saving": "הזן שם לזרימה לפני השמירה",
    "Enter description": "הזן תיאור",
    "Enter keywords separated by commas": "הזן מילות מפתח מופרדות בפסיקים",
    "Enter target duration in seconds (e.g., 20)": "הזן משך יעד בשניות (למשל, 20)",
    "Enter target percentage (e.g., 95)": "הזן אחוז יעד (למשל, 95)",
    "Estimated": "משוער",
    "Existing Endpoint": "נקודת קצה קיימת",
    "Exit": "יציאה",
    "FIXED_LINE": "קו קבוע",
    "FIXED_LINE_OR_MOBILE": "קו קבוע או נייד",
    "Failed to initiate monitoring": "הפעלת הניטור נכשלה",
    "Failed to load health status": "טעינת מצב הבריאות נכשלה",
    "Failed to load integration": "טעינת האינטגרציה נכשלה",
    "Failed to switch mode. Please try again.": "החלפת המצב נכשלה. אנא נסה שוב.",
    "Failed to update integration": "עדכון האינטגרציה נכשל",
    "Favorites": "מועדפים",
    "First Name *": "שם פרטי *",
    "Flow name is required": "נדרש שם לתזרים",
    "Flow name must be {max} characters or less": "שם התזרים חייב להכיל לכל היותר {max} תווים",
    "Flow name too long": "שם התזרים ארוך מדי",
    "Flow saved successfully": "התזרים נשמר בהצלחה",
    "Flow start": "תחילת תזרים",
    "Flow sync failed - changes saved locally": "סנכרון התזרים נכשל – השינויים נשמרו מקומית",
    "Flows Using Node": "תזרימים המשתמשים בצומת",
    "French": "צרפתית",
    "Frequently": "לעיתים קרובות",
    "German": "גרמנית",
    "Hang up": "נתק שיחה",
    "Hash is required": "נדרש מזהה (hash)",
    "He": "הוא",
    "Health": "בריאות",
    "Health Probe": "בדיקת תקינות",
    "Hold on while we re-check the new domain": "אנא המתן בזמן שאנו בודקים את הדומיין החדש",
    "Host ACL": "ACL מארח",
    "Hub": "Hub",
    "IP Authentication Host / ACL": "אימות IP / ACL",
    "Inbound Trunk": "טראנק נכנס",
    "Inbox Destination": "תיבת יעד",
    "Integration updated": "האינטגרציה עודכנה",
    "Internal call": "שיחה פנימית",
    "Invalid Number": "מספר לא חוקי",
    "Invalid leads": "לידים לא תקינים",
    "Keep Alive": "שמירת חיבור",
    "LTR": "שמאל לימין",
    "Last 200 OK from Hub": "200 OK אחרון מה-Hub",
    "Last Inbound Options": "אפשרויות נכנסות אחרונות",
    "Last Name *": "שם משפחה *",
    "Last sync: {date}": "סנכרון אחרון: {date}",
    "Launch": "שגר",
    "Line chart": "תרשים קו",
    "Linked inbox for inbound replies. Read only — edit via the Inbox phone number settings.": "תיבת דואר נכנס מקושרת לתשובות נכנסות. לקריאה בלבד — ערוך דרך הגדרות מספר הטלפון של תיבת הדואר.",
    "Logo": "לוגו",
    "Longest: {value}": "ארוך ביותר: {value}",
    "MS=ms12345678": "MS=ms12345678",
    "Manage the SIP trunk settings.": "נהל את הגדרות ה-SIP trunk.",
    "Mastercard Test Card Name": "שם כרטיס מאסטרקארד לבדיקה",
    "Max Concurrent Calls": "מקסימום שיחות בו-זמניות",
    "Messages confirmed as delivered to the recipient's device.": "הודעות שאושרו כמועברות למכשיר של הנמען.",
    "Messages submitted to the carrier.": "הודעות שנשלחו לספק.",
    "Messages that could not be delivered (invalid number, carrier rejection, etc.).": "הודעות שלא ניתן היה לשלוח (מספר לא תקין, דחייה על ידי ספק וכו').",
    "Method": "שיטה",
    "Microsoft 365": "Microsoft 365",
    "Microsoft Teams channels:": "ערוצי Microsoft Teams:",
    "Missing flow name": "שם זרימה חסר",
    "N / N Characters": "{n} / {max} תווים",
    "N SEGMENT": "{n} {n, plural, one {פלח} other {פלחים}}",
    "No A2P-approved numbers": "אין מספרים מאושרים ל-A2P",
    "No Inbox Chosen": "לא נבחרה תיבת דואר נכנס",
    "No Input Max": "מקסימום ללא קלט",
    "No SMS-enabled numbers": "אין מספרים עם SMS מופעל",
    "No data yet": "אין נתונים עדיין",
    "No endpoint": "אין נקודת קצה",
    "No nodes found": "לא נמצאו קשרים",
    "No queues joined yet": "טרם הצטרף לאף תור.",
    "No recent calls": "אין שיחות אחרונות",
    "Node Used In Multiple Flows": "קשר משמש בתזרימים מרובים",
    "Node used in multiple flows. Changes will apply to all flows": "קשר משמש במספר זרימות. השינויים יחולו על כל הזרימות",
    "Nodes": "קשרים",
    "Only A2P approved numbers are shown. Numbers without approval are not eligible for bulk SMS campaigns to US or Canadian numbers.": "מוצגים רק מספרים מאושרי A2P. מספרים ללא אישור אינם כשירים לקמפיינים של SMS בכמות גדולה למספרים בארה\"ב או בקנדה.",
    "Only numbers with an approved A2P Campaign are shown here. If a number isn’t listed, ensure it is associated with an approved A2P Campaign. <link>Apply for A2P →</link>": "כאן מוצגים רק מספרים עם קמפיין A2P מאושר. אם מספר אינו מופיע, ודא שהוא משויך לקמפיין A2P מאושר. <link>הגש בקשה ל-A2P ←</link>",
    "Opt-Out Keywords": "מילות מפתח לביטול הסכמה",
    "Opt-Out Message": "הודעת ביטול הסכמה",
    "Opted-out": "ביטל הסכמה",
    "Outbound Trunk": "טרנק יוצא",
    "Outcome": "תוצאה",
    "PBX generates these commands for your specific tenant. Run them in an admin PowerShell session after Connect-MicrosoftTeams.": "PBX מייצר פקודות אלה עבור הדייר הספציפי שלך. הפעל אותן בסשן PowerShell עם הרשאות מנהל לאחר Connect-MicrosoftTeams.",
    "Per 15 min": "כל 15 דקות",
    "Per day": "ליום",
    "Per hour": "לשעה",
    "Per-hub probe status and inbound options heartbeat will appear here once the backend exposes them.": "סטטוס בדיקת Hub ופעימות לב של אפשרויות נכנסות יופיעו כאן ברגע שה-backend יחשוף אותם.",
    "Percentage of Answered Calls": "אחוז שיחות שנענו",
    "Periodically sends SIP keep-alive requests to ensure the SIP trunk stays active and the remote side is responding.": "שולח בקשות SIP לשמירת חיבור פעיל מעת לעת כדי להבטיח שהטרנק פעיל והצד המרוחק מגיב.",
    "Phone Check-in": "צ'ק-אין בטלפון",
    "Phone List": "רשימת טלפונים",
    "Phone Number *": "מספר טלפון *",
    "Pie chart": "תרשים עוגה",
    "Placeholder": "פלייסהולדר",
    "Plan canceled": "תוכנית בוטלה",
    "Please select a script in the current tab": "בחר תסריט בכרטיסייה הנוכחית",
    "Please wait a moment and try again": "אנא המתן רגע ונסה שוב",
    "Pop out": "פתח בחלון נפרד",
    "PowerShell CLI": "PowerShell CLI",
    "PowerShell setup": "הגדרת PowerShell",
    "Private Contact": "איש קשר פרטי",
    "Queue call": "שיחת תור",
    "Queued": "בהמתנה בתור",
    "RTL": "RTL",
    "Read / Write": "קריאה / כתיבה",
    "Read only": "קריאה בלבד",
    "Reason": "סיבה",
    "Recipients who replied STOP and were removed from this campaign.": "נמענים שהשיבו STOP והוסרו מקמפיין זה.",
    "Recording failed. Please try again.": "ההקלטה נכשלה. אנא נסה שוב.",
    "Register PBX's managed SBC as a Teams PSTN gateway": "רישום ה-SBC המנוהל של PBX כשער PSTN של Teams",
    "Rejected": "נדחה",
    "Reload Studio": "טען מחדש את Studio",
    "Retries cannot exceed Max Attempts": "מספר הניסיונות החוזרים לא יכול לעלות על מספר הניסיונות המקסימלי ({count})",
    "Rule is not valid": "הכלל אינו תקין",
    "Russian": "רוסית",
    "SBC Domain already used in another integration": "דומיין SBC כבר בשימוש באינטגרציה אחרת",
    "SMS & MMS": "SMS ו-MMS",
    "STOP, CANCEL, UNSUBSCRIBE": "STOP, CANCEL, UNSUBSCRIBE",
    "Schedule": "תזמון",
    "Scheduled": "מתוזמן",
    "Select \"Yes\" to checkout from Call Center and leave all queues": "בחר \"כן\" כדי לצאת ממוקד השירות ולעזוב את כל התורים",
    "Select direction": "בחר כיוון",
    "Select smt": "בחר",
    "Select time format": "בחר פורמט שעה",
    "Select time group": "בחר קבוצת זמן",
    "Send To": "שלח אל",
    "Send message": "שלח הודעה",
    "Sender ID": "מזהה שולח",
    "Sending rate format": "{perHour}/שעה → {perDay}/יום",
    "Sent at": "נשלח ב",
    "Set Inbox": "הגדר תיבת דואר נכנס",
    "Show Inputs From Other Flows": "הצג כניסות מזרימות אחרות",
    "Sign Up for PBX.IM – Cloud PBX Phone System Solutions": "הירשם ל-PBX.IM – פתרונות מרכזייה בענן",
    "Sign out": "התנתק",
    "Skip Sending Messages With Any Empty Tokens": "דלג על שליחת הודעות עם משתנים ריקים",
    "Skip empty tokens tooltip": "מופעל: אם ערכי המשתנים ריקים, ההודעה לא תישלח.\n\nמושבת: ההודעה תישלח עם ערך ריק.",
    "Some nodes have validation errors": "בחלק מהקשרים יש שגיאות אימות",
    "Something went wrong while rendering this call flow. Your unsaved changes may be lost.": "משהו השתבש בעת עיבוד זרימת השיחה. השינויים שלא נשמרו עלולים ללכת לאיבוד.",
    "Split": "פיצול",
    "Stripe V2 top-up failed": "הטענת יתרה Stripe V2 נכשלה",
    "Stripe V2 top-up successful": "הטענת יתרה Stripe V2 בוצעה בהצלחה",
    "Studio crashed": "Studio קרס",
    "Summary": "סיכום",
    "Suppressed": "מודחק",
    "Switching to": "עובר ל",
    "Sync Templates": "סנכרן תבניות",
    "TFA is required by your organization": "אימות דו-שלבי (TFA) נדרש על ידי הארגון שלך",
    "Target Duration (seconds)": "משך יעד (שניות)",
    "Target Percentage (%)": "אחוז יעד (%)",
    "Temporarily Unavailable": "זמנית לא זמין",
    "Terminate call": "סיים שיחה",
    "Terminate the call for all participants?": "לסיים את השיחה עבור כל המשתתפים?",
    "Test call active in another flow. End it to start a new one.": "שיחת בדיקה פעילה בזרימה אחרת. סיים אותה כדי להתחיל חדשה.",
    "Test call failed": "שיחת הבדיקה נכשלה",
    "Test call timed out": "שיחת הבדיקה פג תוקפה",
    "Text to Speech": "טקסט לדיבור",
    "The number of concurrent calls can't exceed the number of Microsoft Teams Channels": "מספר השיחות הו-זמניות לא יכול לעלות על מספר ערוצי Microsoft Teams",
    "The number of seats can’t exceed the plan maximum.": "מספר המושבים לא יכול לעלות על המקסימום של התוכנית.",
    "This context holds the SIP registration (master)": "הקשר זה מחזיק את רישום ה-SIP (ראשי)",
    "This domain is not registered.": "דומיין זה אינו רשום.",
    "This subdomain suffix is already taken": "סיומת תת-הדומיין הזו כבר תפוסה",
    "This text is appended to every message.": "טקסט זה מצורף לכל הודעה.",
    "This text is appended to every message. Required by carriers.": "טקסט זה מצורף לכל הודעה. נדרש על ידי ספקי הסלולר.",
    "Timegroup": "קבוצת זמן",
    "Timeout Destination": "יעד פסק זמן",
    "To opt out of future messages, reply STOP.": "כדי להסיר את עצמך מהודעות עתידיות, השב/י STOP.",
    "Total contacts": "סך כל אנשי הקשר",
    "Total: {value}": "סה\"כ: {value}",
    "Unable to create campaign": "לא ניתן ליצור קמפיין",
    "Unable to submit campaign": "לא ניתן להגיש קמפיין",
    "Unable to update campaign": "לא ניתן לעדכן קמפיין",
    "United States": "ארצות הברית",
    "Untitled Flow": "זרימה ללא שם",
    "Up": "פעיל",
    "Upgrade your plan to add more seats.": "שדרג את התוכנית שלך להוספת מושבים נוספים.",
    "Uploaded logo": "לוגו שהועלה",
    "User Defined": "מוגדר על ידי משתמש",
    "Utility": "שירות",
    "Verify the gateway and test a call": "אמת את השער ובצע שיחת בדיקה",
    "Verifying domain": "מאמת דומיין",
    "WhatsApp Templates": "תבניות WhatsApp",
    "Widget name is required": "שם הווידג'ט הוא שדה חובה",
    "Widget name must be less than 100 characters": "שם הווידג'ט חייב להכיל פחות מ-100 תווים",
    "Work": "עבודה",
    "X-XXXXXXX or XX-XXXXXXX": "X-XXXXXXX או XX-XXXXXXX",
    "You are listening": "אתה מאזין",
    "You are whispering": "אתה לוחש",
    "You barged into the call": "פרצת לשיחה",
    "You have new chats in queue:": "יש לך צ'אטים חדשים בתור:",
    "Your subscription has been canceled.": "המנוי שלך בוטל.",
    "bottom background": "רקע תחתון",
    "chat menu": "תפריט צ'אט",
    "contacts found in this list.": "אנשי קשר נמצאו ברשימה זו.",
    "dial_ahead_tooltip": "ציין כמה שיחות יכול החייגן להחייג ולהכניס לתור עבור הסוכנים לפני שהסוכנים זמינים לחלוטין. זה עוזר לאזן בין מהירות לבין יכולת טיפול בשיחות.",
    "https://example.com/privacy": "https://example.com/privacy",
    "https://example.com/terms": "https://example.com/terms",
    "inbound": "נכנס",
    "invalid numbers": "מספרים לא תקינים",
    "of {amount}": "מתוך {amount}",
    "outbound": "יוצא",
    "sbc.example.com": "sbc.example.com",
    "top background": "רקע עליון",
    "{count} node(s) not connected to any trigger": "{count} קשר(ים) שאינם מחוברים לאף טריגר",
    "1 hour": "שעה אחת",
    "15 minutes": "15 דקות",
    "30 minutes": "30 דקות",
    "5 minutes": "5 דקות",
    "Add Route": "הוסף מסלול",
    "Add Question": "הוסף שאלה",
    "Added from question library.": "נוסף מספריית השאלות.",
    "Added to question library.": "נוסף לספריית השאלות.",
    "Are you sure? This action cannot be undone.": "האם אתה בטוח? לא ניתן לבטל פעולה זו.",
    "At least one route is required": "נדרש לפחות מסלול אחד",
    "Call Screen": "מסך שיחה",
    "Route name": "שם המסלול",
    "Chat Destination": "יעד הצ'אט",
    "Chat Never Expires": "הצ'אט לעולם לא פג",
    "Chat Screen": "מסך צ'אט",
    "Choose a category to get started.": "בחר קטגוריה כדי להתחיל.",
    "Client Context": "הקשר לקוח",
    "Closed Hours Message": "הודעת שעות סגירה",
    "Decimal Number": "מספר עשרוני",
    "Delete Route": "מחק מסלול",
    "Email Address": "כתובת אימייל",
    "End call": "סיים שיחה",
    "Expires After": "פג תוקף לאחר",
    "Hello, Victor.": "שלום, Victor.",
    "Hey there! Hope you're having a good one.": "היי! מקווים שיש לך יום טוב.",
    "How can we help you?": "כיצד נוכל לעזור לך?",
    "Letters Only": "אותיות בלבד",
    "Long Text": "טקסט ארוך",
    "Maximum 5 routes allowed": "מותרים עד 5 מסלולים",
    "Message shown when closed": "הודעה המוצגת כאשר סגור",
    "Message...": "הודעה...",
    "Mute microphone": "השתק מיקרופון",
    "New Route": "מסלול חדש",
    "Numbers Only": "מספרים בלבד",
    "Question label": "תווית השאלה",
    "Question Library": "ספריית שאלות",
    "Remove from question library.": "הסר מספריית השאלות.",
    "Save & Continue": "שמור והמשך",
    "Save to question library for reuse.": "שמור בספריית השאלות לשימוש חוזר.",
    "Saved to question library.": "נשמר בספריית השאלות.",
    "Subtitle": "כותרת משנה",
    "Validation Rule": "כלל אימות",
    "Victor joined the conversation": "Victor הצטרף לשיחה",
    "Welcome!": "ברוך הבא!",
    "What can I help you with?": "במה אוכל לעזור לך?",
    "What can we help you with?": "במה נוכל לעזור לך?",
    "This queue is locked by an admin": "התור נעול על ידי מנהל מערכת",
    "Add Business Hours": "הוסף שעות פעילות",
    "Edit Business Hours": "ערוך שעות פעילות",
    "Account was created on {date}. Start date has been adjusted.": "החשבון נוצר בתאריך {date}. תאריך ההתחלה הותאם.",
    "Customer waiting duration": "משך המתנת לקוח",
    "Customer talking duration": "משך שיחת לקוח",
    "Max Wait Time": "זמן המתנה מקסימלי",
    "Customer max waiting duration": "משך המתנה מקסימלי של לקוח",
    "Number of abandoned calls": "מספר שיחות נטושות",
    "Calls Within SLA": "שיחות בתוך ה-SLA",
    "Timeout Calls": "שיחות שחרגו מהזמן",
    "Answered on time": "נענו בזמן",
    "Not answered in time": "לא נענו בזמן",
    "Remove from library": "הסר מהספרייה",
    "Web Widget Preview": "תצוגה מקדימה של וידג'ט האתר",
    "Close Preview": "סגור תצוגה מקדימה",
    "Enable Call or Chat for this route": "יש להפעיל שיחה או צ'אט עבור מסלול זה",
    "Existing embeds will stop working.": "ההטמעות הקיימות יפסיקו לעבוד.",
    "Your current integration script will no longer work after regeneration. All existing integrations must be updated with the new script to continue working. Do you want to continue?": "סקריפט האינטגרציה הנוכחי שלך לא יעבוד יותר לאחר החידוש. יש לעדכן את כל האינטגרציות הקיימות עם הסקריפט החדש כדי שימשיכו לפעול. האם ברצונך להמשיך?",
    "Maximum date range is 3 months. End date has been adjusted.": "טווח התאריכים המרבי הוא 3 חודשים. תאריך הסיום הותאם.",
    "Maximum date range is 90 days. End date has been adjusted.": "טווח התאריכים המרבי הוא 90 ימים. תאריך הסיום הותאם.",
    "Please fix the date range before exporting": "יש לתקן את טווח התאריכים לפני הייצוא",
    "Segments / SMS": "מקטעים / SMS",
    "Segments SMS format": "{segments} ({charCount} תווים)",
    "Segments per message": "מקטעים להודעה",
    "Segment cost": "עלות מקטע",
    "Total cost": "עלות כוללת",
    "Balance below estimated cost — top up to launch": "היתרה נמוכה מהעלות המשוערת — יש לטעון יתרה כדי לשגר",
    "Unable to pause campaign": "לא ניתן להשהות את הקמפיין",
    "Unable to resume campaign": "לא ניתן לחדש את הקמפיין",
    "Search phone number": "חפש מספר טלפון",
    "Skip greeting tooltip": "דלג על הודעת הפתיח והעבר את המתקשרים ישירות לצליל ההקלטה. הפעל אם אינך רוצה שהמתקשרים ישמעו פתיח לפני השארת ההודעה.",
    "Skip Voicemail Operation Instructions tooltip": "דלג על הנחיות המערכת האוטומטיות (למשל 'הקלט לאחר הצליל, הקש 1 בסיום'). הפעל לחוויה נקייה יותר שבה המתקשרים שומעים רק את הפתיח שלך ואת הצפצוף.",
    "Background": "רקע",
    "Business Hours": "שעות פעילות",
    "Call Now": "התקשר עכשיו",
    "Call {name}": "התקשר ל-{name}",
    "Contact us web widget created successfully": "וידג'ט 'צור קשר' לאתר נוצר בהצלחה",
    "Contact us web widget updated successfully": "וידג'ט 'צור קשר' לאתר עודכן בהצלחה",
    "Content Text": "טקסט תוכן",
    "Edit Contact Us Web Widget": "ערוך וידג'ט 'צור קשר' לאתר",
    "How do I integrate it?": "איך משלבים את זה?",
    "Integration Script": "סקריפט האינטגרציה",
    "Label": "תווית",
    "Paste the script in your HTML just before the closing </body> tag": "הדבק את הסקריפט ב-HTML שלך ממש לפני תגית ה-</body> הסוגרת",
    "Please enter a valid hex color (e.g., #FF0000 or #F00)": "אנא הזן צבע HEX חוקי (לדוגמה, #FF0000 או #F00)",
    "Preview": "תצוגה מקדימה",
    "Show Keypad": "הצג מקלדת",
    "Shown once a route has Call enabled.": "מוצג לאחר שמסלול מופעל עם שיחה.",
    "Test Widget": "בדוק וידג'ט",
    "Time Group": "קבוצת זמן",
    "Create Contact Us Web Widget": "צור וידג'ט 'צור קשר' לאתר",
    "Edit SMS Campaign": "ערוך קמפיין SMS",
    "Approved": "אושר",
    "Access Denied": "הגישה נדחתה",
    "You don't have permission to view this page.": "אין לך הרשאה לצפות בדף זה.",
    "Failed to load report data": "טעינת נתוני הדוח נכשלה",
    "Sign in securely with your Reshetcall identity.": "התחברו באופן מאובטח עם זהות Reshetcall שלכם.",
    "These filters are not yet available in the new reports engine.": "מסננים אלה עדיין אינם זמינים במנוע הדוחות החדש.",
    "Agent status created": "סטטוס הסוכן נוצר",
    "Agent status updated": "סטטוס הסוכן עודכן",
    "Always": "תמיד",
    "Call forwarding created": "הפניית השיחות נוצרה",
    "Call forwarding updated": "הפניית השיחות עודכנה",
    "Conference created": "שיחת הוועידה נוצרה",
    "Conference updated": "שיחת הוועידה עודכנה",
    "End on moderator exit": "סיום עם יציאת המנחה",
    "Extension created": "השלוחה נוצרה",
    "Extension updated": "השלוחה עודכנה",
    "Leave empty to keep the current value": "השאירו ריק כדי לשמור על הערך הנוכחי",
    "Passthrough": "מקורי",
    "Remove admin pin": "הסרת קוד מנהל",
    "Remove user pin": "הסרת קוד משתמש",
    "Require answer confirmation": "דרישת אישור מענה",
    "This extension is already in use": "שלוחה זו כבר בשימוש",
    "Trigger": "טריגר",
    "Unreachable": "לא זמין",
    "The selected destination is no longer available": "היעד שנבחר אינו זמין עוד",
    "The selected media file is no longer available": "קובץ המדיה שנבחר אינו זמין עוד",
    "One of the selected labels is no longer available": "אחת התוויות שנבחרו אינה זמינה עוד",
    "One of the selected teams is no longer available": "אחד הצוותים שנבחרו אינו זמין עוד",
    "Invalid credentials": "פרטי ההתחברות שגויים",
    "Showing data for your teams only": "מציג נתונים עבור הצוותים שלך בלבד",
    "Couldn't remove the picture": "הסרת התמונה נכשלה",
    "The file size must not exceed 4 MB": "גודל הקובץ לא יכול לעלות על 4 MB",
    "Template created": "התבנית נוצרה",
    "A template needs a body": "תבנית חייבת לכלול גוף הודעה",
    "Template name must be lowercase letters, digits and underscores": "שם התבנית חייב להכיל אותיות קטנות, ספרות וקווים תחתונים בלבד",
    "Failed to create template": "יצירת התבנית נכשלה",
    "Nothing to update": "אין מה לעדכן",
    "Meta rejected the template change": "‏Meta דחתה את השינוי בתבנית",
    "Template submitted to Meta for approval": "התבנית נשלחה ל-Meta לאישור",
    "This template was already submitted": "התבנית כבר נשלחה",
    "Meta rejected the template": "‏Meta דחתה את התבנית",
    "Failed to submit template": "שליחת התבנית נכשלה",
    "That template no longer exists": "התבנית כבר לא קיימת",
    "Synced {count} number(s) from Meta": "סונכרנו {count} מספרים מ-Meta",
    "Only one WhatsApp Business Account can be connected per account. Not connected: {ids}.": "ניתן לחבר חשבון WhatsApp Business אחד בלבד לכל חשבון. לא חוברו: {ids}.",
    "A sync is already running. Try again in a moment.": "סנכרון כבר פועל. נסו שוב בעוד רגע.",
    "Number updated successfully": "המספר עודכן בהצלחה",
    "That number no longer exists": "המספר כבר לא קיים",
    "Failed to update number": "עדכון המספר נכשל",
    "You do not have permission to view WhatsApp settings": "אין לך הרשאה לצפות בהגדרות WhatsApp",
    "Could not load WhatsApp settings": "טעינת הגדרות WhatsApp נכשלה",
    "Try again": "נסה שוב",
    "Inbox assignment becomes available once inboxes are set up": "שיוך לתיבות דואר יהיה זמין לאחר הגדרת תיבות",
    "Removed at Meta": "הוסר ב-Meta",
    "Not available yet": "עדיין לא זמין",
    "Assignment updated": "השיוך עודכן",
    "Phone number in use named": "מספר הטלפון הזה כבר שייך ל-{name}.",
    "Phone number in use": "מספר הטלפון הזה כבר שייך לאיש קשר אחר.",
    "Permissions": "הרשאות",
    "Ring group created": "קבוצת הצלצול נוצרה",
    "Ring group updated": "קבוצת הצלצול עודכנה",
    "Sequential": "סדרתי",
    "One of the selected users is no longer available": "אחד המשתמשים שנבחרו אינו זמין עוד",
    "Voicemail created": "תא קולי נוצר",
    "Voicemail updated": "תא קולי עודכן",
    "Remove access code": "הסרת קוד גישה מרחוק",
    "Failed to load options": "טעינת האפשרויות נכשלה",
    "An error occurred while saving the inbox.": "אירעה שגיאה בעת שמירת תיבת הדואר הנכנס.",
    "invalid_verification_code": "קוד אימות שגוי",
    "verification_code_expired": "תוקף קוד האימות פג",
    "too_many_attempts": "יותר מדי ניסיונות שגויים. הקוד הזה כבר לא תקף — השתמש ב\"שלח שוב\" כדי לקבל קוד חדש.",
    "Time group created": "קבוצת הזמן נוצרה",
    "Time group updated": "קבוצת הזמן עודכנה",
    "Business hours created": "שעות הפעילות נוצרו",
    "Business hours updated": "שעות הפעילות עודכנו",
    "One of the selected time groups is no longer available": "אחת מקבוצות הזמן שנבחרו אינה זמינה עוד",
    "The selected time group is no longer available": "קבוצת הזמן שנבחרה אינה זמינה עוד",
    "Business hours cannot route to themselves": "שעות פעילות לא יכולות לנתב לעצמן",
    "You do not have permission to view time groups": "אין לך הרשאה לצפות בקבוצות זמן",
    "Congestion": "עומס",
    "Cannot delete, still in use by {items}": "לא ניתן למחוק, עדיין בשימוש על ידי {items}",
    "Access code must be 1 to 10 digits": "קוד הגישה חייב להיות באורך 1 עד 10 ספרות",
    "Cannot delete row in use": "לא ניתן למחוק: עדיין בשימוש על ידי {what}. יש להסיר אותו משם קודם.",
    "Cannot delete row in use generic": "לא ניתן למחוק: עדיין בשימוש.",
    "Leave empty to remove the PIN": "השאירו ריק כדי להסיר את הקוד",
    "View": "הצגה",
    "PIN must be 4 to 6 digits": "הקוד חייב להיות באורך 4 עד 6 ספרות",
    "Invalid value": "ערך לא תקין",
    "The start and end times cannot be the same": "שעת ההתחלה ושעת הסיום לא יכולות להיות זהות",
    "skipped team members": "{count, plural, one {משתמש אחד שנבחר אינו זמין עוד ולא נוסף} other {# משתמשים שנבחרו אינם זמינים עוד ולא נוספו}}",
    "skipped team statuses": "{count, plural, one {סטטוס אחד שנבחר אינו זמין עוד ולא נוסף} other {# סטטוסים שנבחרו אינם זמינים עוד ולא נוספו}}",
    "An error occurred while saving the team.": "אירעה שגיאה בעת שמירת הצוות.",
    "Media file created": "קובץ המדיה נוצר",
    "Media file updated": "קובץ המדיה עודכן",
    "This file has already been uploaded": "הקובץ הזה כבר הועלה.",
    "Converting audio...": "ממיר אודיו...",
    "This audio file could not be read": "לא ניתן לקרוא את קובץ האודיו הזה. נסה קובץ אחר.",
    "Media file is in use": "קובץ המדיה בשימוש ולא ניתן למחוק אותו.",
    "Media file is in use by": "לא ניתן למחוק את קובץ המדיה — הוא עדיין בשימוש על ידי {entities}.",
    "Announcement created": "ההודעה נוצרה",
    "Announcement updated": "ההודעה עודכנה",
    "Media file not found": "קובץ המדיה לא נמצא",
    "Label not found": "התווית לא נמצאה",
    "The file is too large": "הקובץ גדול מדי. הגודל המרבי הוא {size}.",
    "Text to speech is unavailable right now": "המרת טקסט לדיבור אינה זמינה כרגע. נסה שוב מאוחר יותר.",
    "No longer available": "לא זמין עוד",
    "Extensions longer than Max digits cannot be dialed": "שלוחות {digits} ארוכות ממקסימום הספרות ולא ניתן לחייג אליהן",
    "Longer than Max digits": "לא יכול לעלות על מקסימום ספרות ({max})",
    "An auto attendant cannot point at itself": "נתב שיחות אוטומטי לא יכול להצביע על עצמו",
    "One of the selected extensions is no longer available": "אחת מהשלוחות שנבחרו אינה זמינה עוד",
    "Too many items": "יותר מדי פריטים",
    "You do not have permission to view users": "אין לך הרשאה לצפות במשתמשים",
    "This audio is too long": "האודio ארוך מדי. המקסימום הוא כ-{minutes} דקות לאחר ההמרה.",
    "Too many requests. Please try again in a moment.": "יותר מדי בקשות. נסה שוב בעוד רגע.",
    "Call queue created": "תור שיחות נוצר",
    "Call queue updated": "תור שיחות עודכן",
    "Dynamic - Position in Queue": "דינמי - מיקום בתור",
    "Dynamic - Estimated Wait Time in Queue": "דינמי - זמן המתנה משוער בתור",
    "Plays the selected audio in the order defined below to callers waiting in the queue": "נגן את השמע הנבחר לפי הסדר המוגדר למתקשרים הממתינים בתור",
    "Invalid value in field": "ערך לא תקין: {field}",
    "Currently routes to": "מנתב כרגע אל {name}",
    "Too many requests. Please try again in {seconds} seconds.": "יותר מדי בקשות. נסו שוב בעוד {seconds, plural, one {שנייה #} other {# שניות}}.",
    "Too many requests. Please try again in {minutes} minutes.": "יותר מדי בקשות. נסו שוב בעוד {minutes, plural, one {דקה #} other {# דקות}}.",
    "Connecting your WhatsApp Business account and syncing numbers and templates…": "מחבר את חשבון WhatsApp Business ומסנכרן מספרים ותבניות…",
    "Waiting for Meta to finish registering — this can take a moment": "ממתין ל-Meta לסיום הרישום — זה עשוי לקחת רגע",
    "Account settings are unavailable right now. Please try again shortly.": "הגדרות החשבון אינן זמינות כעת. נסו שוב בעוד מספר רגעים.",
    "These prices have expired. Please search again.": "המחירים האלה פגו. יש לחפש שוב.",
    "That selection is no longer valid. Please search again.": "הבחירה הזו כבר אינה תקפה. יש לחפש שוב.",
    "That number sold out while ordering. Please search again.": "המספר הזה נמכר במהלך ההזמנה. יש לחפש שוב.",
    "That number is no longer available. Please search again.": "המספר הזה אינו זמין עוד. יש לחפש שוב.",
    "Your card would not authorize this purchase.": "הכרטיס שלך לא אישר את הרכישה הזו.",
    "Your balance does not cover this purchase.": "היתרה שלך אינה מכסה את הרכישה הזו.",
    "Some numbers could not be bought": "לא ניתן היה לרכוש חלק מהמספרים",
    "We could not complete that purchase. Please try again shortly.": "לא הצלחנו להשלים את הרכישה. יש לנסות שוב בעוד רגע.",
    "Please buy at most {max} numbers at a time": "יש לרכוש עד {max} מספרים בכל פעם",
    "That sign-in was cancelled. Please try again.": "That sign-in was cancelled. Please try again.",
    "Your sign-in with that provider has expired. Please start again.": "תוקף ההתחברות דרך הספק הזה פג. התחל מחדש.",
    "Conversation history": "היסטוריית שיחות",
    "No earlier conversations.": "אין שיחות קודמות.",
    "Supervisors": "מפקחים",
    "Mine": "שלי",
    "Unread": "לא נקראו",
    "Pick a conversation": "בחר שיחה",
    "New group": "קבוצה חדשה",
    "Create group": "צור קבוצה",
    "Add people": "הוסף אנשים",
    "Leave group": "עזוב את הקבוצה",
    "Leave this group?": "לעזוב את הקבוצה הזו?",
    "You will stop receiving its messages.": "תפסיק לקבל את ההודעות שלה.",
    "Direct message": "הודעה ישירה",
    "Internal chat": "צ'אט פנימי",
    "Search people": "חפש אנשים",
    "No colleagues found": "לא נמצאו עמיתים",
    "New message": "הודעה חדשה",
    "Start a conversation from one of your numbers.": "התחל שיחה מאחד המספרים שלך.",
    "No numbers can send messages": "אין מספרים שיכולים לשלוח הודעות",
    "Choose a number": "בחר מספר",
    "Type a message": "הקלד הודעה",
    "The message could not be sent. Check the number and try again.": "לא ניתן היה לשלוח את ההודעה. בדוק את המספר ונסה שוב.",
    "What would you like to start?": "מה תרצה להתחיל?",
    "Messaging": "הודעות",
    "An inbox is a shared pool. Its staff see every unclaimed conversation in it.": "תיבה היא מאגר משותף. הצוות שלה רואה כל שיחה שטרם נתבעה בה.",
    "New inbox": "תיבה חדשה",
    "No inboxes yet. Create one and add the people who will work it.": "אין תיבות עדיין. צור אחת והוסף את האנשים שיעבדו עליה.",
    "Archived": "בארכיון",
    "Nobody is staffing this inbox": "אף אחד לא מטפל בתיבה זו",
    "Unarchive": "שחזר מהארכיון",
    "Archive": "העבר לארכיון",
    "Rename inbox": "שנה שם לתיבה",
    "A supervisor also sees what the inbox's agents have claimed.": "מפקח רואה גם את מה שנציגי התיבה תבעו.",
    "Create inbox": "צור תיבה",
    "Any number": "כל מספר",
    "Move up": "הזז למעלה",
    "Move down": "הזז למטה",
    "Channel": "ערוץ",
    "Use this number": "השתמש במספר זה",
    "New conversation": "שיחה חדשה",
    "Choose who to message, then write below.": "בחר למי לשלוח, ואז כתוב למטה.",
    "Who works which conversations": "מי מטפל באילו שיחות",
    "Messaging route": "ניתוב הודעות",
    "Messages to this number reach nobody": "הודעות למספר הזה לא מגיעות לאף אחד",
    "The route could not be saved.": "לא ניתן היה לשמור את הניתוב.",
    "No numbers yet": "אין מספרים עדיין",
    "Move to inbox": "העבר לתיבה",
    "Reopen": "פתח מחדש",
    "Show details": "הצג פרטים",
    "Hide details": "הסתר פרטים",
    "Join this conversation to reply.": "הצטרף לשיחה כדי להשיב.",
    "Alphabetical": "לפי סדר אלפביתי",
    "Date Created": "תאריך יצירה",
    "Date Updated": "תאריך עדכון",
    "These numbers still feed this inbox": "המספרים הבאים עדיין מזינים תיבה זו",
    "The inbox could not be archived.": "לא ניתן היה להעביר את התיבה לארכיון.",
    "Manage inboxes assigned to users and teams": "נהל תיבות דואר נכנס המוקצות למשתמשים ולצוותים",
    "The inbox is archived, not erased: its conversations stay, and nobody sees them until it is restored.": "התיבה מועברת לארכיון, לא נמחקת: השיחות שלה נשמרות, ואיש לא רואה אותן עד שתשוחזר.",
    "Add inbox": "הוסף תיבה",
    "Edit inbox": "ערוך תיבה",
    "Delete inbox": "מחק תיבה",
    "Greeting Message": "הודעת פתיחה",
    "Enter a greeting message for inbound conversations...": "הזן הודעת פתיחה לשיחות נכנסות...",
    "When an inbound message arrives, this greeting is sent as the generic first reply. After that, an user can assign the conversation to themselves.": "כאשר מגיעה הודעה נכנסת, הודעת פתיחה זו נשלחת כמענה הראשון. לאחר מכן, משתמש יכול לשייך את השיחה לעצמו.",
    "The inbox could not be saved.": "לא ניתן היה לשמור את התיבה.",
    "The name and greeting were saved, but the staff could not be updated.": "השם והודעת הפתיחה נשמרו, אך לא ניתן היה לעדכן את הצוות.",
    "{cleared} numbers were cleared; {remaining} still feed this inbox. Try again to clear the rest.": "{cleared} מספרים נוקו; {remaining} עדיין מזינים תיבה זו. נסה שוב כדי לנקות את השאר.",
    "{cleared} of them were already cleared.": "{cleared} מהם כבר נוקו.",
    "chat system created": "{actor} יצר את הצ'אט.",
    "chat system claimed": "{actor} הצטרף לצ'אט.",
    "chat system assigned": "{actor} העביר את הצ'אט אל {target}.",
    "chat system released": "{actor} עזב את הצ'אט.",
    "chat system moved": "{actor} העביר את הצ'אט אל {target}.",
    "chat system closed": "{actor} סיים את הצ'אט.",
    "chat system reopened": "{actor} פתח מחדש את הצ'אט.",
    "chat system member added": "{actor} הוסיף את {target} לצ'אט.",
    "chat system member removed": "{actor} הסיר את {target} מהצ'אט.",
    "chat system member left": "{actor} עזב את הצ'אט.",
    "chat system renamed": "{actor} שינה את שם הצ'אט ל־{target}.",
    "chat system announcement": "הודעה\n{body}",
    "chat system more": "עוד {count}",
    "A template with no inboxes is offered to nobody": "תבנית ללא תיבות לא מוצעת לאף אחד",
    "Team Inboxes": "תיבות צוות",
    "Could not load inboxes": "לא ניתן היה לטעון את התיבות",
    "Invitation resent automatically": "ההזמנה נשלחה מחדש באופן אוטומטי",
    "invitation_resent_to_new_email": "הזמנה חדשה נשלחה אל {email}. אין צורך לשלוח אותה שוב.",
    "The inbox stopped working. Your messages are safe.": "תיבת הדואר הנכנס הפסיקה לעבוד. ההודעות שלך בטוחות.",
    "TEAM INBOXES": "תיבות צוות",
    "Close conversation": "סגור שיחה",
    "Are you sure you want to close this conversation?": "האם אתה בטוח שברצונך לסגור את השיחה?",
    "Leave conversation": "עזוב שיחה",
    "Are you sure you want to leave this conversation?": "האם אתה בטוח שברצונך לעזוב את השיחה?",
    "Personal Inboxes": "תיבות אישיות",
    "No items": "אין פריטים",
    "My Inbox": "התיבה שלי",
    "Internal Chat": "צ'אט פנימי",
    "Logs": "יומנים",
    "PBX Studio": "PBX Studio",
    "SIP Trunks": "טראנקים של SIP",
    "Channels": "ערוצים",
    "My Business": "העסק שלי",
    "Message Logs": "יומן הודעות",
    "WhatsApp": "WhatsApp",
    "Loading…": "טוען…",
    "Display Name": "שם תצוגה",
    "No phone numbers attached yet": "עדיין לא שויכו מספרי טלפון",
    "WhatsApp Business account connected successfully": "חשבון WhatsApp Business חובר בהצלחה",
    "Connected WhatsApp Business Accounts": "חשבונות WhatsApp Business מחוברים",
    "WhatsApp business numbers": "מספרי WhatsApp Business",
    "Add Inbox": "הוסף תיבה",
    "Remove {name} from this group?": "להסיר את {name} מהקבוצה?",
    "Callback pending": "שיחה חוזרת ממתינה",
    "Wallboard not available": "לוח התצוגה אינו זמין",
    "That wallboard link is already in use. Reload the page and try again.": "הקישור ללוח התצוגה הזה כבר בשימוש. טען מחדש את הדף ונסה שוב.",
    "Live updates paused": "העדכונים החיים מושהים",
    "Totals may be incomplete": "הסיכומים עשויים להיות חלקיים",
    "Name is too long": "השם ארוך מדי",
    "The board is too large to save. Use a smaller logo image.": "הלוח גדול מדי לשמירה. השתמש בתמונת לוגו קטנה יותר.",
    "Wallboard not found": "לוח התצוגה לא נמצא",
    "No wallboard hash provided": "לא סופק מזהה לוח תצוגה",
    "Failed to save wallboard": "שמירת לוח התצוגה נכשלה",
    "Wallboard Validation Failed": "אימות לוח התצוגה נכשל",
    "Please try again later.": "נסה שוב מאוחר יותר.",
    "Failed to change status": "שינוי הסטטוס נכשל",
    "Reference data may be out of date": "נתוני העזר עשויים להיות לא מעודכנים",
    "We've sent you a WhatsApp message with a verification code": "שלחנו לך הודעת WhatsApp עם קוד אימות",
    "This verification method is not available for your country.": "שיטת אימות זו אינה זמינה במדינה שלך.",
    "This phone number is already in use by another account.": "מספר הטלפון הזה כבר בשימוש בחשבון אחר.",
    "This is already your verified number.": "זה כבר המספר המאומת שלך.",
    "Not verified": "לא מאומת",
    "Phone code expired": "תוקף הקוד פג.",
    "Verification Code": "קוד אימות",
    "Authenticator app enabled": "אפליקציית אימות פעילה",
    "Change 2FA": "שינוי אימות דו-שלבי",
    "Email enabled": "דוא\"ל פעיל",
    "Methods used for two-factor authentication": "שיטות המשמשות לאימות דו-שלבי",
    "Or enter this key": "או הזינו את המפתח הזה",
    "Scan the QR code with your authenticator app": "סרקו את קוד ה-QR באפליקציית האימות",
    "That code is not valid. Check the code and try again": "הקוד אינו תקין. בדקו את הקוד ונסו שוב",
    "This setup has expired. Start again": "תוקף ההגדרה פג. התחילו מחדש",
    "Verify your email to use it for 2FA": "אמתו את כתובת הדוא\"ל כדי להשתמש בה לאימות דו-שלבי",
    "Receive a sign-in code by email": "קבלת קוד כניסה בדוא\"ל",
    "We couldn't load your invoices.": "לא הצלחנו לטעון את החשבוניות שלך.",
    "No invoices yet": "אין עדיין חשבוניות",
    "Paid": "שולם",
    "Unpaid": "לא שולם",
    "Void": "בוטל",
    "Wallet top-up": "טעינת יתרה",
    "+{count} more": "+{count} נוספים",
    "PDF": "PDF",
    "Complete the card verification to finish your top-up": "השלם את אימות הכרטיס כדי לסיים את הטעינה",
    "The card was declined.": "הכרטיס נדחה.",
    "This country is already used": "מדינה זו כבר בשימוש",
    "You do not have permission to view phone numbers": "אין לך הרשאה לצפות במספרי טלפון",
    "Upgrade": "שדרג",
    "You have {used} queues; {plan} allows {allowed}. Delete {delete} to continue.": "יש לך {used} תורים; התוכנית {plan} מאפשרת {allowed}. מחק {delete} כדי להמשיך.",
    "Changes to {plan} on {date}": "שינוי ל-{plan} בתאריך {date}",
    "Keep current plan": "השאר את התוכנית הנוכחית",
    "Remove users before reducing seats": "{used} משתמשים פעילים — הסר משתמשים לפני הקטנת מספר המושבים.",
    "All seats are in use. Add seats to your plan to invite more users.": "כל המושבים בשימוש. הוסף מושבים לתוכנית שלך כדי להזמין משתמשים נוספים.",
    "All seats are in use. Add seats to your plan to reactivate this user.": "כל המושבים בשימוש. הוסף מושבים לתוכנית שלך כדי להפעיל מחדש את המשתמש.",
    "Could not load your 2FA settings": "לא הצלחנו לטעון את הגדרות האימות הדו-שלבי",
    "Some changes were saved. Check your settings and try again": "חלק מהשינויים נשמרו. בדקו את ההגדרות ונסו שוב",
    "Please validate your authentication code": "אמתו את קוד האימות",
    "We couldn't save your number right now. Please try again.": "לא הצלחנו לשמור את המספר שלך כרגע. נסו שוב.",
    "We couldn't send the code by SMS. Please try another method.": "לא הצלחנו לשלוח את הקוד ב-SMS. נסו שיטה אחרת.",
    "We couldn't send the code over WhatsApp. Please try SMS instead.": "לא הצלחנו לשלוח את הקוד ב-WhatsApp. נסו SMS במקום.",
    "We can't send the code right now. Please try again shortly.": "לא ניתן לשלוח את הקוד כרגע. נסו שוב בעוד רגע.",
    "Too many incorrect attempts. That code is no longer valid. Send a new code.": "יותר מדי ניסיונות שגויים. הקוד הזה כבר לא תקף. שלחו קוד חדש.",
    "We couldn't load your account": "לא הצלחנו לטעון את החשבון שלך",
    "Try again, or log out and sign in again if the problem continues": "נסה שוב, או התנתק והתחבר מחדש אם הבעיה נמשכת",
    "You can't sign in from this location ({ip}). Please contact your administrator.": "לא ניתן להתחבר ממיקום זה ({ip}). פנו למנהל המערכת.",
    "You can't sign in from this location. Please contact your administrator.": "לא ניתן להתחבר ממיקום זה. פנו למנהל המערכת.",
    "Your password has been changed, but you can't sign in from this location. Please contact your administrator.": "הסיסמה שלך שונתה, אך לא ניתן להתחבר ממיקום זה. פנו למנהל המערכת.",
    "Allowed IP addresses": "כתובות IP מורשות",
    "You do not have permission to view queues": "אין לך הרשאה לצפות בתורים",
    "The role was saved, but the agent status did not update": "התפקיד נשמר, אך סטטוס הסוכן לא עודכן",
    "$0.00 today, cancel anytime before your trial ends on {date}": "0.00$ היום, אפשר לבטל בכל עת לפני שתקופת הניסיון מסתיימת ב-{date}",
    "You have {used} web widgets; {plan} allows {allowed}. Delete {delete} to continue.": "יש לך {used} ווידג'טים לאתר; התוכנית {plan} מאפשרת {allowed}. מחק {delete} כדי להמשיך.",
    "{plan} allows up to {max} seats.": "התוכנית {plan} מאפשרת עד {max} מושבים.",
    "Card added, but it could not be kept as non-default": "הכרטיס נוסף, אך לא ניתן היה להשאיר אותו שלא ככרטיס ברירת מחדל",
    "Enter a valid ZIP code": "הזן מיקוד תקין",
    "Business location": "מיקום העסק",
    "Card verification failed. Try again or use another card.": "אימות הכרטיס נכשל. נסה שוב או השתמש בכרטיס אחר.",
    "Payment received. Your balance will update shortly.": "התשלום התקבל. היתרה שלך תתעדכן בקרוב.",
    "Up to {count} email addresses": "ניתן להוסיף עד {count} כתובות דוא\"ל",
    "Test email not sent to {emails}": "דוא\"ל הבדיקה לא נשלח אל {emails}",
    "Voicemail saved, but where its recordings are delivered was not changed": "התא הקולי נשמר, אך היעד שאליו נמסרות ההקלטות שלו לא שונה",
    "Withheld number": "מספר חסוי",
    "Not delivered": "לא נמסר",
    "Transcript": "תמלול",
    "This conversation is closed. Reopen it to reply.": "השיחה הזו סגורה. פתח אותה מחדש כדי להשיב.",
    "Voicemails can't be answered here. Call the caller back.": "לא ניתן להשיב כאן להודעות קוליות. חזור למתקשר.",
    "Voicemails can't be answered here, and this caller's number was withheld.": "לא ניתן להשיב כאן להודעות קוליות, ומספר המתקשר חסוי.",
    "Confirmation link sent to {email}": "נשלח קישור אישור אל {email}",
    "The new email is pending, but the confirmation link could not be sent. Use Resend Verification Link in a minute.": "הדואר האלקטרוני החדש ממתין לאישור, אך לא ניתן היה לשלוח את קישור האישור. השתמש באפשרות שלח מחדש קישור אימות בעוד דקה.",
    "There is no pending email change for this user.": "אין שינוי דואר אלקטרוני ממתין עבור משתמש זה.",
    "Confirm new email": "אישור דואר אלקטרוני חדש",
    "Click the button below to confirm your new email address.": "לחץ על הכפתור למטה כדי לאשר את כתובת הדואר האלקטרוני החדשה שלך.",
    "Your email has been changed. You can now sign in with {email}.": "הדואר האלקטרוני שלך שונה. כעת תוכל להתחבר עם {email}.",
    "This email was already confirmed. You can sign in with {email}.": "דואר אלקטרוני זה כבר אושר. תוכל להתחבר עם {email}.",
    "This confirmation link has expired. Ask your administrator to send a new one.": "תוקף קישור האישור פג. בקש ממנהל המערכת לשלוח קישור חדש.",
    "This confirmation link has already been used.": "קישור האישור הזה כבר נוצל.",
    "This confirmation link is no longer valid.": "קישור האישור הזה כבר אינו תקף.",
    "A confirmation email was sent recently. Save the new email again in a minute.": "הודעת אישור נשלחה לאחרונה. שמור שוב את הדואר האלקטרוני החדש בעוד דקה.",
    "The pending email change was cancelled.": "שינוי הדואר האלקטרוני הממתין בוטל.",
    "We could not confirm your email right now. Your link may still work, so try again.": "לא הצלחנו לאשר את הדואר האלקטרוני שלך כרגע. ייתכן שהקישור עדיין תקף, לכן נסה שוב.",
    "Time-based (TOTP), SHA1, 6 digits, 30 seconds": "מבוסס זמן (TOTP), SHA1, 6 ספרות, 30 שניות",
    "Available once the invitation is accepted": "יהיה זמין לאחר שההזמנה תתקבל",
    "The user's email is not verified, so it cannot be used for 2FA": "כתובת האימייל של המשתמש לא אומתה, ולכן אי אפשר להשתמש בה לאימות דו-שלבי",
    "2FA cannot be turned on: the user has no verified method": "לא ניתן להפעיל אימות דו-שלבי: למשתמש אין שיטה מאומתת",
    "We couldn't send the code by email. Please try again.": "לא הצלחנו לשלוח את הקוד באימייל. נסה שוב.",
    "Always sent to the account owner: {email}": "תמיד נשלח לבעל החשבון: {email}",
    "The following numbers are already registered under another campaign: {numbers}": "המספרים הבאים כבר רשומים תחת קמפיין אחר: {numbers}",
    "Some of the selected numbers are no longer available. Please pick again.": "חלק מהמספרים שנבחרו אינם זמינים עוד. יש לבחור מחדש.",
    "In review": "בבדיקה",
    "Deactivate": "השבתה",
    "Choose how many messages you expect to send": "בחרו כמה הודעות אתם מצפים לשלוח",
    "{price} per month": "{price} לחודש",
    "Low volume": "נפח נמוך",
    "High volume": "נפח גבוה",
    "How many messages do you expect to send?": "כמה הודעות אתם מצפים לשלוח?",
    "A2P registration is not part of your current plan. Contact sales to add it.": "רישום A2P אינו חלק מהתוכנית הנוכחית שלכם. פנו למכירות כדי להוסיף אותו.",
    "This campaign can no longer be edited": "לא ניתן עוד לערוך את הקמפיין הזה",
    "Your brand is registered with the carriers. Contact support to change it.": "המותג שלכם רשום אצל הספקים. פנו לתמיכה כדי לשנות אותו.",
    "Your payment was declined. Update your payment method and try again.": "התשלום נדחה. עדכנו את אמצעי התשלום ונסו שוב.",
    "A2P registration needs an active subscription.": "רישום A2P דורש מנוי פעיל.",
    "A2P registration is not enabled for this account yet. Contact support.": "רישום A2P עדיין אינו זמין לחשבון הזה. פנו לתמיכה.",
    "Campaign deactivated": "הקמפיין הושבת",
    "Failed to deactivate campaign": "השבתת הקמפיין נכשלה",
    "{count} waiting for assignment": "{count} ממתינים לשיוך",
    "waiting for assignment": "ממתין לשיוך",
    "Deactivate campaign": "השבתת קמפיין",
    "Billing stops and its numbers can no longer text US recipients. This cannot be undone: you would have to register again.": "החיוב ייפסק והמספרים שלו לא יוכלו עוד לשלוח הודעות לנמענים בארה\"ב. לא ניתן לבטל פעולה זו: יהיה עליכם להירשם מחדש.",
    "Submitted": "נשלח",
    "Stopped because of a billing problem on our side. Contact support.": "הופסק בגלל בעיית חיוב אצלנו. פנו לתמיכה.",
    "Stopped because the account was closed.": "הופסק כי החשבון נסגר.",
    "Stopped because your subscription ended.": "הופסק כי המנוי שלכם הסתיים.",
    "Stopped by you.": "הופסק על ידכם.",
    "Manage numbers": "ניהול מספרים",
    "Numbers updated": "המספרים עודכנו",
    "Added numbers wait for support to assign them before they can text US recipients. Removed numbers stop sending at once.": "מספרים שנוספו ממתינים לשיוך על ידי התמיכה לפני שיוכלו לשלוח הודעות לנמענים בארה\"ב. מספרים שהוסרו מפסיקים לשלוח מיד.",
    "This number isn't available for registration yet. Contact support to add it to your account.": "המספר הזה עדיין אינו זמין לרישום. פנו לתמיכה כדי להוסיף אותו לחשבון שלכם.",
    "The volume tier is fixed after the first submit. Contact support to change it.": "רמת הנפח נקבעת לאחר השליחה הראשונה. פנו לתמיכה כדי לשנות אותה.",
    "{price} per year": "{price} לשנה",
    "Not available on your plan": "לא זמין בתוכנית שלכם",
    "We couldn't load the prices. Retry to see them before you submit.": "לא הצלחנו לטעון את המחירים. נסו שוב כדי לראות אותם לפני השליחה.",
    "Note from support": "הערה מהתמיכה",
    "This registration is already being submitted. Try again in a few minutes.": "הרישום כבר נשלח כעת. נסו שוב בעוד כמה דקות.",
    "SMS registration is unavailable while your account is restricted. Contact support.": "רישום SMS אינו זמין כל עוד החשבון שלכם מוגבל. פנו לתמיכה.",
    "Billing refused this registration. Contact support.": "החיוב סירב לרישום הזה. פנו לתמיכה.",
    "The volume tier changed since the price was shown. Check the price and submit again.": "רמת הנפח השתנתה מאז שהמחיר הוצג. בדקו את המחיר ושלחו שוב.",
    "Campaign actions": "פעולות קמפיין",
    "Your account's billing country isn't confirmed yet. Contact support to confirm it.": "מדינת החיוב של החשבון עדיין לא אושרה. פנו לתמיכה כדי לאשר אותה.",
    "Up to 15,000 messages a month": "עד 15,000 הודעות בחודש",
    "More than 15,000 messages a month": "יותר מ-15,000 הודעות בחודש",
    "Due when you submit": "לתשלום בעת השליחה",
    "Brand registration {brand} and vetting {vetting}": "רישום מותג {brand} ובדיקה {vetting}",
    "Vetting {vetting}. Your brand is already registered.": "בדיקה {vetting}. המותג שלך כבר רשום.",
    "When approved, the first {months} months up front": "עם האישור, {months} החודשים הראשונים מראש",
    "After that, renewed with your plan": "לאחר מכן, מתחדש עם התוכנית שלך",
    "These are the carrier's fees and are not refunded, even when a registration is rejected. Resubmitting pays the vetting again.": "אלה עמלות של חברת התקשורת והן אינן מוחזרות, גם כאשר רישום נדחה. שליחה מחדש מחייבת שוב את דמי הבדיקה.",
    "Your balance doesn't cover the submission fees. Top up and submit again.": "היתרה שלך אינה מכסה את דמי השליחה. הטען יתרה ושלח שוב.",
    "Add a payment method to your plan, then submit again.": "הוסיפו אמצעי תשלום לתוכנית שלכם ושלחו שוב.",
    "Charged to your plan's payment method, plus tax where it applies.": "החיוב מתבצע באמצעי התשלום של התוכנית שלכם, בתוספת מס כשהוא חל.",
    "The submission fees changed since they were shown. Check them and submit again.": "דמי השליחה השתנו מאז שהוצגו. בדוק אותם ושלח שוב.",
    "{numbers} can no longer stay on this registration and will be removed when you save.": "{numbers} לא יכול להישאר ברישום הזה ויוסר בשמירה.",
    "This account signs in with a different provider. Use that one, or choose Forgot Password to set a password.": "החשבון הזה מתחבר דרך ספק אחר. השתמשו בו, או בחרו \"שכחת סיסמה?\" כדי להגדיר סיסמה.",
    "SSO authentication is disabled.": "אימות SSO מושבת.",
    "Connect your {provider} account": "חיבור חשבון {provider}",
    "This email already has an account. Enter your password to connect": "לכתובת המייל הזו כבר יש חשבון. הזינו את הסיסמה כדי לחבר",
    "Incorrect password. Please try again.": "סיסמה שגויה. נסו שוב.",
    "Connect and log in": "חיבור וכניסה",
    "Call Details": "פרטי שיחה",
    "Call ended": "השיחה הסתיימה",
    "Call flow started": "תהליך השיחה התחיל",
    "Call rejected": "השיחה נדחתה",
    "Could not load the call steps": "לא ניתן לטעון את שלבי השיחה",
    "Flow finished": "התהליך הסתיים",
    "Hung up": "נותק",
    "Joined conference": "הצטרף לוועידה",
    "No steps were recorded for this call": "לא נרשמו שלבים לשיחה זו",
    "Played announcement": "הושמעה הודעה",
    "Queue option": "אפשרות בתור",
    "Recording": "הקלטה",
    "Routed": "נותב",
    "Routed to call flow": "נותב לתהליך שיחה",
    "Sent to device": "נשלח למכשיר",
    "Sent to queue": "נשלח לתור",
    "Step": "שלב",
    "Virtual hold": "המתנה וירטואלית",
    "Waited for keypad input": "המתין להקשה",
    "Keypad input": "הקשה",
    "Caller hung up": "המתקשר ניתק",
    "Enter comma-separated emails": "הזן כתובות דוא\"ל מופרדות בפסיקים",
    "You've reached the limit of three custom plans. Please remove one to add a new plan": "הגעת למגבלה של שלוש תוכניות מותאמות אישית. הסר אחת כדי להוסיף תוכנית חדשה",
    "The user has been signed out": "המשתמש נותק מהמערכת",
    "Users will be signed out": "{count, plural, one {משתמש אחד נותק} other {# משתמשים נותקו}} מהמערכת.",
    "Users could not be signed out": "{count, plural, one {לא ניתן היה לנתק משתמש אחד} other {לא ניתן היה לנתק # משתמשים}} מהמערכת. נסו שוב.",
    "An administrator signed you out": "מנהל המערכת ניתק אותך",
    "Plan Details": "פרטי התוכנית",
    "The email was not changed because the user was deactivated.": "הדואר האלקטרוני לא שונה כי המשתמש הושבת.",
    "Open the confirmation link from your email again.": "פתח שוב את קישור האישור מהדואר האלקטרוני שלך.",
    "Your password has expired": "פג תוקף הסיסמה שלך",
    "Sign in to choose a new one": "היכנסו כדי לבחור סיסמה חדשה",
    "Choose a new password to continue": "בחרו סיסמה חדשה כדי להמשיך.",
    "Sign in with the account for {email}.": "התחברו עם החשבון של {email}.",
    "Your organization has no free seats. Contact your administrator.": "אין מושבים פנויים בארגון שלכם. פנו למנהל המערכת.",
    "This email already has an account. Please log in.": "לכתובת האימייל הזו כבר יש חשבון. אנא התחברו.",
    "Something went wrong. Please try again.": "משהו השתבש. אנא נסו שוב.",
    "Your organization has no active subscription. Contact your administrator.": "לארגון שלכם אין מנוי פעיל. פנו למנהל המערכת.",
    "We couldn't check your organization's seats. Please try again in a few minutes.": "לא הצלחנו לבדוק את המושבים בארגון שלכם. אנא נסו שוב בעוד מספר דקות.",
    "Delete this integration? Its API keys stop working at once.": "למחוק את האינטגרציה? מפתחות ה-API שלה יפסיקו לעבוד מיד.",
    "On save the API key is revoked and requests using it are refused.": "בשמירה מפתח ה-API יישלל, ובקשות שמשתמשות בו יידחו.",
    "Show key": "הצג מפתח",
    "Hide key": "הסתר מפתח",
    "Regenerate API key": "יצירה מחדש של מפתח API",
    "Refuse": "דחה",
    "Browser session enabled": "הפעלת דפדפן הופעלה",
    "Browser session disabled": "הפעלת דפדפן הושבתה",
    "On save the browser session will be enabled for all integrations": "בשמירה, הפעלת דפדפן תופעל עבור כל האינטגרציות",
    "On save the browser session will be disabled for all integrations": "בשמירה, הפעלת דפדפן תושבת עבור כל האינטגרציות",
    "The browser session dials phone numbers only.": "הפעלת דפדפן מחייגת רק למספרי טלפון.",
    "This key can't be shown. Regenerate to get a new one.": "לא ניתן להציג את המפתח הזה. צרו מחדש כדי לקבל מפתח חדש.",
    "A new key replaces this integration's keys, which keep working until you save.": "מפתח חדש יחליף את המפתחות של האינטגרציה הזו, שימשיכו לעבוד עד שתשמרו.",
    "The new key could not be saved, so a new one is shown. Copy it again, then save.": "לא ניתן היה לשמור את המפתח החדש, ולכן מוצג מפתח חדש. העתיקו אותו שוב ואז שמרו.",
    "Agent keys made through the API are revoked too when a new key is saved or the API is turned off.": "מפתחות סוכן שנוצרו דרך ה-API נשללים גם הם כששומרים מפתח חדש או מכבים את ה-API.",
    "Recommended: allow only the IP addresses your clicks come from, so a leaked key cannot be used elsewhere. A link the CRM opens in the agent's browser comes from your office's public IP.": "מומלץ: אפשרו רק את כתובות ה-IP שמהן מגיעות הלחיצות, כך שמפתח שדלף לא יוכל לשמש ממקום אחר. קישור שה-CRM פותח בדפדפן של הסוכן מגיע מכתובת ה-IP הציבורית של המשרד שלכם.",
    "Select users to remove": "בחרו משתמשים להסרה",
    "Pick {count} users to remove. They are deactivated on the next billing date.": "בחרו {count} משתמשים להסרה. הם יושבתו בתאריך החיוב הבא.",
    "Remove {name}": "הסרת {name}",
    "Account Owner": "בעלי החשבון",
    "Loading users…": "טוען משתמשים…",
    "{picked} of {count} selected": "נבחרו {picked} מתוך {count}",
    "Your card was declined. The seat count has not changed.": "הכרטיס נדחה. מספר המושבים לא השתנה.",
    "Trial seat limit reached. Start your paid plan to add more users.": "הגעתם למגבלת המושבים בתקופת הניסיון. התחילו את המסלול בתשלום כדי להוסיף משתמשים.",
    "Another plan change is still being processed. Please try again in a moment.": "שינוי אחר במסלול עדיין מתבצע. נסו שוב בעוד רגע.",
    "Pick which users to remove before lowering the seats.": "בחרו אילו משתמשים להסיר לפני הקטנת מספר המושבים.",
    "Seat change scheduled": "שינוי המושבים תוזמן",
    "Seat change scheduled for {date}.": "שינוי המושבים מתוזמן ל-{date}.",
    "Review seat change": "סקירת שינוי המושבים",
    "Users removed on the billing date": "משתמשים שיוסרו בתאריך החיוב",
    "{plan} requires at least {min} seats.": "מסלול {plan} דורש לפחות {min} מושבים.",
    "You have {count} users. Next, you'll choose who to remove.": "יש לכם {count} משתמשים. בשלב הבא תבחרו את מי להסיר.",
    "{plan} includes a minimum of {min} seats. You're using {used}, so {free} are free to assign.": "מסלול {plan} כולל מינימום של {min} מושבים. אתם משתמשים ב-{used}, כך ש-{free} פנויים להקצאה.",
    "Cancel the scheduled seat change?": "לבטל את שינוי המושבים המתוזמן?",
    "You keep your {count} seats and nobody is removed.": "תשמרו על {count} המושבים שלכם ואף אחד לא יוסר.",
    "Undo change": "ביטול השינוי",
    "Seat change cancelled. You keep {count} seats.": "שינוי המושבים בוטל. נשארתם עם {count} מושבים.",
    "Scheduled changes": "שינויים מתוזמנים",
    "Seats {from} → {to}": "מושבים {from} → {to}",
    "{count} seats scheduled for removal on {date}": "{count} מושבים מתוזמנים להסרה בתאריך {date}",
    "Leaving": "עוזבים",
    "Undo": "ביטול",
    "Your {plan} plan has started": "מסלול {plan} שלכם התחיל",
    "You can now add more users.": "עכשיו אפשר להוסיף עוד משתמשים.",
    "We couldn't start your paid plan. Your trial is unchanged.": "לא הצלחנו להתחיל את המסלול בתשלום. תקופת הניסיון שלכם לא השתנתה.",
    "Not now": "לא עכשיו",
    "Start {plan} plan": "התחלת מסלול {plan}",
    "Plan": "מסלול",
    "Yearly": "שנתי",
    "Trial seat limit reached. Free trials include up to {cap} users.": "הגעתם למגבלת המושבים בתקופת הניסיון. תקופת ניסיון כוללת עד {cap} משתמשים.",
    "Start paid plan now": "התחלת מסלול בתשלום עכשיו",
    "Trial": "ניסיון",
    "Trial ends on {date}": "תקופת הניסיון מסתיימת ב-{date}",
    "Free trial": "תקופת ניסיון",
    "{count} trial seats left after this invite": "יישארו {count} מושבי ניסיון אחרי ההזמנה",
    "This invitation has expired. Ask your administrator to send a new one.": "ההזמנה הזו פגה. בקשו ממנהל המערכת לשלוח הזמנה חדשה.",
    "This invitation was already accepted. Log in with your email and password instead.": "ההזמנה הזו כבר אושרה. היכנסו עם האימייל והסיסמה שלכם במקום.",
    "This invitation was revoked. Ask your administrator to send a new one.": "ההזמנה הזו בוטלה. בקשו ממנהל המערכת לשלוח הזמנה חדשה.",
    "That invitation no longer exists. Ask your administrator to send a new one.": "ההזמנה הזו כבר לא קיימת. בקשו ממנהל המערכת לשלוח הזמנה חדשה.",
    "This billing cycle is being charged right now. Please try again in a few minutes.": "החיוב על מחזור החיוב הזה מתבצע כרגע. נסו שוב בעוד כמה דקות.",
    "Your wallet balance is too low for this change. Top up and try again.": "היתרה בארנק נמוכה מדי לשינוי הזה. טענו את הארנק ונסו שוב.",
    "That is below your plan's minimum number of seats.": "זה מתחת למספר המושבים המינימלי בתוכנית שלך.",
    "One of the picked users can't be removed. Close this window and pick again.": "לא ניתן להסיר את אחד המשתמשים שנבחרו. סגרו את החלון ובחרו שוב.",
    "Users removed now": "משתמשים שיוסרו עכשיו",
    "Your card was declined. Your trial is unchanged.": "הכרטיס שלכם נדחה. תקופת הניסיון לא השתנתה.",
    "Your paid plan has already started.": "המסלול בתשלום שלכם כבר התחיל.",
    "Your paid plan has already started. Check your seats in Manage Seats.": "המסלול בתשלום שלכם כבר התחיל. בדקו את המושבים בניהול מושבים.",
    "We couldn't confirm your payment. Check your plan in a few minutes before you try again.": "לא הצלחנו לאשר את התשלום. בדקו את המסלול בעוד כמה דקות לפני שתנסו שוב.",
    "Plus tax and any one-time fees.": "בתוספת מס וכל עמלה חד-פעמית.",
    "Your organization has reached its free trial user limit. Contact your administrator.": "הארגון שלכם הגיע למגבלת המשתמשים של תקופת הניסיון. פנו למנהל המערכת.",
    "Charged today": "חיוב היום",
    "Every node must be connected to the phone number": "כל קשר חייב להיות מחובר למספר הטלפון",
    "This destination is not allowed here": "יעד זה אינו מותר כאן",
    "An output can only go to one destination": "פלט יכול להוביל ליעד אחד בלבד",
    "Choose a destination": "בחר יעד",
    "A node cannot point to itself": "קשר אינו יכול להפנות לעצמו",
    "Too many outputs on this node": "יותר מדי פלטים בקשר זה",
    "A phone number or extension can only start a flow, not be a step in it": "מספר טלפון או שלוחה יכולים רק להתחיל תזרים, לא להיות שלב בתוכו",
    "This output does not exist on this node": "פלט זה אינו קיים בקשר זה",
    "A connection starts from a node that is not in the flow": "חיבור מתחיל מקשר שאינו נמצא בתזרים",
    "A node could not be identified. Reload and try again.": "לא ניתן היה לזהות קשר. טען מחדש ונסה שוב.",
    "A destination no longer exists. Pick another one.": "יעד כבר אינו קיים. בחר יעד אחר.",
    "This flow was changed elsewhere since you opened it. Reload to get the latest version.": "התזרים שונה במקום אחר מאז שפתחת אותו. טען מחדש כדי לקבל את הגרסה העדכנית.",
    "This number/extension already starts another flow": "מספר/שלוחה זו כבר מתחילה תזרים אחר",
    "These extension digits are already in use": "ספרות שלוחה אלו כבר בשימוש",
    "This item is in use elsewhere, so this change is not allowed": "פריט זה נמצא בשימוש במקום אחר, ולכן שינוי זה אינו מותר",
    "This change conflicts with the current routing. Reload and try again.": "שינוי זה מתנגש בניתוב הנוכחי. טען מחדש ונסה שוב.",
    "You don't have permission to change this flow": "אין לך הרשאה לשנות תזרים זה",
    "This node could not be loaded, so saving could change its routing. Reload and try again.": "לא ניתן היה לטעון קשר זה, ולכן שמירה עלולה לשנות את הניתוב שלו. טען מחדש ונסה שוב.",
    "Choose a phone number or extension to start the flow": "בחר מספר טלפון או שלוחה כדי להתחיל את התזרים",
    "This flow already starts at another number or extension. Put it back to save.": "תזרים זה כבר מתחיל במספר או בשלוחה אחרים. החזר אותו כדי לשמור.",
    "The flow could not be saved. Try again.": "לא ניתן היה לשמור את התזרים. נסה שוב.",
    "The flow is saved, but its new name is not. Try again.": "התזרים נשמר, אך שמו החדש לא נשמר. נסה שוב.",
    "{node} could not be saved: {detail}": "לא ניתן היה לשמור את {node}: {detail}",
    "The flow could not be saved: {detail}": "לא ניתן היה לשמור את התזרים: {detail}",
    "You don't have permission to change {node}": "אין לך הרשאה לשנות את {node}",
    "This could not be loaded. Try again.": "לא ניתן היה לטעון את זה. נסה שוב.",
    "Regenerate password": "צור סיסמה מחדש",
    "Choose Existing Queue": "בחר תור קיים",
    "How long a caller waits before the Timeout destination": "כמה זמן מתקשר ממתין לפני יעד הזמן הקצוב",
    "When this many callers are waiting, the next one goes to the Queue full destination": "כאשר ממתינים כמות זו של מתקשרים, הבא בתור עובר ליעד התור המלא",
    "A caller whose estimated wait is longer goes to the Wait too long destination instead of waiting": "מתקשר שזמן ההמתנה המשוער שלו ארוך יותר עובר ליעד ההמתנה הארוכה מדי במקום להמתין",
    "Keys used by other queue options: {keys}": "מקשים בשימוש על ידי אפשרויות תור אחרות: {keys}",
    "This key is used by another queue option": "מקש זה נמצא בשימוש על ידי אפשרות תור אחרת",
    "A queue key can only hang up without a reason": "מקש בתור יכול לנתק רק ללא סיבה",
    "Could not load the inputs from other flows": "לא ניתן לטעון את הכניסות מזרימות אחרות",
    "DND ON": "נא לא להפריע פעיל",
    "An unset Busy/DND or No Answer goes to the user's voicemail.": "תפוס/נא לא להפריע או אין מענה שלא הוגדרו עוברים לתא הקולי של המשתמש.",
    "An unset Busy/DND or No Answer hangs up.": "תפוס/נא לא להפריע או אין מענה שלא הוגדרו מנתקים את השיחה.",
    "Queue full needs a caller limit, set on the Call queue screen": "תור מלא דורש מגבלת מתקשרים, שמוגדרת במסך תור השיחות",
    "Wait too long needs an estimated-wait limit, set on the Call queue screen": "המתנה ארוכה מדי דורשת מגבלת זמן המתנה משוער, שמוגדרת במסך תור השיחות",
    "The flow is saved, but this user's settings were not: the user has no account in the app": "התרשים נשמר, אך ההגדרות של המשתמש הזה לא נשמרו: למשתמש אין חשבון באפליקציה",
    "The flow is saved, but the user's settings did not reach the phone system. Try again.": "התרשים נשמר, אך הגדרות המשתמש לא הגיעו למערכת הטלפוניה. נסו שוב.",
    "{name} on {date}": "{name} ב-{date}",
    "Last Edited By": "נערך לאחרונה על ידי",
    "Annual invoice": "חשבונית שנתית",
    "Cancel the scheduled plan change?": "לבטל את שינוי המסלול המתוזמן?",
    "Confirm change": "אישור השינוי",
    "Confirm changes": "אישור השינויים",
    "Confirm plan change": "אישור שינוי מסלול",
    "Contact sales": "פנייה למכירות",
    "Current plan": "המסלול הנוכחי",
    "Downgrade": "שנמוך",
    "Downgrade cancelled. You stay on {plan}.": "השנמוך בוטל. נשארתם במסלול {plan}.",
    "Downgrade to {plan}": "מעבר ל-{plan}",
    "Free during your trial · You'll be charged {amount} on {date}": "ללא עלות בתקופת הניסיון · תחויבו ב-{amount} בתאריך {date}",
    "Free trials include up to {cap} users.": "תקופת ניסיון כוללת עד {cap} משתמשים.",
    "No refund": "ללא החזר",
    "Plan changed to {plan} · {seats} seats · {total} / {period}.": "המסלול שונה ל-{plan} · {seats} מושבים · {total} / {period}.",
    "Seats drop to {count} on your next billing date": "מספר המושבים יירד ל-{count} בתאריך החיוב הבא",
    "Switch to monthly": "מעבר לחיוב חודשי",
    "Switch to yearly": "מעבר לחיוב שנתי",
    "Takes effect on {date}": "ייכנס לתוקף ב-{date}",
    "Takes effect today": "נכנס לתוקף היום",
    "These changes take effect on {date}, your next billing date.": "השינויים ייכנסו לתוקף ב-{date}, תאריך החיוב הבא שלכם.",
    "Year": "שנה",
    "You stay on {plan}.": "תישארו במסלול {plan}.",
    "You're now on {plan}. Your trial continues until {date}.": "עברתם למסלול {plan}. תקופת הניסיון ממשיכה עד {date}.",
    "You're using {count} seats. Deactivate users to go lower.": "אתם משתמשים ב-{count} מושבים. השביתו משתמשים כדי לרדת.",
    "Your plan changed, but the seat count could not be lowered. Try Manage Seats.": "המסלול שונה, אבל לא הצלחנו להקטין את מספר המושבים. נסו דרך ניהול מושבים.",
    "Your plan changes to {plan} on {date}.": "המסלול שלכם יעבור ל-{plan} בתאריך {date}.",
    "{amount} charged now (prorated)": "{amount} חיוב עכשיו (יחסי)",
    "{count} seats ({plan} minimum)": "{count} מושבים (המינימום של {plan})",
    "{plan} includes a minimum of {min} seats. You'll be billed for {seats} seats; you're using {used}, so {free} are free to assign.": "מסלול {plan} כולל מינימום של {min} מושבים. תחויבו על {seats} מושבים; אתם משתמשים ב-{used}, כך ש-{free} פנויים להקצאה.",
    "{price} / user / {period}": "{price} / משתמש / {period}",
    "To upgrade, stay on yearly billing. You can switch to monthly at the end of your term.": "כדי לשדרג, הישארו בחיוב שנתי. אפשר לעבור לחיוב חודשי בסוף התקופה.",
    "Your billing period can't change while phone numbers are billed on this plan. Contact support.": "לא ניתן לשנות את תקופת החיוב כל עוד מספרי טלפון מחויבים בתוכנית הזו. פנו לתמיכה.",
    "We couldn't change your plan. Please try again.": "לא הצלחנו לשנות את התוכנית. נסו שוב.",
    "We couldn't price that change. Please try again.": "לא הצלחנו לתמחר את השינוי. נסו שוב.",
    "We couldn't load the plans right now. Please try again shortly.": "לא הצלחנו לטעון את התוכניות כרגע. נסו שוב בעוד רגע.",
    "Total file size exceeds the 4MB limit.": "הגודל הכולל של הקבצים חורג מהמגבלה של 4MB.",
    "ticket created without number": "מעולה! פתחתי עבורך קריאת תמיכה. הצוות שלנו יחזור אליך ברגע שיהיה עדכון. כדאי לעקוב אחרי תיבת הדואר שלך",
    "Locked": "נעול",
    "Resume subscription": "חידוש המנוי",
    "We couldn't resume your subscription. Please try again.": "לא הצלחנו לחדש את המנוי. נסו שוב.",
    "WhatsApp needs an active subscription": "WhatsApp דורש מנוי פעיל",
    "{plan} has no WhatsApp. These numbers are disconnected on the change date: {numbers}": "ב-{plan} אין WhatsApp. המספרים האלה מתנתקים בתאריך השינוי: {numbers}",
    "WhatsApp switched off": "WhatsApp כבוי",
    "Plan change cancelled. You stay on your current plan.": "שינוי התוכנית בוטל. נשארת בתוכנית הנוכחית.",
    "WhatsApp isn't on your next plan": "WhatsApp לא כלול בתוכנית הבאה שלך",
    "Your plan is set to change to one without WhatsApp. Keep your current plan to connect WhatsApp.": "התוכנית שלך עומדת להשתנות לתוכנית בלי WhatsApp. השאר את התוכנית הנוכחית כדי לחבר WhatsApp.",
    "Your scheduled plan has no WhatsApp. Undo the plan change to connect WhatsApp.": "בתוכנית המתוזמנת שלך אין WhatsApp. בטל את שינוי התוכנית כדי לחבר WhatsApp.",
    "Your subscription is set to cancel. Resume it to connect WhatsApp.": "המנוי שלכם מוגדר להתבטל. חדשו אותו כדי לחבר את WhatsApp.",
    "Your subscription will continue.": "המנוי שלכם ימשיך.",
    "Cancellation scheduled. Your plan ends on {date}.": "הביטול מתוזמן. המסלול שלכם מסתיים ב-{date}.",
    "Go back": "חזרה",
    "Keep subscription": "השארת המנוי",
    "Keep your subscription?": "להשאיר את המנוי?",
    "Minimum {count} characters.": "מינימום {count} תווים.",
    "Please tell us more": "ספרו לנו עוד",
    "Select a reason": "בחרו סיבה",
    "Type CANCEL to confirm": "הקלידו CANCEL לאישור",
    "Undo cancellation": "ביטול הביטול",
    "We couldn't cancel your subscription. Please try again.": "לא הצלחנו לבטל את המנוי. נסו שוב.",
    "What's the main reason for cancelling?": "מה הסיבה העיקרית לביטול?",
    "Your cancellation is scheduled for {date}.": "הביטול שלכם מתוזמן ל-{date}.",
    "Your phone numbers are held for 30 days, then released. To keep them, port them to another provider before cancelling.": "מספרי הטלפון שלכם יישמרו 30 יום ואז ישוחררו. כדי לשמור אותם, נידו אותם לספק אחר לפני הביטול.",
    "Your plan stays active until {date}. No refunds are given for the current billing period.": "המסלול שלכם נשאר פעיל עד {date}. אין החזר על תקופת החיוב הנוכחית.",
    "Your team loses access to calls, messages and the app.": "הצוות שלכם יאבד גישה לשיחות, להודעות ולאפליקציה.",
    "Your {plan} plan will continue and renew on {date}. Scheduled changes you had before cancelling are not restored.": "מסלול {plan} שלכם ימשיך ויתחדש ב-{date}. שינויים מתוזמנים שהיו לפני הביטול לא יוחזרו.",
    "Too expensive": "יקר מדי",
    "Missing a feature we need": "חסרה יכולת שאנחנו צריכים",
    "Call quality or reliability issues": "בעיות באיכות או באמינות השיחות",
    "Switching to another provider": "עוברים לספק אחר",
    "Too difficult to set up or use": "קשה מדי להגדיר או להשתמש",
    "We no longer need a phone system": "אנחנו כבר לא צריכים מערכת טלפוניה",
    "No contacts left to call. Every number in the call list was already dialed or skipped": "לא נותרו אנשי קשר לחיוג. כל המספרים ברשימת החיוג כבר חויגו או דולגו",
    "Wrong number": "מספר שגוי",
    "Network error": "שגיאת רשת",
    "On the Do Not Call list": "ברשימת אל תתקשר",
    "Your account closes now. You won't be charged.": "החשבון שלך ייסגר עכשיו. לא תחויב.",
    "Users can't sign in. Calls and messages stop.": "משתמשים לא יוכלו להתחבר. שיחות והודעות יופסקו.",
    "Numbers are held for 30 days, then released.": "המספרים נשמרים למשך 30 יום ואז משוחררים.",
    "Data is deleted after 30 days.": "הנתונים נמחקים אחרי 30 יום.",
    "Your trial has already ended.": "תקופת הניסיון שלך כבר הסתיימה.",
    "We couldn't end your trial. Please try again.": "לא הצלחנו לסיים את תקופת הניסיון. נסה שוב.",
    "This account is closed. Ask the account owner to reactivate it.": "החשבון הזה סגור. בקש מבעל החשבון להפעיל אותו מחדש.",
    "Your account is still closing. Please try again in a minute.": "החשבון שלך עדיין בתהליך סגירה. נסה שוב בעוד דקה.",
    "Your card was declined. Try another card. Your account is still closed.": "הכרטיס שלך נדחה. נסה כרטיס אחר. החשבון שלך עדיין סגור.",
    "There's no card on file. Add a card to reactivate your account.": "אין כרטיס שמור. הוסף כרטיס כדי להפעיל את החשבון מחדש.",
    "We couldn't reactivate your account. Please try again.": "לא הצלחנו להפעיל את החשבון מחדש. נסה שוב.",
    "Account reactivated. Your {plan} plan has started.": "החשבון הופעל מחדש. תוכנית {plan} שלך התחילה.",
    "Cancelled": "בוטל",
    "Reactivate account": "הפעלת החשבון מחדש",
    "Account closed {closed} · Number held until {held}": "החשבון נסגר ב-{closed} · המספר שמור עד {held}",
    "No upcoming invoice": "אין חשבונית קרובה",
    "Reactivating starts your plan today and charges your saved card.": "הפעלה מחדש מתחילה את התוכנית שלך היום ומחייבת את הכרטיס השמור.",
    "This account is closed. The account owner can sign in to reactivate it.": "החשבון הזה סגור. בעל החשבון יכול להתחבר ולהפעיל אותו מחדש.",
    "A ring group cannot route to itself": "קבוצת צלצול לא יכולה לנתב לעצמה",
    "A forward cannot route to itself": "העברה לא יכולה לנתב לעצמה",
    "An announcement cannot route to itself": "הודעה לא יכולה לנתב לעצמה",
    "The flow is saved, but you don't have permission to change this user's settings": "התזרים נשמר, אך אין לך הרשאה לשנות את הגדרות המשתמש הזה",
    "The flow is saved, but the user's settings could not be saved. Try again.": "התזרים נשמר, אך לא ניתן היה לשמור את הגדרות המשתמש. נסה שוב.",
    "Not started": "לא התחיל",
    "These changes take effect today.": "השינויים נכנסים לתוקף היום.",
    "IVRs": "תפריטים קוליים (IVR)",
    "Call flows": "זרימות שיחה",
    "Web widgets": "ווידג'טים לאתר",
    "AI hours": "שעות AI",
    "Choose what to keep": "בחר מה להשאיר",
    "Turned off automatically": "כבוי אוטומטית",
    "Settings that are turned off are kept, and come back on when you upgrade.": "הגדרות שכובות נשמרות, וחוזרות לפעול כשתשדרג.",
    "A wallboard can have at most {max} stats resets.": "לוח תצוגה יכול לכלול עד {max} איפוסי נתונים.",
    "The server rejected these wallboard settings: {fields}": "השרת דחה את הגדרות לוח התצוגה הבאות: {fields}",
    "Texting campaigns": "קמפיינים של הודעות טקסט",
    "{plan} includes {count} texting campaigns. Choose what happens to each one.": "{plan} כולל {count, plural, one {קמפיין אחד של הודעות טקסט} other {# קמפיינים של הודעות טקסט}}. בחרו מה יקרה לכל אחד.",
    "What happens to {name}": "מה יקרה ל-{name}",
    "Keep · included": "להשאיר · כלול",
    "Keep · {price}/mo": "להשאיר · {price} לחודש",
    "Keep · paid": "להשאיר · בתשלום",
    "Deregister": "לבטל רישום",
    "WhatsApp numbers": "מספרי WhatsApp",
    "Data at risk": "נתונים בסיכון",
    "These WhatsApp numbers stop receiving messages on the change date: {numbers}": "מספרי ה-WhatsApp האלה יפסיקו לקבל הודעות בתאריך השינוי: {numbers}",
    "Texting campaigns kept free: {count}": "קמפיינים שנשארו בחינם: {count}",
    "Texting campaigns kept and paid: {count}": "קמפיינים שנשארו בתשלום: {count}",
    "Texting campaigns deregistered: {count}": "קמפיינים שבוטל רישומם: {count}",
    "WhatsApp numbers kept: {count}": "מספרי WhatsApp שנשארו: {count}",
    "WhatsApp numbers disconnected: {count}": "מספרי WhatsApp שנותקו: {count}",
    "Keep · {price}/yr": "להשאיר · {price} לשנה",
    "We couldn't load your texting campaigns and WhatsApp numbers. Close this window and try again.": "לא הצלחנו לטעון את קמפייני הודעות הטקסט ומספרי ה-WhatsApp שלך. סגרו את החלון ונסו שוב.",
    "Your texting campaigns or WhatsApp numbers changed. Close this window and try again.": "קמפייני הודעות הטקסט או מספרי ה-WhatsApp שלך השתנו. סגרו את החלון ונסו שוב.",
    "Disconnect": "לנתק",
    "Call flows {list} use this queue. Edit them before {when}.": "תזרימי השיחות {list} משתמשים בתור הזה. ערכו אותם לפני {when}.",
    "Call queues are not available on the new plan.": "תורי שיחות אינם זמינים בתוכנית החדשה.",
    "Call queues redirected: {count}": "תורי שיחות שהופנו: {count}",
    "Call recording becomes manual": "הקלטת שיחות הופכת לידנית",
    "Convert queues to ring groups": "המרת תורים לקבוצות צלצול",
    "Dialer campaigns are paused": "קמפייני החייגן מושהים",
    "Download recordings": "הורדת הקלטות",
    "I understand these routes will stop working": "אני מבין/ה שהנתיבים האלה יפסיקו לעבוד",
    "Inbound · {route} → {trunk}": "נכנס · {route} ← {trunk}",
    "Live wallboards turn off": "לוחות התצוגה החיים נכבים",
    "New destination for {name}": "יעד חדש עבור {name}",
    "Outbound · {route} → {trunk}": "יוצא · {route} ← {trunk}",
    "Recordings kept for {months} months": "הקלטות נשמרות {months} חודשים",
    "Recordings older than {months} months become read-only on {when} and are deleted 30 days later.": "הקלטות ישנות מ-{months} חודשים הופכות לקריאה בלבד ב-{when} ונמחקות 30 יום לאחר מכן.",
    "Redirect calls": "הפניית שיחות",
    "Ring group": "קבוצת צלצול",
    "Ring group with the same agents": "קבוצת צלצול עם אותם נציגים",
    "SIP trunks stop working on {when}.": "טראנקי SIP יפסיקו לעבוד ב-{when}.",
    "SIP trunks switched off": "טראנקי SIP כובו",
    "SMS to email turns off": "SMS לאימייל נכבה",
    "Sticky agent, skill-based routing and call barging turn off": "נציג קבוע, ניתוב לפי כישורים והתפרצות לשיחה נכבים",
    "Used by {list}": "בשימוש על ידי {list}",
    "Web widget is removed": "וידג'ט האתר מוסר",
    "Web widget: chat is removed, calls only": "וידג'ט האתר: הצ'אט מוסר, שיחות בלבד",
    "WhatsApp inbox turns off": "תיבת WhatsApp נכבית",
    "Whisper turns off": "לחישה נכבית",
    "today": "היום",
    "Auto Top-up saved. Your card was charged {amount}.": "תשלום אוטומטי נשמר. הכרטיס שלך חויב ב-{amount}.",
    "Your balance is below {threshold}, so your card will be charged {amount} now. Then it tops up whenever the balance falls below {threshold}.": "היתרה שלך מתחת ל-{threshold}, ולכן הכרטיס שלך יחויב ב-{amount} כעת. לאחר מכן תתבצע טעינה בכל פעם שהיתרה יורדת מתחת ל-{threshold}.",
    "Save and top up": "שמור וטען",
    "The card was not charged, so auto top-up was not saved. Check your card and try again.": "הכרטיס לא חויב, ולכן התשלום האוטומטי לא נשמר. בדקו את הכרטיס ונסו שוב.",
    "We couldn't confirm whether your card was charged. Check your balance before trying again.": "לא הצלחנו לוודא אם הכרטיס חויב. בדקו את היתרה לפני שתנסו שוב.",
    "Complete the card verification, then save auto top-up again.": "השלימו את אימות הכרטיס, ואז שמרו שוב את התשלום האוטומטי.",
    "Payment received. Once your balance updates, save auto top-up again.": "התשלום התקבל. לאחר שהיתרה תתעדכן, שמרו שוב את התשלום האוטומטי.",
    "Your card was charged {amount}, but auto top-up was not saved. Save it again.": "הכרטיס שלכם חויב ב-{amount}, אך התשלום האוטומטי לא נשמר. שמרו אותו שוב.",
    "Your balance could not be loaded. Try again in a moment.": "לא ניתן היה לטעון את היתרה. נסו שוב בעוד רגע.",
    "Choose destination": "בחירת יעד",
    "Only someone who can manage call queues can make this change.": "רק מי שיכול לנהל תורי שיחות יכול לבצע את השינוי הזה.",
    "We couldn't load your call queues and SIP trunks.": "לא הצלחנו לטעון את תורי השיחות וטראנקי ה-SIP שלך.",
    "We couldn't check which call flows use this queue.": "לא הצלחנו לבדוק אילו תזרימי שיחות משתמשים בתור הזה.",
    "Your call queues or SIP trunks changed. Close this window and try again.": "תורי השיחות או טראנקי ה-SIP שלך השתנו. סגרו את החלון ונסו שוב.",
    "Back to your account": "חזרה לחשבון שלך",
    "Your account's data was deleted 30 days after it closed. Sign up again to start over.": "נתוני החשבון שלך נמחקו 30 יום לאחר הסגירה. הירשמו מחדש כדי להתחיל מההתחלה.",
    "Your data was deleted": "הנתונים שלך נמחקו",
    "Your data": "הנתונים שלך",
    "You can view and download your call logs, recordings and reports until {date}. After that they are deleted for good.": "אפשר לצפות ולהוריד את יומני השיחות, ההקלטות והדוחות עד {date}. לאחר מכן הם נמחקים לצמיתות.",
    "Logging out in {seconds}s": "מנתק בעוד {seconds} שניות",
    "Your account signs in with Google or Microsoft. Set a password to also log in with your email.": "החשבון שלך מתחבר באמצעות Google או Microsoft. הגדר סיסמה כדי להתחבר גם עם האימייל שלך.",
    "Set a password": "הגדרת סיסמה",
    "Check your email": "בדוק את האימייל שלך",
    "We've emailed you a link to set your password.": "שלחנו לך באימייל קישור להגדרת הסיסמה.",
    "Link sent": "הקישור נשלח",
    "Download your invoices before then too. After that, email support@pbx.im for a copy.": "הורידו גם את החשבוניות לפני כן. לאחר מכן, כתבו ל-support@pbx.im לקבלת עותק.",
    "Need an invoice? Email support@pbx.im for a copy.": "צריכים חשבונית? כתבו ל-support@pbx.im לקבלת עותק.",
    "Could not change the password": "לא ניתן היה לשנות את הסיסמה",
    "Change your own password from your Profile page": "שנה את הסיסמה שלך מדף הפרופיל",
    "This user is deactivated": "משתמש זה מושבת",
    "Set user password intro": "בחר סיסמה חדשה עבור {name} ושתף אותה איתו באופן מאובטח. הסיסמה הנוכחית תפסיק לעבוד.",
    "This Google or Microsoft account is already connected to a PBX account. Sign in instead.": "חשבון Google או Microsoft זה כבר מחובר לחשבון PBX. התחבר במקום זאת.",
    "Your account was created. Please sign in.": "החשבון שלך נוצר. נא להתחבר.",
    "This node is deactivated. Calls routed to it won't go through.": "הצומת הזה מושבת. שיחות שינותבו אליו לא יעברו.",
    "SMS isn't active on this number yet": "ה-SMS עדיין לא פעיל במספר הזה",
    "You don't have permission to change the linked inbox": "אין לך הרשאה לשנות את תיבת הדואר המקושרת",
    "You're not allowed to send from this number": "אינך מורשה לשלוח מהמספר הזה",
    "You're not a member of this inbox": "אינך חבר בתיבת הדואר הזו",
    "This number is no longer available for messaging": "המספר הזה כבר לא זמין להודעות",
    "This number is routed to another inbox": "המספר הזה מנותב לתיבת דואר אחרת",
    "Could not load SMS settings": "טעינת הגדרות SMS נכשלה",
    "This message is too long to send": "ההודעה ארוכה מדי לשליחה",
    "Attempted": "בניסיון",
    "Could not load your numbers": "לא ניתן לטעון את המספרים שלך",
    "Busy/DND": "תפוס/נא לא להפריע",
    "A number changed while syncing. Run Sync Numbers again.": "מספר השתנה במהלך הסנכרון. הפעל שוב את סנכרון המספרים.",
    "Could not import the message templates. Run Sync Templates to try again.": "לא ניתן היה לייבא את תבניות ההודעות. הפעל את סנכרון התבניות כדי לנסות שוב.",
    "Could not read the WhatsApp Business Account details from Meta: {reason}": "לא ניתן היה לקרוא את פרטי חשבון WhatsApp Business מ-Meta: {reason}",
    "Could not read the phone numbers from Meta. Run Sync Numbers to try again.": "לא ניתן היה לקרוא את מספרי הטלפון מ-Meta. הפעל את סנכרון המספרים כדי לנסות שוב.",
    "Could not refresh the number status from Meta. Run Sync Numbers to update it.": "לא ניתן היה לרענן את סטטוס המספר מ-Meta. הפעל את סנכרון המספרים כדי לעדכן אותו.",
    "Could not subscribe to Meta webhooks, so template status updates will not arrive. Disconnect and connect again to retry.": "לא ניתן היה להירשם ל-webhooks של Meta, ולכן עדכוני סטטוס של תבניות לא יגיעו. נתק והתחבר שוב כדי לנסות שוב.",
    "Could not unsubscribe from Meta webhooks: {reason}": "לא ניתן היה לבטל את ההרשמה ל-webhooks של Meta: {reason}",
    "Failed to complete WhatsApp connection.": "השלמת החיבור ל-WhatsApp נכשלה.",
    "Failed to disconnect the WhatsApp Business Account. Please try again.": "ניתוק חשבון WhatsApp Business נכשל. נסה שוב.",
    "Failed to start the WhatsApp connection. Please try again.": "התחלת החיבור ל-WhatsApp נכשלה. נסה שוב.",
    "Failed to sync WhatsApp numbers. Please try again.": "סנכרון מספרי WhatsApp נכשל. נסה שוב.",
    "Failed to sync WhatsApp templates. Please try again.": "סנכרון תבניות WhatsApp נכשל. נסה שוב.",
    "Failed to update the assignment. Please try again.": "עדכון השיוך נכשל. נסה שוב.",
    "Meta could not complete the sign-in. Please try again.": "Meta לא הצליחה להשלים את הכניסה. נסה שוב.",
    "Meta could not complete the sign-in: {reason}": "Meta לא הצליחה להשלים את הכניסה: {reason}",
    "Meta is limiting requests right now. Try again in a few minutes.": "Meta מגבילה כרגע את הבקשות. נסה שוב בעוד כמה דקות.",
    "Meta is not responding right now. Try again later.": "Meta לא מגיבה כרגע. נסה שוב מאוחר יותר.",
    "Meta rejected the request.": "Meta דחתה את הבקשה.",
    "Meta rejected the request: {reason}": "Meta דחתה את הבקשה: {reason}",
    "No WhatsApp Business Account is connected. Connect one first.": "אין חשבון WhatsApp Business מחובר. חבר חשבון קודם.",
    "No WhatsApp Business Account was shared. In the Meta window, select a WhatsApp Business Account and try again.": "לא שותף אף חשבון WhatsApp Business. בחלון של Meta, בחר חשבון WhatsApp Business ונסה שוב.",
    "Not all numbers could be read from Meta, so some may be out of date. Run Sync Numbers again.": "לא ניתן היה לקרוא את כל המספרים מ-Meta, ולכן חלקם עשויים להיות לא מעודכנים. הפעל שוב את סנכרון המספרים.",
    "Not all templates could be read from Meta. Run Sync Templates to finish importing them.": "לא ניתן היה לקרוא את כל התבניות מ-Meta. הפעל את סנכרון התבניות כדי לסיים לייבא אותן.",
    "Number {number} cannot send messages yet because its ownership is not verified. Verify it in WhatsApp Manager, then run Sync Numbers.": "המספר {number} עדיין לא יכול לשלוח הודעות כי הבעלות עליו לא אומתה. אמת אותו ב-WhatsApp Manager ואז הפעל את סנכרון המספרים.",
    "Number {number} cannot send messages yet because its ownership verification has expired. Verify it again in WhatsApp Manager, then run Sync Numbers.": "המספר {number} עדיין לא יכול לשלוח הודעות כי תוקף אימות הבעלות עליו פג. אמת אותו שוב ב-WhatsApp Manager ואז הפעל את סנכרון המספרים.",
    "Number {number} could not be registered for sending because Meta blocked it after too many attempts. Try again in 72 hours.": "לא ניתן היה לרשום את המספר {number} לשליחה כי Meta חסמה אותו לאחר יותר מדי ניסיונות. נסה שוב בעוד 72 שעות.",
    "Number {number} could not be registered for sending because its two-step verification PIN does not match. Contact support.": "לא ניתן היה לרשום את המספר {number} לשליחה כי קוד ה-PIN של האימות הדו-שלבי שלו לא תואם. פנה לתמיכה.",
    "Number {number} isn't ready to send messages yet. Check it in WhatsApp Manager, wait a few minutes, then run Sync Numbers.": "המספר {number} עדיין לא מוכן לשליחת הודעות. בדוק אותו ב-WhatsApp Manager, המתן כמה דקות ואז הפעל את סנכרון המספרים.",
    "Number {number} could not be synced: {reason}": "לא ניתן היה לסנכרן את המספר {number}: {reason}",
    "Number {number} is already connected to another PBX.IM account. Disconnect it there first, then run Sync Numbers.": "המספר {number} כבר מחובר לחשבון PBX.IM אחר. נתק אותו שם קודם ואז הפעל את סנכרון המספרים.",
    "Numbers were not registered for sending because the registration PIN is not configured. Contact support.": "המספרים לא נרשמו לשליחה כי קוד ה-PIN לרישום לא הוגדר. פנה לתמיכה.",
    "One of the selected users no longer exists.": "אחד המשתמשים שנבחרו כבר לא קיים.",
    "The WhatsApp sign-in expired or was already used. Please try again.": "הכניסה ל-WhatsApp פגה או שכבר נעשה בה שימוש. נסה שוב.",
    "The connection to WhatsApp has expired. Disconnect and connect again.": "החיבור ל-WhatsApp פג. נתק והתחבר שוב.",
    "The sign-in window was blocked. Allow pop-ups for this site and try again.": "חלון הכניסה נחסם. אפשר חלונות קופצים לאתר זה ונסה שוב.",
    "This WhatsApp Business Account is already being connected. Wait a moment, then refresh the page.": "חשבון WhatsApp Business זה כבר נמצא בתהליך חיבור. המתן רגע ואז רענן את הדף.",
    "This WhatsApp Business Account is already connected to another PBX.IM account. Disconnect it there first, then try again.": "חשבון WhatsApp Business זה כבר מחובר לחשבון PBX.IM אחר. נתק אותו שם קודם ונסה שוב.",
    "This WhatsApp sign-in was started from a different account. Please try again from this account.": "הכניסה ל-WhatsApp הזו התחילה מחשבון אחר. נסה שוב מחשבון זה.",
    "This account already has a different WhatsApp Business Account connected. Disconnect it first, then try again.": "לחשבון זה כבר מחובר חשבון WhatsApp Business אחר. נתק אותו קודם ונסה שוב.",
    "WhatsApp Business Account {ids} is already connected to another PBX.IM account, so it was not connected here.": "חשבון WhatsApp Business {ids} כבר מחובר לחשבון PBX.IM אחר, ולכן הוא לא חובר כאן.",
    "WhatsApp is not configured on this environment.": "WhatsApp לא מוגדר בסביבה זו.",
    "{count} number(s) are no longer on this WhatsApp Business Account and were removed.": "{count} מספר(ים) כבר לא נמצאים בחשבון WhatsApp Business זה והוסרו.",
    "Sync Numbers": "סנכרן מספרים",
    "WhatsApp Business account disconnected successfully": "חשבון WhatsApp Business נותק בהצלחה",
    "Voicemail delete timeout exit hint": "שיחות אל {names} מועברות לכאן. כדי לשנות זאת, עברו אל הגדרות > משתמשים > ערוך משתמש > ניהול שיחות.",
    "Voicemail delete kept missed-call hint": "{names} עדיין משתמשים בו כתא הקולי הישן לשיחות שלא נענו, ואין עדיין מסך שמסיר זאת. פנו לתמיכה כדי להסיר אותו.",
    "Archiving this inbox unroutes": "העברת תיבה זו לארכיון מבטלת את הניתוב של {items}. הם לא יימסרו לאף אחד עד שתנתבו אותם מחדש, ושחזור מהארכיון לא ישחזר אותם.",
    "Name deactivated": "{name} (מושבת)",
    "Where this voicemail delivers could not be loaded.": "לא ניתן היה לטעון לאן תא קולי זה נמסר.",
    "Where these voicemails deliver could not be loaded, so Type and Destination read Unknown.": "לא ניתן היה לטעון לאן תאים קוליים אלה נמסרים, ולכן סוג ויעד מוצגים כלא ידוע.",
    "Missed-call voicemail": "תא קולי לשיחות שלא נענו",
    "The selected voicemail no longer exists": "התא הקולי שנבחר כבר לא קיים",
    "This user has no phone account": "למשתמש זה אין חשבון טלפון",
    "Too many changes at once. Try again in a minute": "יותר מדי שינויים בבת אחת. נסה שוב בעוד דקה",
    "Name archived": "{name} (בארכיון)",
    "Unrecognised route": "ניתוב לא מזוהה",
    "This account has too many inboxes to show where voicemails deliver, so Type and Destination read Unknown.": "בחשבון זה יש יותר מדי תיבות דואר נכנס כדי להציג לאן תאים קוליים נמסרים, ולכן סוג ויעד מוצגים כלא ידוע.",
    "Destinations were not searched, only names and emails.": "החיפוש לא כלל יעדים, רק שמות וכתובות דוא\"ל.",
    "Filtering by Type is unavailable right now, so all voicemails are shown.": "סינון לפי סוג אינו זמין כרגע, ולכן מוצגים כל התאים הקוליים.",
    "People's names are not searched without permission to view users.": "שמות של אנשים אינם נכללים בחיפוש ללא הרשאה לצפות במשתמשים.",
    "You are about to leave this group.": "אתה עומד לעזוב את הקבוצה הזו.",
    "The flow is saved, but the voicemail's owner was not changed. Try again.": "התזרים נשמר, אך הבעלים של התא הקולי לא שונה. נסה שוב.",
    "Account balance too low — contact your administrator": "יתרת החשבון נמוכה מדי — פנה למנהל המערכת",
    "This person opted out of your messages.": "איש הקשר ביטל את הסכמתו לקבל ממך הודעות.",
    "This number can't receive texts. Check the number.": "המספר הזה לא יכול לקבל הודעות SMS. בדוק את המספר.",
    "Texts from this number can't carry attachments.": "הודעות SMS מהמספר הזה לא יכולות לכלול קבצים מצורפים.",
    "This message could not be sent.": "לא ניתן היה לשלוח את ההודעה.",
    "Change Plan": "שינוי תוכנית",
    "{count} seats have been added to your account.": "{count, plural, one {מושב אחד נוסף לחשבון שלך.} other {# מושבים נוספו לחשבון שלך.}}",
    "{count} seats will be removed on {date}.": "{count, plural, one {מושב אחד יוסר ב-{date}.} other {# מושבים יוסרו ב-{date}.}}",
    "{count} seats have been removed from your account.": "{count, plural, one {מושב אחד הוסר מהחשבון שלך.} other {# מושבים הוסרו מהחשבון שלך.}}",
    "Seats Changed Successfully": "המושבים עודכנו בהצלחה",
    "Remove Users To Decrease Seats": "הסרת משתמשים כדי להפחית מושבים",
    "More than {cap} seats starts your paid plan.": "יותר מ-{cap} מושבים מפעיל את התוכנית בתשלום.",
    "To decrease the seats <b>{count}</b> users need to be removed.": "{count, plural, one {כדי להפחית מושבים יש להסיר משתמש <b>אחד</b>.} other {כדי להפחית מושבים יש להסיר <b>#</b> משתמשים.}}",
    "Yearly invoice after trial": "חשבונית שנתית לאחר תקופת הניסיון",
    "Monthly invoice after trial": "חשבונית חודשית לאחר תקופת הניסיון",
    "Trial Seats": "מושבי ניסיון",
    "Change Seats": "שינוי מושבים",
    "Trial includes {cap} seats.": "תקופת הניסיון כוללת {cap} מושבים.",
    "Seats used": "מושבים בשימוש",
    "{used} of {total}": "{used} מתוך {total}",
    "Price / Seat after trial": "מחיר / מושב לאחר תקופת הניסיון",
    "scheduled for deactivation": "מתוזמן להשבתה",
    "Max Number Of Users": "מספר משתמשים מרבי",
    "ACD, Auto Attendant, Skill-Based Routing": "ACD, מרכזייה אוטומטית, ניתוב לפי מיומנות",
    "MP3 Call Recordings Storage": "אחסון הקלטות שיחה MP3",
    "Support Channels": "ערוצי תמיכה",
    "Support Availability": "זמינות תמיכה",
    "Available Seats": "מושבים זמינים",
    "Trial limit: {cap}": "מגבלת ניסיון: {cap}",
    "Plan Max Users": "מקסימום משתמשים בתוכנית",
    "Trial • {days, plural, one {# day} other {# days}} left": "ניסיון • {days, plural, one {נותר יום #} other {נותרו # ימים}}",
    "The new plan has been added to your account.": "התוכנית החדשה נוספה לחשבון שלך.",
    "Transaction didn’t go through": "העסקה לא עברה",
    "Please update your payment method or add funds to complete your purchase.": "עדכן את אמצעי התשלום או הוסף כספים כדי להשלים את הרכישה.",
    "Start Plan": "התחלת תוכנית",
    "Need More Than {cap} Users?": "צריך יותר מ-{cap} משתמשים?",
    "Trial includes {cap} seats. Start your {plan} plan to add more users, buy numbers and send business SMS.": "תקופת הניסיון כוללת {cap} מושבים. התחל את תוכנית {plan} כדי להוסיף משתמשים, לקנות מספרים ולשלוח SMS עסקי.",
    "Your trial ends today.": "תקופת הניסיון שלך מסתיימת היום.",
    "Plan Max Seats": "מקסימום מושבים בתוכנית",
    "Plus tax, numbers, add-ons and any one-time fees.": "בתוספת מס, מספרים, תוספות וכל עמלה חד-פעמית.",
    "Your price list: {name}": "המחירון שלך: {name}",
    "Contact support to change your prices.": "כדי לשנות את המחירים, פנו לתמיכה.",
    "Your price list is being updated": "המחירון שלך מתעדכן",
    "Check back in a few minutes.": "בדקו שוב בעוד כמה דקות.",
    "Your price list is being updated. Your prices will show here when it is ready.": "המחירון שלך מתעדכן. המחירים שלך יוצגו כאן כשהוא יהיה מוכן.",
    "This account has its own price list. Contact support to change it.": "לחשבון זה יש מחירון משלו. כדי לשנות אותו, פנו לתמיכה.",
    "Your own price list": "המחירון שלך",
    "Available on paid plans.": "זמין בתוכניות בתשלום.",
    "Upgrade To Continue": "שדרגו כדי להמשיך",
    "This feature is included in {plan}, a paid plan.": "התכונה הזו כלולה ב-{plan}, תוכנית בתשלום.",
    "Before You Downgrade": "לפני שמורידים חבילה",
    "Remove these features": "הסר את התכונות האלה",
    "Not available in new plan": "לא זמין בחבילה החדשה",
    "Upon switching you will lose access to these features.": "לאחר המעבר תאבד גישה לתכונות האלה.",
    "Some features will have to be removed before you can downgrade the plan.": "יש להסיר חלק מהתכונות לפני שתוכל להוריד את החבילה.",
    "Plan change scheduled": "שינוי החבילה תוזמן",
    "Prorated Charges": "חיובים יחסיים",
    "/ user / {period}": "/ משתמש / {period}",
    "{plan} Plan": "חבילת {plan}",
    "Nevermind": "לא משנה",
    "On {date}": "ב-{date}",
    "Tell us what we can improve": "ספרו לנו מה אפשר לשפר",
    "Optional answer": "תשובה אופציונלית",
    "Cancel your free plan?": "לבטל את התוכנית החינמית?",
    "End Trial": "סיום תקופת הניסיון",
    "What happens next": "מה קורה עכשיו",
    "Extend Trial": "הארכת תקופת הניסיון",
    "Need more time to decide?": "צריכים עוד זמן להחליט?",
    "We'll add {days} free days to your trial so you can finish evaluating.": "נוסיף {days} ימים חינם לתקופת הניסיון כדי שתוכלו לסיים את הבדיקה.",
    "Your trial now ends on {date}.": "תקופת הניסיון שלך מסתיימת עכשיו ב-{date}.",
    "Your trial was already extended.": "תקופת הניסיון שלך כבר הוארכה.",
    "We couldn't extend your trial. Please try again.": "לא הצלחנו להאריך את תקופת הניסיון. נסו שוב.",
    "Verification attempts": "ניסיונות אימות",
    "Attempt {current} of {max}": "ניסיון {current} מתוך {max}",
    "We couldn't place the holds on your card. Please try again.": "לא הצלחנו לבצע את החסימות הזמניות בכרטיס שלך. נסו שוב.",
    "Your bank didn't confirm the hold. Try again to finish the check.": "הבנק לא אישר את החסימה הזמנית. נסו שוב כדי להשלים את הבדיקה.",
    "These holds have expired. Place new ones to verify your card.": "תוקף החסימות הזמניות פג. בצעו חסימות חדשות כדי לאמת את הכרטיס.",
    "Your card is verified.": "הכרטיס שלך אומת.",
    "Place new holds": "ביצוע חסימות חדשות",
    "Verify Your Card": "אימות הכרטיס שלך",
    "Placing two small holds on your card…": "מבצעים שתי חסימות זמניות קטנות בכרטיס שלך…",
    "We've placed two temporary holds under $1.00 each on your card. Check your bank app or statement, then enter both exact amounts to verify your card.": "ביצענו בכרטיס שלך שתי חסימות זמניות, כל אחת מתחת ל-$1.00. בדקו באפליקציית הבנק או בדף החשבון, והזינו את שני הסכומים המדויקים כדי לאמת את הכרטיס.",
    "They show as {descriptor} on your statement.": "הן מופיעות בדף החשבון בשם {descriptor}.",
    "First Transaction Amount": "סכום העסקה הראשונה",
    "Second Transaction Amount": "סכום העסקה השנייה",
    "Card verification failed": "אימות הכרטיס נכשל",
    "I couldn't verify my card ending in {last4}. Please help me verify it.": "לא הצלחתי לאמת את הכרטיס שמסתיים ב-{last4}. אשמח לעזרה באימות.",
    "I couldn't verify my card. Please help me verify it.": "לא הצלחתי לאמת את הכרטיס שלי. אשמח לעזרה באימות.",
    "You've reached the limit of card verifications for now. Please contact support to verify your card.": "הגעת למגבלת אימותי הכרטיס כרגע. פנו לתמיכה כדי לאמת את הכרטיס.",
    "Your card ending in {last4} was removed and its authorization holds were released. Please add a card to continue.": "הכרטיס שמסתיים ב-{last4} הוסר והחסימות הזמניות שוחררו. הוסיפו כרטיס כדי להמשיך.",
    "Your card was removed and its authorization holds were released. Please add a card to continue.": "הכרטיס שלך הוסר והחסימות הזמניות שוחררו. הוסיפו כרטיס כדי להמשיך.",
    "Add Card": "הוספת כרטיס",
    "We Couldn't Verify This Card": "לא הצלחנו לאמת את הכרטיס הזה",
    "Verify Card": "אימות כרטיס",
    "Verify your card first": "קודם יש לאמת את הכרטיס",
    "Your card can't be charged until it's verified. Enter the two small hold amounts from your bank app to finish.": "לא ניתן לחייב את הכרטיס עד שהוא מאומת. הזינו את שני סכומי החסימה הקטנים מאפליקציית הבנק כדי לסיים.",
    "Verify your card. Confirm the two small holds on your card to activate billing.": "אמתו את הכרטיס. אשרו את שתי החסימות הזמניות הקטנות בכרטיס כדי להפעיל את החיוב.",
    "You can finish buying your numbers now.": "אפשר לסיים עכשיו את רכישת המספרים.",
    "Contact Support": "פנייה לתמיכה",
    "We couldn't verify your card ending in {last4}. Add another card, or contact support for help.": "לא הצלחנו לאמת את הכרטיס שמסתיים ב-{last4}. הוסיפו כרטיס אחר, או פנו לתמיכה לעזרה.",
    "We couldn't verify your card. Add another card, or contact support for help.": "לא הצלחנו לאמת את הכרטיס שלך. הוסיפו כרטיס אחר, או פנו לתמיכה לעזרה.",
    "Forwarded": "הועברה",
    "This user is deactivated or removed. Choose another user.": "המשתמש הזה הושבת או הוסר. בחרו משתמש אחר.",
    "This device is disabled, removed, or has no active user. Choose another device.": "המכשיר הזה הושבת, הוסר או שאין לו משתמש פעיל. בחרו מכשיר אחר.",
    "This extension is removed, or no longer rings an active user. Choose another extension.": "השלוחה הזו הוסרה, או שכבר אינה מצלצלת למשתמש פעיל. בחרו שלוחה אחרת.",
    "Click 2 Call integration created": "אינטגרציית קליק 2 קול (לחץ לשיחה) נוצרה",
    "Click 2 Call integration updated": "אינטגרציית קליק 2 קול (לחץ לשיחה) עודכנה",
    "Forwarded to": "הועברה אל",
    "No numbers available for this country or these filters right now.": "אין כרגע מספרים זמינים למדינה או למסננים האלה.",
    "Phone numbers can't be purchased during a trial. Upgrade your plan to buy numbers.": "לא ניתן לרכוש מספרי טלפון בתקופת הניסיון. שדרגו את התוכנית כדי לקנות מספרים.",
    "Reconnect": "חיבור מחדש",
    "Disconnect WhatsApp number": "ניתוק מספר WhatsApp",
    "{number} stops sending and receiving messages. Any monthly charge for it stops at the end of the billing period. Your other numbers stay connected.": "{number} יפסיק לשלוח ולקבל הודעות. כל חיוב חודשי עבורו ייפסק בסוף תקופת החיוב. שאר המספרים שלך יישארו מחוברים.",
    "Failed to disconnect the WhatsApp number. Please try again.": "ניתוק מספר ה-WhatsApp נכשל. נסו שוב.",
    "Failed to reconnect the WhatsApp number. Please try again.": "החיבור מחדש של מספר ה-WhatsApp נכשל. נסו שוב.",
    "WhatsApp is available on the Core and Advanced plans.": "WhatsApp זמין בתוכניות Core ו-Advanced.",
    "Reconnect WhatsApp number": "חיבור מחדש של מספר WhatsApp",
    "{number} starts sending and receiving messages again. If your plan charges per WhatsApp number, a new charge for the rest of this billing period starts today.": "{number} יחזור לשלוח ולקבל הודעות. אם התוכנית שלך מחייבת לפי מספר WhatsApp, חיוב חדש על יתרת תקופת החיוב הנוכחית יתחיל היום.",
    "Rang": "צלצל",
    "Callee hung up": "הנמען ניתק",
    "Ended by the system": "הסתיימה על ידי המערכת",
    "Holiday": "חג",
    "Transfer hold": "המתנה להעברה",
    "Pressed {digit}": "הקיש {digit}",
    "Rang: {names}": "צלצל: {names}",
    "Rang: {names} +{more} more": "צלצל: {names} ועוד {more}",
    "Could not load the call details": "לא ניתן לטעון את פרטי השיחה",
    "No details were recorded for this call": "לא נרשמו פרטים לשיחה זו",
    "Trunk": "טראנק",
    "Feature code": "קוד תכונה",
    "Queue full": "התור מלא",
    "Wait time too long": "זמן ההמתנה ארוך מדי",
    "No agents available": "אין נציגים זמינים",
    "Call Flow": "זרימת שיחה",
    "This person already accepted the invitation. Open them again from the refreshed list to edit.": "האדם הזה כבר קיבל את ההזמנה. פתחו אותו שוב מהרשימה המעודכנת כדי לערוך.",
    "This invitation was revoked": "ההזמנה הזו בוטלה",
    "That invitation no longer exists": "ההזמנה הזו כבר לא קיימת",
    "Due now (each)": "לתשלום עכשיו (ליחידה)",
    "You haven't accepted your invitation yet. Open the invitation email to set up your account.": "עדיין לא אישרת את ההזמנה. פתחו את מייל ההזמנה כדי להגדיר את החשבון.",
    "A new invitation was sent to {name}. There is no need to resend it.": "הזמנה חדשה נשלחה אל {name}. אין צורך לשלוח אותה שוב.",
    "{name} has been notified by email.": "{name} קיבל/ה הודעה בדואר אלקטרוני.",
    "You are about to invite {name} as a team member": "אתה עומד להזמין את {name} כחבר צוות",
    "This person still receives calls from a phone number, extension, IVR, queue, flow or another user. Change those first, then delete the invitation.": "אדם זה עדיין מקבל שיחות ממספר טלפון, שלוחה, IVR, תור, תרשים או משתמש אחר. שנו אותם קודם, ואז מחקו את ההזמנה.",
    "Deleting the invitation did not finish. Please try again.": "מחיקת ההזמנה לא הושלמה. נסו שוב.",
    "We couldn't load this flow. Check your connection and try again.": "לא הצלחנו לטעון את התזרים. בדקו את החיבור ונסו שוב.",
    "The embed code is not available in this environment.": "קוד ההטמעה אינו זמין בסביבה זו.",
    "This widget moved from the previous platform. Its old embed code still works for now: replace it with the code below on every site that uses it.": "הווידג'ט הזה הועבר מהפלטפורמה הקודמת. קוד ההטמעה הישן שלו עדיין עובד בינתיים: החליפו אותו בקוד שלמטה בכל אתר שמשתמש בו.",
    "This widget was changed elsewhere. Reload the page and try again.": "הווידג'ט שונה במקום אחר. טענו מחדש את הדף ונסו שוב.",
    "Your plan allows no more web widgets.": "התוכנית שלך אינה מאפשרת ווידג'טים נוספים לאתר.",
    "This widget no longer exists.": "הווידג'ט הזה כבר לא קיים.",
    "Back to integrations": "חזרה לאינטגרציות",
    "Delete this widget? Every site that embeds it stops showing it.": "למחוק את הווידג'ט? כל אתר שמטמיע אותו יפסיק להציג אותו.",
    "Switched off, the widget shows on no website.": "כשהווידג'ט כבוי, הוא לא מוצג באף אתר.",
    "Remove “{label}” from the question library? Routes that already ask it keep their copy.": "להסיר את “{label}” ממאגר השאלות? מסלולים שכבר שואלים אותה שומרים על העותק שלהם.",
    "Visitors are not offered chat until you pick who answers it": "המבקרים לא יקבלו שיח עד שתבחרו מי עונה לו",
    "The widget was saved, but some chats are not routed yet.": "הווידג'ט נשמר, אבל חלק מהשיחות בצ'אט עדיין לא מנותבות.",
    "This person can no longer answer chats": "האדם הזה כבר לא יכול לענות לשיח",
    "This inbox is no longer available": "התיבה הזו כבר לא זמינה",
    "Chat could not be routed here. Save again to retry.": "לא ניתן היה לנתב את השיח לכאן. שמרו שוב כדי לנסות שוב.",
    "Where chats go could not be loaded. Reload the page to change it.": "לא ניתן היה לטעון לאן מגיע השיח. טענו את הדף מחדש כדי לשנות זאת.",
    "This widget could not be loaded.": "לא ניתן היה לטעון את הווידג'ט.",
    "Website chat": "צ'אט מהאתר",
    "Website visitor": "מבקר באתר",
    "This chat has ended.": "הצ'אט הזה הסתיים.",
    "chat system visitor left": "המבקר עזב את הצ'אט.",
    "chat system visitor ended": "המבקר סיים את הצ'אט.",
    "chat system timed out": "פג הזמן של הצ'אט.",
    "chat system route removed": "הצ'אט הסתיים כי המסלול שלו הוסר.",
    "chat system route changed": "הצ'אט הסתיים כי הניתוב שלו שונה.",
    "Visitors can send files": "מבקרים יכולים לשלוח קבצים",
    "Files: images, PDF, Office documents, text, audio and MP4 video.": "קבצים: תמונות, PDF, מסמכי Office, טקסט, שמע ווידאו MP4.",
    "Show agent names to visitors": "הצג למבקרים את שמות הסוכנים",
    "When off, visitors see \"Agent\" instead of names.": "כשהאפשרות כבויה, המבקרים רואים \"Agent\" במקום שמות.",
    "Send offline messages to": "שלח הודעות אופליין אל",
    "When this route is closed, visitors can leave a message that is emailed here.": "כשהמסלול הזה סגור, המבקרים יכולים להשאיר הודעה שתישלח בדוא\"ל לכתובות האלה.",
    "Name shown in website chats": "השם שמוצג בצ'אטים באתר",
    "Website visitors see this name when you chat with them. Leave empty to use your first name.": "מבקרים באתר רואים את השם הזה כשאתה מתכתב איתם בצ'אט. השאר ריק כדי להשתמש בשם הפרטי שלך.",
    "Website visitors see this name when this user chats with them. Leave empty to use their first name.": "מבקרים באתר רואים את השם הזה כשהמשתמש מתכתב איתם בצ'אט. השאר ריק כדי להשתמש בשם הפרטי של המשתמש.",
    "This name cannot contain @": "השם לא יכול להכיל @",
    "This name is reserved. Choose another one.": "השם הזה שמור. בחר שם אחר.",
    "Allowed websites": "אתרים מורשים",
    "Only these websites can show the widget, one per line (example.com and www.example.com count as two). Leave empty to let any website show it.": "רק האתרים האלה יכולים להציג את הווידג'ט, אחד בכל שורה (example.com ו-www.example.com נחשבים לשני אתרים). השאר ריק כדי לאפשר לכל אתר להציג אותו.",
    "Enter a website address like https://example.com": "הכנס כתובת אתר כמו https://example.com",
    "Up to {count} websites": "עד {count} אתרים",
    "Privately held company": "חברה פרטית",
    "NYSE American (AMEX)": "NYSE American (AMEX)",
    "Euronext Amsterdam (AMX)": "Euronext Amsterdam (AMX)",
    "Gambling and Lottery": "הימורים והגרלות",
    "tax number": "מספר מס",
    "ZIP code": "מיקוד",
    "postal code": "מיקוד",
    "Postal Code": "מיקוד",
    "{field} must not exceed {count} characters": "{field} לא יכול לעלות על {count} תווים",
    "{field} must be at least {count} characters": "{field} חייב להכיל לפחות {count} תווים",
    "Your plan, or the one you're moving to, doesn't include WhatsApp. Update your plan to use it.": "התוכנית שלך, או התוכנית שאליה אתה עובר, לא כוללת WhatsApp. עדכן את התוכנית כדי להשתמש בו.",
    "This card was removed, so there's nothing to verify.": "הכרטיס הזה הוסר, ולכן אין מה לאמת.",
    "Enter both amounts.": "הזינו את שני הסכומים.",
    "Enter each amount in dollars with up to 2 decimals, for example 0.57.": "הזינו כל סכום בדולרים, עם עד 2 ספרות אחרי הנקודה, לדוגמה 0.57.",
    "Each hold is between $0.01 and $0.99. Enter it in dollars, for example 0.57.": "כל חסימה זמנית היא בין $0.01 ל-$0.99. הזינו אותה בדולרים, לדוגמה 0.57.",
    "Outside calls start once the account's card is verified": "שיחות יוצאות יתחילו לאחר אימות הכרטיס של החשבון",
    "Some features are unavailable. Your account admin needs to finish billing setup.": "חלק מהתכונות אינן זמינות. מנהל החשבון צריך להשלים את הגדרת החיוב.",
    "Invalid authorization amounts, please try again. You have {count} attempts left.": "סכומי החסימה שגויים, נסו שוב. נותרו לכם {count} ניסיונות.",
    "Invalid authorization amounts. You have 1 attempt left: a wrong answer removes this card.": "סכומי החסימה שגויים. נותר לכם ניסיון אחד: תשובה שגויה תסיר את הכרטיס.",
    "Partly saved": "נשמר חלקית",
    "This person still receives calls from {routes}. Change those first, then delete the invitation.": "אדם זה עדיין מקבל שיחות מאלה: {routes}. שנו אותם קודם, ואז מחקו את ההזמנה.",
    "Searching by UUID finds that call on any date, ignoring the other filters": "חיפוש לפי UUID מוצא את השיחה בכל תאריך, ומתעלם משאר המסננים",
    "SIP Call-ID": "SIP Call-ID"
}
